/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

/** What `claude mcp get <name>` answers. */
export enum YdistriDevsMcpStatus {
  NotConfigured = 'NotConfigured',
  NeedsAuthentication = 'NeedsAuthentication',
  Connected = 'Connected',
}
export enum ValidationProblemCode {
  Unspecified = 'Unspecified',
  ConfigurationRuleNoSetup = 'ConfigurationRule_NoSetup',
  ConfigurationRuleEmptySelection = 'ConfigurationRule_EmptySelection',
  ConfigurationRuleAllScopesAll = 'ConfigurationRule_AllScopesAll',
  ConfigurationRuleMainRuleMissingSetup = 'ConfigurationRule_MainRuleMissingSetup',
  ConfigurationRuleMainRuleNotUpdatable = 'ConfigurationRule_MainRuleNotUpdatable',
  ConfigurationRulePriorityOutOfRange = 'ConfigurationRule_PriorityOutOfRange',
  ConfigurationRuleBaseRuleSetupNotAllowed = 'ConfigurationRule_BaseRuleSetupNotAllowed',
  ConfigurationRuleNotFound = 'ConfigurationRule_NotFound',
  ConfigurationRuleStoresScopeRequired = 'ConfigurationRule_StoresScopeRequired',
  ConfigurationRuleStoreTypesScopeRequired = 'ConfigurationRule_StoreTypesScopeRequired',
  ConfigurationRuleDepartmentsScopeRequired = 'ConfigurationRule_DepartmentsScopeRequired',
  ConfigurationRuleUnknownEntity = 'ConfigurationRule_UnknownEntity',
  ConfigurationSetupValueOutOfRange = 'ConfigurationSetup_ValueOutOfRange',
  ConfigurationSetupInvalidValue = 'ConfigurationSetup_InvalidValue',
  ConfigurationValueOutOfRange = 'ConfigurationValue_OutOfRange',
  ConfigurationValueInvalidValue = 'ConfigurationValue_InvalidValue',
  StoresAndDepartmentsExceptionOutOfScope = 'StoresAndDepartments_ExceptionOutOfScope',
  StoresAndDepartmentsExceptionNoStores = 'StoresAndDepartments_ExceptionNoStores',
  StoresAndDepartmentsMissingEntities = 'StoresAndDepartments_MissingEntities',
  StoresAndDepartmentsNoEnabledSource = 'StoresAndDepartments_NoEnabledSource',
  StoresAndDepartmentsNoEnabledTarget = 'StoresAndDepartments_NoEnabledTarget',
  StoresAndDepartmentsInvalidExceptionShape = 'StoresAndDepartments_InvalidExceptionShape',
  StoresAndDepartmentsFlaggedStores = 'StoresAndDepartments_FlaggedStores',
  StoresAndDepartmentsFieldOverridden = 'StoresAndDepartments_FieldOverridden',
  CategoriesNoSource = 'Categories_NoSource',
  CategoriesNoTarget = 'Categories_NoTarget',
  CategoriesArchivedIntegrationList = 'Categories_ArchivedIntegrationList',
  CategoriesArchivedUserList = 'Categories_ArchivedUserList',
  CategoriesListTypeMismatch = 'Categories_ListTypeMismatch',
  CategoriesRowsRequired = 'Categories_RowsRequired',
  CategoriesFlagsRequired = 'Categories_FlagsRequired',
  CategoriesUnknownFlag = 'Categories_UnknownFlag',
  CategoriesDuplicateFlag = 'Categories_DuplicateFlag',
  CategoriesRowNull = 'Categories_RowNull',
  CategoriesValueRequired = 'Categories_ValueRequired',
  CategoriesUnknownField = 'Categories_UnknownField',
  CategoriesUnknownSkuType = 'Categories_UnknownSkuType',
  CategoriesDuplicateRow = 'Categories_DuplicateRow',
  CategoriesRootIncomplete = 'Categories_RootIncomplete',
  CategoriesUnknownRootRow = 'Categories_UnknownRootRow',
  CategoriesOverrideSlotInvalid = 'Categories_OverrideSlotInvalid',
  CategoriesRootOnlyField = 'Categories_RootOnlyField',
  CategoriesListNotOnRoot = 'Categories_ListNotOnRoot',
  CategoriesExclusionOutOfScope = 'Categories_ExclusionOutOfScope',
  CategoriesFlagRequiresOff = 'Categories_FlagRequiresOff',
  CategoriesFlagOffOverrides = 'Categories_FlagOffOverrides',
  CategoriesSkuTypeRowsIncomplete = 'Categories_SkuTypeRowsIncomplete',
  CategoriesDeadStockForecastFixed = 'Categories_DeadStockForecastFixed',
  CategoriesSkuTypeValuesDiffer = 'Categories_SkuTypeValuesDiffer',
  CategoriesNotInTemplateData = 'Categories_NotInTemplateData',
  CategoriesUnknownList = 'Categories_UnknownList',
  CategoriesListWithoutVersion = 'Categories_ListWithoutVersion',
  CategoriesGroupGuardOff = 'Categories_GroupGuardOff',
  CategoriesRequestListNotFound = 'Categories_RequestListNotFound',
  CategoriesRequestListInvalid = 'Categories_RequestListInvalid',
  CategoriesListVersionDataDeleted = 'Categories_ListVersionDataDeleted',
  RegionsEmptyGroup = 'Regions_EmptyGroup',
  RegionsNoGroups = 'Regions_NoGroups',
  RegionsGroupIdRequired = 'Regions_GroupIdRequired',
  RegionsGroupNotFound = 'Regions_GroupNotFound',
  RegionsGroupRegionsRequired = 'Regions_GroupRegionsRequired',
  RegionsRegionAlreadyInGroup = 'Regions_RegionAlreadyInGroup',
  RegionsRegionNotInGroup = 'Regions_RegionNotInGroup',
  RegionsGroupIdsRequired = 'Regions_GroupIdsRequired',
  RegionsFlowTypeRequired = 'Regions_FlowTypeRequired',
  RegionsGroupsRequired = 'Regions_GroupsRequired',
  RegionsGroupNull = 'Regions_GroupNull',
  RegionsDuplicateGroup = 'Regions_DuplicateGroup',
  RegionsUnknownRegion = 'Regions_UnknownRegion',
  RegionsRegionNotInTemplateData = 'Regions_RegionNotInTemplateData',
  RegionsDuplicateRegion = 'Regions_DuplicateRegion',
  RegionsCustomOnly = 'Regions_CustomOnly',
  SkuClassesNoneEnabled = 'SkuClasses_NoneEnabled',
  SkuClassesNoSource = 'SkuClasses_NoSource',
  SkuClassesNoTarget = 'SkuClasses_NoTarget',
  SkuClassesEnabledWithoutRole = 'SkuClasses_EnabledWithoutRole',
  SkuClassesRowNull = 'SkuClasses_RowNull',
  SkuClassesDuplicateRow = 'SkuClasses_DuplicateRow',
  SkuClassesUnknownRow = 'SkuClasses_UnknownRow',
  SkuClassesRowsMissing = 'SkuClasses_RowsMissing',
  SkuClassesRowsRequired = 'SkuClasses_RowsRequired',
  ProductListsNoneEnabled = 'ProductLists_NoneEnabled',
  ProductListsArchivedConfigured = 'ProductLists_ArchivedConfigured',
  ProductListsArchivedList = 'ProductLists_ArchivedList',
  ProductListsExceptionNull = 'ProductLists_ExceptionNull',
  ProductListsStoredTwice = 'ProductLists_StoredTwice',
  ProductListsDuplicateException = 'ProductLists_DuplicateException',
  ProductListsUnknownList = 'ProductLists_UnknownList',
  ProductListsExceptionsRequired = 'ProductLists_ExceptionsRequired',
  ProductListsListGone = 'ProductLists_ListGone',
  ProductListsVersionDataDeleted = 'ProductLists_VersionDataDeleted',
  BrandsNoneEnabled = 'Brands_NoneEnabled',
  BrandsUnknownBrand = 'Brands_UnknownBrand',
  BrandsNotInTemplateData = 'Brands_NotInTemplateData',
  BrandsExceptionsRequired = 'Brands_ExceptionsRequired',
  BrandsDuplicateException = 'Brands_DuplicateException',
  CalculationTitleRequired = 'Calculation_TitleRequired',
  CalculationTemplateRequired = 'Calculation_TemplateRequired',
  CalculationNoSubordinates = 'Calculation_NoSubordinates',
  CalculationSubmergedNotEditable = 'Calculation_SubmergedNotEditable',
  CalculationTypeNotCreatable = 'Calculation_TypeNotCreatable',
  CalculationIdRequired = 'Calculation_IdRequired',
  CalculationNotFound = 'Calculation_NotFound',
  CalculationTypeNotUpdatable = 'Calculation_TypeNotUpdatable',
  CalculationPrivateNotAllowed = 'Calculation_PrivateNotAllowed',
  CalculationSyncedToPap = 'Calculation_SyncedToPap',
  TemplateTitleRequired = 'Template_TitleRequired',
  CalculationCustomExportRunActive = 'Calculation_CustomExportRunActive',
  CalculationFinishExecutionRequired = 'Calculation_FinishExecutionRequired',
  CalculationFinishExecutionNotAllowed = 'Calculation_FinishExecutionNotAllowed',
  CalculationPickAndPackDisabled = 'Calculation_PickAndPackDisabled',
  CalculationPapExecutionDateInvalid = 'Calculation_PapExecutionDateInvalid',
  CalculationPapProgressInvalid = 'Calculation_PapProgressInvalid',
  CalculationPapPickingStarted = 'Calculation_PapPickingStarted',
  CalculationFinishExecutionNotChangeable = 'Calculation_FinishExecutionNotChangeable',
  CalculationPapAndFinishExecutionConflict = 'Calculation_PapAndFinishExecutionConflict',
  CalculationFinishExecutionInPast = 'Calculation_FinishExecutionInPast',
  CalculationNotDeletable = 'Calculation_NotDeletable',
  CalculationNotOwner = 'Calculation_NotOwner',
  CalculationCreationRefused = 'Calculation_CreationRefused',
  CalculationManualNotSupported = 'Calculation_ManualNotSupported',
  CalculationModeInvalid = 'Calculation_ModeInvalid',
  CalculationMergedTemplateNotAllowed = 'Calculation_MergedTemplateNotAllowed',
  CalculationOverlappingNull = 'Calculation_OverlappingNull',
  CalculationSubordinatesNotAllowed = 'Calculation_SubordinatesNotAllowed',
  CalculationSubordinateNull = 'Calculation_SubordinateNull',
  CalculationSubordinateModeInvalid = 'Calculation_SubordinateModeInvalid',
  TemplateIdRequired = 'Template_IdRequired',
  TemplateNotFound = 'Template_NotFound',
  TemplateLocked = 'Template_Locked',
  TemplateLastOne = 'Template_LastOne',
  TemplateStatusNotChangeable = 'Template_StatusNotChangeable',
  CalculationFamilyBusy = 'Calculation_FamilyBusy',
  CalculationProductionWhileEditing = 'Calculation_ProductionWhileEditing',
  CalculationRootTypeNotAllowed = 'Calculation_RootTypeNotAllowed',
  CalculationSubordinateOriginalNotAllowed = 'Calculation_SubordinateOriginalNotAllowed',
  CalculationSubordinateTemplateNotAllowed = 'Calculation_SubordinateTemplateNotAllowed',
  CalculationSubordinateOriginalRequired = 'Calculation_SubordinateOriginalRequired',
  CalculationTitleTooLong = 'Calculation_TitleTooLong',
  CalculationRecomputeNotAllowed = 'Calculation_RecomputeNotAllowed',
  CalculationRecomputeProduction = 'Calculation_RecomputeProduction',
  CalculationRecomputeInProgress = 'Calculation_RecomputeInProgress',
  CalculationEditNotAllowed = 'Calculation_EditNotAllowed',
  CalculationRedistributionNotEditable = 'Calculation_RedistributionNotEditable',
  CustomExportCalculationNotFound = 'CustomExport_CalculationNotFound',
  CustomExportCalculationSubmerged = 'CustomExport_CalculationSubmerged',
  CustomExportCalculationNotProduction = 'CustomExport_CalculationNotProduction',
  CustomExportInvalidType = 'CustomExport_InvalidType',
  CustomExportDisabled = 'CustomExport_Disabled',
  CustomExportActionNotAllowed = 'CustomExport_ActionNotAllowed',
  CustomExportCalculationRequired = 'CustomExport_CalculationRequired',
  CustomExportRunRequired = 'CustomExport_RunRequired',
  CustomExportStatusRequired = 'CustomExport_StatusRequired',
  CustomExportStatusNotPatchable = 'CustomExport_StatusNotPatchable',
  CustomExportItemsNotFinished = 'CustomExport_ItemsNotFinished',
  StoreScheduleStoreRequired = 'StoreSchedule_StoreRequired',
  StoreScheduleRestrictionRequired = 'StoreSchedule_RestrictionRequired',
  StoreSchedulePeriodEnded = 'StoreSchedule_PeriodEnded',
  StoreSchedulePeriodIncomplete = 'StoreSchedule_PeriodIncomplete',
  StoreSchedulePeriodReversed = 'StoreSchedule_PeriodReversed',
  StoreScheduleArchived = 'StoreSchedule_Archived',
  StoreScheduleNoteTooLong = 'StoreSchedule_NoteTooLong',
  StoreScheduleRecordNull = 'StoreSchedule_RecordNull',
  StoreScheduleDuplicateRecord = 'StoreSchedule_DuplicateRecord',
  StoreScheduleRecordsRequired = 'StoreSchedule_RecordsRequired',
  StoreScheduleNotInRegister = 'StoreSchedule_NotInRegister',
  StoreScheduleStoreChangeNotAllowed = 'StoreSchedule_StoreChangeNotAllowed',
  StoreScheduleStoreNotFound = 'StoreSchedule_StoreNotFound',
  EntityListNameTaken = 'EntityList_NameTaken',
  EntityListTypeRequired = 'EntityList_TypeRequired',
  EntityListNameRequired = 'EntityList_NameRequired',
  EntityListCustomerIdTaken = 'EntityList_CustomerIdTaken',
  EntityListTypeCombinationInvalid = 'EntityList_TypeCombinationInvalid',
  EntityListArchiveDateInPast = 'EntityList_ArchiveDateInPast',
  EntityListNotUserList = 'EntityList_NotUserList',
  EntityListArchived = 'EntityList_Archived',
  EntityListTypeChangeNotAllowed = 'EntityList_TypeChangeNotAllowed',
  EntityListImportOperationNotAllowed = 'EntityList_ImportOperationNotAllowed',
  EntityListImportValidationChanged = 'EntityList_ImportValidationChanged',
  EntityListMissingSkuHandlingRequired = 'EntityList_MissingSkuHandlingRequired',
  EntityListComputationConfirmationRequired = 'EntityList_ComputationConfirmationRequired',
  EntityListUnarchiveUnavailable = 'EntityList_UnarchiveUnavailable',
  EntityListImportStaged = 'EntityList_ImportStaged',
  EntityListDataDeleted = 'EntityList_DataDeleted',
  EntityListHeld = 'EntityList_Held',
  PasswordTooShort = 'Password_TooShort',
  PasswordTooWeak = 'Password_TooWeak',
  PasswordOldMismatch = 'Password_OldMismatch',
  TenantNameRequired = 'Tenant_NameRequired',
  TenantNameTooLong = 'Tenant_NameTooLong',
  ProjectTenantRequired = 'Project_TenantRequired',
  ProjectNameRequired = 'Project_NameRequired',
  ProjectShortNameRequired = 'Project_ShortNameRequired',
  ProjectDbNameRequired = 'Project_DbNameRequired',
  ProjectSqlServerRequired = 'Project_SqlServerRequired',
  ProjectSqlPoolRequired = 'Project_SqlPoolRequired',
  ProjectNotUnique = 'Project_NotUnique',
  ProjectStatusNotAllowed = 'Project_StatusNotAllowed',
  ProjectSqlServerNotInEnvironment = 'Project_SqlServerNotInEnvironment',
  ProjectSqlPoolNotInEnvironment = 'Project_SqlPoolNotInEnvironment',
  ProjectSqlPoolNotOnServer = 'Project_SqlPoolNotOnServer',
  ProjectIdRequired = 'Project_IdRequired',
  ProjectNotFound = 'Project_NotFound',
  ProjectTenantNotChangeable = 'Project_TenantNotChangeable',
  ProjectSqlServerNotChangeable = 'Project_SqlServerNotChangeable',
  ProjectSqlPoolNotChangeable = 'Project_SqlPoolNotChangeable',
  UserNameRequired = 'User_NameRequired',
  UserNameTooLong = 'User_NameTooLong',
  UserEmailRequired = 'User_EmailRequired',
  UserEmailInvalid = 'User_EmailInvalid',
  UserEmailTaken = 'User_EmailTaken',
  UserSuperUserDomainRequired = 'User_SuperUserDomainRequired',
  UserProjectRequired = 'User_ProjectRequired',
  UserSuperUserWithoutProjects = 'User_SuperUserWithoutProjects',
  UserAuthenticationMethodRequired = 'User_AuthenticationMethodRequired',
  UserAuthenticationMethodEmpty = 'User_AuthenticationMethodEmpty',
  UserAiCapabilityUndefined = 'User_AiCapabilityUndefined',
  ProductLookupIdentifierRequired = 'ProductLookup_IdentifierRequired',
  ProductLookupInvalidProductId = 'ProductLookup_InvalidProductId',
  RecordImportOperationNotAllowed = 'RecordImport_OperationNotAllowed',
  RecordImportNegativeQuantity = 'RecordImport_NegativeQuantity',
  RecordImportSameSourceAndTargetStore = 'RecordImport_SameSourceAndTargetStore',
  RecordImportSkuUsedAsSourceAndTarget = 'RecordImport_SkuUsedAsSourceAndTarget',
  RecordImportNotFound = 'RecordImport_NotFound',
  RecordImportCalculationRunning = 'RecordImport_CalculationRunning',
  RecordImportSourceOutsideSnapshot = 'RecordImport_SourceOutsideSnapshot',
  RecordImportIncrementRequiresCurrentSnapshot = 'RecordImport_IncrementRequiresCurrentSnapshot',
  ConfigurationDocumentVersionRequired = 'ConfigurationDocument_VersionRequired',
  ConfigurationDocumentRulesRequired = 'ConfigurationDocument_RulesRequired',
  ConfigurationDocumentRuleNull = 'ConfigurationDocument_RuleNull',
  ConfigurationDocumentPrioritiesNotContiguous = 'ConfigurationDocument_PrioritiesNotContiguous',
  ConfigurationDocumentDuplicateRuleId = 'ConfigurationDocument_DuplicateRuleId',
  ConfigurationDocumentMainRuleIdRequired = 'ConfigurationDocument_MainRuleIdRequired',
  ConfigurationDocumentNotTheMainRule = 'ConfigurationDocument_NotTheMainRule',
  ConfigurationDocumentForeignRule = 'ConfigurationDocument_ForeignRule',
  ConfigurationDocumentElementNull = 'ConfigurationDocument_ElementNull',
  ConfigurationDocumentDuplicateScopeType = 'ConfigurationDocument_DuplicateScopeType',
  ConfigurationDocumentEntityIdsRequired = 'ConfigurationDocument_EntityIdsRequired',
  ConfigurationDocumentDuplicateEntityId = 'ConfigurationDocument_DuplicateEntityId',
  ConfigurationDocumentDuplicateSetupType = 'ConfigurationDocument_DuplicateSetupType',
  ConfigurationDocumentSchedulesReadOnly = 'ConfigurationDocument_SchedulesReadOnly',
  ConfigurationDocumentOptOutsRequired = 'ConfigurationDocument_OptOutsRequired',
  ConfigurationDocumentEntityNotInTemplateData = 'ConfigurationDocument_EntityNotInTemplateData',
  ConfigurationDocumentUnknownStoreSchedule = 'ConfigurationDocument_UnknownStoreSchedule',
  CalculationStatisticsViewInvalid = 'CalculationStatistics_ViewInvalid',
  CalculationStatisticsArgumentNotForView = 'CalculationStatistics_ArgumentNotForView',
  CalculationStatisticsLimitOutOfRange = 'CalculationStatistics_LimitOutOfRange',
  CalculationStatisticsSortByNotForView = 'CalculationStatistics_SortByNotForView',
  CalculationStatisticsTooManyIds = 'CalculationStatistics_TooManyIds',
  CalculationStatisticsNotEvaluated = 'CalculationStatistics_NotEvaluated',
  ConversationIdRequired = 'Conversation_IdRequired',
  ConversationProjectRequired = 'Conversation_ProjectRequired',
  ConversationTitleTooLong = 'Conversation_TitleTooLong',
  ConversationPromptRequired = 'Conversation_PromptRequired',
  ConversationPromptTooLong = 'Conversation_PromptTooLong',
  ConversationTurnIdRequired = 'Conversation_TurnIdRequired',
  ConversationScreenUrlTooLong = 'Conversation_ScreenUrlTooLong',
  ConversationScreenRouteTooLong = 'Conversation_ScreenRouteTooLong',
  ConversationScreenParamsTooLarge = 'Conversation_ScreenParamsTooLarge',
  ConversationScreenTooLarge = 'Conversation_ScreenTooLarge',
  ConversationTitleRequired = 'Conversation_TitleRequired',
  ConfigurationCopyIncompatible = 'ConfigurationCopy_Incompatible',
  ConfigurationCopySourceStatusNotAllowed = 'ConfigurationCopy_SourceStatusNotAllowed',
  ConfigurationCopySourceNotComputed = 'ConfigurationCopy_SourceNotComputed',
  ConfigurationCopySourceHasNoConfiguration = 'ConfigurationCopy_SourceHasNoConfiguration',
  ConfigurationCopySameSourceAndTarget = 'ConfigurationCopy_SameSourceAndTarget',
  TemplateConfigurationSectionNull = 'TemplateConfiguration_SectionNull',
  TemplateConfigurationEnumAsNumber = 'TemplateConfiguration_EnumAsNumber',
  TemplateConfigurationUnknownSection = 'TemplateConfiguration_UnknownSection',
  TemplateConfigurationSectionNotAvailable = 'TemplateConfiguration_SectionNotAvailable',
  TemplateConfigurationSectionsRequired = 'TemplateConfiguration_SectionsRequired',
  CatalogUnknownKind = 'Catalog_UnknownKind',
  CatalogTooManyIds = 'Catalog_TooManyIds',
  CatalogParentOnlyForCategories = 'Catalog_ParentOnlyForCategories',
  CatalogParentAndSubtree = 'Catalog_ParentAndSubtree',
  CatalogIdsWithParent = 'Catalog_IdsWithParent',
  CatalogProductsNeedFilter = 'Catalog_ProductsNeedFilter',
  AdvancedConfigurationEnabledRequired = 'AdvancedConfiguration_EnabledRequired',
  AdvancedConfigurationValuesRequired = 'AdvancedConfiguration_ValuesRequired',
  AdvancedConfigurationRowNull = 'AdvancedConfiguration_RowNull',
  AdvancedConfigurationKeyRequired = 'AdvancedConfiguration_KeyRequired',
  AdvancedConfigurationVersionRowNotAValue = 'AdvancedConfiguration_VersionRowNotAValue',
  AdvancedConfigurationUnknownField = 'AdvancedConfiguration_UnknownField',
  AdvancedConfigurationItemSequenceRequired = 'AdvancedConfiguration_ItemSequenceRequired',
  AdvancedConfigurationValueRequired = 'AdvancedConfiguration_ValueRequired',
  AdvancedConfigurationFieldSetVersionReadOnly = 'AdvancedConfiguration_FieldSetVersionReadOnly',
  AdvancedConfigurationUnknownFieldSetVersion = 'AdvancedConfiguration_UnknownFieldSetVersion',
  AdvancedConfigurationRowsMissing = 'AdvancedConfiguration_RowsMissing',
  AdvancedConfigurationDuplicateRow = 'AdvancedConfiguration_DuplicateRow',
  AdvancedConfigurationUnknownRow = 'AdvancedConfiguration_UnknownRow',
  AdvancedConfigurationReadOnlyRowChanged = 'AdvancedConfiguration_ReadOnlyRowChanged',
  AdvancedConfigurationVersionRowRepeated = 'AdvancedConfiguration_VersionRowRepeated',
  AiPromptTitleRequired = 'AiPrompt_TitleRequired',
  AiPromptTitleTooLong = 'AiPrompt_TitleTooLong',
  AiPromptContentRequired = 'AiPrompt_ContentRequired',
  AiPromptContentTooLong = 'AiPrompt_ContentTooLong',
  AiPromptSuperUserOnlyNotAllowed = 'AiPrompt_SuperUserOnlyNotAllowed',
  AiPromptTitleTaken = 'AiPrompt_TitleTaken',
  RedistributionEditNoItems = 'RedistributionEdit_NoItems',
  RedistributionEditTooManyItems = 'RedistributionEdit_TooManyItems',
  RedistributionEditItemNull = 'RedistributionEdit_ItemNull',
  RedistributionEditDuplicateItem = 'RedistributionEdit_DuplicateItem',
  RedistributionEditItemMatchesNothing = 'RedistributionEdit_ItemMatchesNothing',
  RedistributionEditVersionChanged = 'RedistributionEdit_VersionChanged',
  RedistributionEditQuantityNegative = 'RedistributionEdit_QuantityNegative',
  RedistributionEditQuantityOfDeletedPair = 'RedistributionEdit_QuantityOfDeletedPair',
  RedistributionEditPairWithoutRow = 'RedistributionEdit_PairWithoutRow',
  RedistributionEditStockExceeded = 'RedistributionEdit_StockExceeded',
}
export enum ValidationArea {
  StoresAndDepartments = 'StoresAndDepartments',
  Categories = 'Categories',
  Regions = 'Regions',
  SkuClasses = 'SkuClasses',
  ProductLists = 'ProductLists',
  Brands = 'Brands',
}
export enum TransactionOverviewType {
  SaleRegular = 'SaleRegular',
  SalePromo = 'SalePromo',
  SaleSellout = 'SaleSellout',
  ForecastMin = 'ForecastMin',
  ForecastMax = 'ForecastMax',
  Inbound = 'Inbound',
  Outbound = 'Outbound',
}
export enum SuperTargetRedistributionType {
  ProductsInRedistribution = 'ProductsInRedistribution',
  SourceWarehousesInRedistribution = 'SourceWarehousesInRedistribution',
  AllWarehouses = 'AllWarehouses',
  DoNotUse = 'DoNotUse',
}
export enum StoreRankingStatus {
  Ranked = 'Ranked',
  ManuallyExcluded = 'ManuallyExcluded',
  AutoExcluded = 'AutoExcluded',
  ShortLived = 'ShortLived',
}
export enum StatisticType {
  Minimal = 'Minimal',
  Average = 'Average',
  Median = 'Median',
  Maximum = 'Maximum',
}
export enum SortDirection {
  Asc = 'Asc',
  Desc = 'Desc',
}
export enum SkuType {
  DeadStock = 'DeadStock',
  SlowMover = 'SlowMover',
  FastMover = 'FastMover',
}
export enum SkuRedistributionChangeType {
  RoutesRemoved = 'RoutesRemoved',
  SourceStoresRemoved = 'SourceStoresRemoved',
  TargetStoresRemoved = 'TargetStoresRemoved',
  ProductRemoved = 'ProductRemoved',
  PickingPositionsRemoved = 'PickingPositionsRemoved',
  PickingPositionUpdated = 'PickingPositionUpdated',
}
export enum SkuListConfigurationFlag {
  PsUseAllSkus = 'PsUseAllSkus',
  PtUseAllSkus = 'PtUseAllSkus',
}
export enum ScopeUsageType {
  AsoSource = 'AsoSource',
  AsoTarget = 'AsoTarget',
}
export enum ScopeSourceType {
  User = 'User',
  Integration = 'Integration',
}
export enum ScopeSectionRuleTypeName {
  Category = 'Category',
  Region = 'Region',
  StoreType = 'StoreType',
  Store = 'Store',
  Department = 'Department',
  SkuClass = 'SkuClass',
  Brand = 'Brand',
  EntityList = 'EntityList',
  Product = 'Product',
}
export enum ScopeSectionRuleModeName {
  Include = 'Include',
  Exclude = 'Exclude',
}
export enum RouteExecutionStatus {
  NotStarted = 'NotStarted',
  InProgress = 'InProgress',
  Finished = 'Finished',
}
export enum RegionFlowType {
  AllEnabled = 'AllEnabled',
  WithinRegion = 'WithinRegion',
  CustomRedistribution = 'CustomRedistribution',
}
export enum RecordImportAction {
  NotSet = 'NotSet',
  Skip = 'Skip',
  Insert = 'Insert',
  Update = 'Update',
  CreateSkuAndInsert = 'CreateSkuAndInsert',
  Duplicate = 'Duplicate',
  NoChange = 'NoChange',
  Delete = 'Delete',
}
export enum ProductListSourceType {
  Integration = 'Integration',
  Custom = 'Custom',
}
export enum ProductGroupTypeKey {
  Size = 'Size',
  SizeColor = 'Size|Color',
  SizeSet = 'Size|Set',
}
export enum ProductAttributeValueType {
  DateOfFirstSale = 'DateOfFirstSale',
  DateOfLastSale = 'DateOfLastSale',
  DateOfFirstPurchase = 'DateOfFirstPurchase',
  DateOfLastPurchase = 'DateOfLastPurchase',
  AvailableSupply = 'AvailableSupply',
  SaleQuantityTotal = 'SaleQuantityTotal',
  SaleValueTotal = 'SaleValueTotal',
  AvailableStockPriceValue = 'AvailableStockPriceValue',
  AvailableSalePriceValue = 'AvailableSalePriceValue',
  OpenPurchaseOrdersQuantity = 'OpenPurchaseOrdersQuantity',
  Frequency6Month = 'Frequency6Month',
  Frequency12Month = 'Frequency12Month',
  MonthlyRevenueQuantity = 'MonthlyRevenueQuantity',
  MonthlyRevenueSalePriceValue = 'MonthlyRevenueSalePriceValue',
  SkuCount = 'SkuCount',
}
export enum ProductActivityStatus {
  Unknown = 'Unknown',
  Active = 'Active',
  Inactive = 'Inactive',
}
export enum ProblemSeverity {
  Error = 'Error',
  Warning = 'Warning',
  Info = 'Info',
}
export enum PickingProgressStatus {
  Started = 'Started',
  Finished = 'Finished',
}
export enum ParameterType {
  Size = 'Size',
  Color = 'Color',
  Set = 'Set',
}
export enum PapSyncType {
  FullFromMainDbIntoPapDb = 'FullFromMainDbIntoPapDb',
  SingleCalculationFromMainDbIntoPapDb = 'SingleCalculationFromMainDbIntoPapDb',
  SingleCalculationFromMainDbDropFromPapDb = 'SingleCalculationFromMainDbDropFromPapDb',
  FullFromPapDbIntoPapApp = 'FullFromPapDbIntoPapApp',
  SingleRouteFromPapAppIntoPapDb = 'SingleRouteFromPapAppIntoPapDb',
  PictureFromPapDbIntoPapApp = 'PictureFromPapDbIntoPapApp',
  SingleCalculationFromPapAppIntoPapDb = 'SingleCalculationFromPapAppIntoPapDb',
  FullFromPapAppIntoPapDb = 'FullFromPapAppIntoPapDb',
  SingleCalculationFromPapDbIntoPapApp = 'SingleCalculationFromPapDbIntoPapApp',
  FillMasterDataFromMainDbIntoPapDb = 'FillMasterDataFromMainDbIntoPapDb',
  AdjustMasterDataInPapDb = 'AdjustMasterDataInPapDb',
  FillSingleCalculationFromMainDbIntoPapDb = 'FillSingleCalculationFromMainDbIntoPapDb',
  AdjustSingleCalculationInPapDb = 'AdjustSingleCalculationInPapDb',
}
export enum PapSyncStatus {
  NotSynced = 'NotSynced',
  Synced = 'Synced',
  Syncing = 'Syncing',
  Unsyncing = 'Unsyncing',
  SyncFailed = 'SyncFailed',
}
export enum PapRedistributionIssueType {
  NotFound = 'NotFound',
}
export enum PapProgressStatus {
  NotStarted = 'NotStarted',
  PickingStarted = 'PickingStarted',
  PickingDone = 'PickingDone',
  Finalized = 'Finalized',
}
export enum PapPackingPictureType {
  Contents = 'Contents',
  ContentsWithPackagingMaterial = 'ContentsWithPackagingMaterial',
  BoxWithLabelAndSeal = 'BoxWithLabelAndSeal',
}
export enum OverviewValueType {
  Quantity = 'Quantity',
  Value = 'Value',
}
export enum Operation {
  Eq = 'eq',
  Ne = 'ne',
  Gt = 'gt',
  Ge = 'ge',
  Lt = 'lt',
  Le = 'le',
  Contains = 'contains',
  Notcontains = 'notcontains',
  Startswith = 'startswith',
  Endswith = 'endswith',
  In = 'in',
  Notin = 'notin',
}
/**
 * Specifies how the entity list import finalisation should handle SKUs that are
 * either missing from the database (Ydistri.Services.Models.EntityLists.MissingSkuHandling.Ignore / Ydistri.Services.Models.EntityLists.MissingSkuHandling.AddAndEnable)
 * or exist but are currently disabled.
 * The value is required on the finalisation request whenever the import summary
 * reports at least one such problematic SKU; it may be omitted when none are present.
 */
export enum MissingSkuHandling {
  Ignore = 'Ignore',
  AddAndEnable = 'AddAndEnable',
}
export enum LogicalOperator {
  And = 'and',
  Or = 'or',
  Not = 'not',
}
export enum ForcingLevelType {
  NoIncrease = 'NoIncrease',
  SlightlyIncrease = 'SlightlyIncrease',
  SignificantlyIncrease = 'SignificantlyIncrease',
}
export enum ExecutionType {
  PickAndPack = 'PickAndPack',
  Integration = 'Integration',
  Heuristic = 'Heuristic',
}
export enum EntityListTypeName {
  MinLayer = 'MinLayer',
  Request = 'Request',
  Source = 'Source',
  Target = 'Target',
  Forced = 'Forced',
  ForcedToZero = 'ForcedToZero',
  Product = 'Product',
}
export enum EntityListSourceType {
  Integration = 'Integration',
  Computation = 'Computation',
  User = 'User',
}
export enum EntityListItemType {
  Sku = 'Sku',
  SkuQuantity = 'SkuQuantity',
  Product = 'Product',
}
export enum EntityListImportAction {
  NotSet = 'NotSet',
  Skip = 'Skip',
  Insert = 'Insert',
  Update = 'Update',
  CreateSkuAndInsert = 'CreateSkuAndInsert',
  Duplicate = 'Duplicate',
  NoChange = 'NoChange',
  Delete = 'Delete',
}
export enum EntityIdentificationType {
  Code = 'Code',
  CustomerId = 'CustomerId',
  YId = 'YId',
}
export enum DisplayEntityIdType {
  None = 'None',
  Code = 'Code',
  CustomerId = 'CustomerId',
}
export enum DataRetrievalStatus {
  Computing = 'Computing',
  Saving = 'Saving',
  Saved = 'Saved',
}
export enum CustomExportRunType {
  New = 'New',
  RetryErrors = 'RetryErrors',
  SkipErrors = 'SkipErrors',
}
export enum CustomExportRunStatus {
  New = 'New',
  Queued = 'Queued',
  Preparing = 'Preparing',
  Processing = 'Processing',
  Revoked = 'Revoked',
  Done = 'Done',
  DoneWithFailed = 'DoneWithFailed',
  Failed = 'Failed',
  FailedPreparing = 'FailedPreparing',
}
export enum CustomExportRunItemStatus {
  Preparing = 'Preparing',
  Processing = 'Processing',
  Done = 'Done',
  Failed = 'Failed',
}
export enum ConversationStatus {
  Idle = 'Idle',
  Running = 'Running',
  Failed = 'Failed',
}
export enum ConversationMessageRole {
  User = 'User',
  Assistant = 'Assistant',
}
export enum ConfigurationValueKind {
  Boolean = 'Boolean',
  Integer = 'Integer',
  Decimal = 'Decimal',
}
export enum ConfigurationStatus {
  RefreshPotential = 'RefreshPotential',
}
export enum ConfigurationSectionType {
  General = 'General',
  PotentialSource = 'PotentialSource',
  PotentialSourceStandardSubsection = 'PotentialSourceStandardSubsection',
  PotentialSourceForcedSubsection = 'PotentialSourceForcedSubsection',
  PotentialTarget = 'PotentialTarget',
}
export enum ConfigurationRuleSetupType {
  IsEnabled = 'IsEnabled',
  UseAsSource = 'UseAsSource',
  UseAsTarget = 'UseAsTarget',
  MaxNumberOfSourceStores = 'MaxNumberOfSourceStores',
  MaxNumberOfTargetStores = 'MaxNumberOfTargetStores',
  MaxNumberOfSourcePickingPositions = 'MaxNumberOfSourcePickingPositions',
  MinimumRouteValue = 'MinimumRouteValue',
}
export enum ConfigurationRuleScopeMode {
  All = 'All',
  Specified = 'Specified',
  AllExcept = 'AllExcept',
}
export enum ConfigurationRuleScopeEntityType {
  Regions = 'Regions',
  Stores = 'Stores',
  StoreTypes = 'StoreTypes',
  Departments = 'Departments',
}
export enum ConfigurationFieldType {
  CatDeadStock = 'CatDeadStock',
  CatSlowMoverMonths = 'CatSlowMoverMonths',
  CatSlowMoverSales = 'CatSlowMoverSales',
  PsMonthsFromFirstPurchase = 'PsMonthsFromFirstPurchase',
  PsMonthsFromLastPurchase = 'PsMonthsFromLastPurchase',
  PsMinRowValue = 'PsMinRowValue',
  PsMonthsOfSupplyToKeep = 'PsMonthsOfSupplyToKeep',
  PsMaxForecastConfidence = 'PsMaxForecastConfidence',
  PtMonthsOfSupplyToGetByForecast = 'PtMonthsOfSupplyToGetByForecast',
  PtMinForecastConfidence = 'PtMinForecastConfidence',
  PtMinimal6MonthsFrequencyOfSales = 'PtMinimal6MonthsFrequencyOfSales',
  PtAddOpenPurchaseOrdersToAvailableSupply = 'PtAddOpenPurchaseOrdersToAvailableSupply',
  PtTargetStockoutsOnly = 'PtTargetStockoutsOnly',
  PtForcingLevelTypeId = 'PtForcingLevelTypeId',
  PsMinLayerList = 'PsMinLayerList',
  PtMinLayerList = 'PtMinLayerList',
  PtRequestList = 'PtRequestList',
  PsMinProductPurchasePrice = 'PsMinProductPurchasePrice',
  PsSkuScope = 'PsSkuScope',
  PsSkuScopeForced = 'PsSkuScopeForced',
  PsUseAllSkus = 'PsUseAllSkus',
  PtSkuScope = 'PtSkuScope',
  PtUseAllSkus = 'PtUseAllSkus',
  PsMonthsFromLastPurchaseForced = 'PsMonthsFromLastPurchaseForced',
  PsMinProductPurchasePriceForced = 'PsMinProductPurchasePriceForced',
  PsSkuScopeExclusion = 'PsSkuScopeExclusion',
  PtSkuScopeExclusion = 'PtSkuScopeExclusion',
  PsSkuScopeForcedExclusion = 'PsSkuScopeForcedExclusion',
  CatEnableCategory = 'CatEnableCategory',
  PsUseStrictSets = 'PsUseStrictSets',
  PsUseMinCostUnitPriceForSets = 'PsUseMinCostUnitPriceForSets',
  PsMinCostUnitPriceForSets = 'PsMinCostUnitPriceForSets',
  PsUseSmartSets = 'PsUseSmartSets',
  PsUseMinRedistributionQuantity = 'PsUseMinRedistributionQuantity',
  PsAllowBreakSetsMinQuantitiesWhenGoingToZero = 'PsAllowBreakSetsMinQuantitiesWhenGoingToZero',
  PsUseStrictSetsForced = 'PsUseStrictSetsForced',
  PsUseMinCostUnitPriceForSetsForced = 'PsUseMinCostUnitPriceForSetsForced',
  PsMinCostUnitPriceForSetsForced = 'PsMinCostUnitPriceForSetsForced',
  PsUseSmartSetsForced = 'PsUseSmartSetsForced',
  PsUseMinRedistributionQuantityForced = 'PsUseMinRedistributionQuantityForced',
  PsAllowBreakSetsMinQuantitiesWhenGoingToZeroForced = 'PsAllowBreakSetsMinQuantitiesWhenGoingToZeroForced',
  PsUseHfmq = 'PsUseHfmq',
  PsHfmqPairs = 'PsHfmqPairs',
  PsUseHfmqForced = 'PsUseHfmqForced',
  PsHfmqPairsForced = 'PsHfmqPairsForced',
}
/** Which table a specification row belongs to; the key is that table's enum member name. */
export enum ConfigurationFieldOwner {
  ConfigurationRuleSetup = 'ConfigurationRuleSetup',
  CategoryField = 'CategoryField',
  ExperimentalConfiguration = 'ExperimentalConfiguration',
}
export enum ConfigurationDataType {
  InputNumber = 'InputNumber',
  CheckBox = 'CheckBox',
  SelectBoxForecastConfidence = 'SelectBoxForecastConfidence',
  SelectBoxMonthIdentifySkuType = 'SelectBoxMonthIdentifySkuType',
  SelectBoxMonthsForForecast = 'SelectBoxMonthsForForecast',
  SelectBoxForcingLevelType = 'SelectBoxForcingLevelType',
  SelectBoxMinLayerList = 'SelectBoxMinLayerList',
  SelectBoxRequestList = 'SelectBoxRequestList',
  SelectBoxTargetList = 'SelectBoxTargetList',
  SelectBoxSourceList = 'SelectBoxSourceList',
  SelectBoxForcedList = 'SelectBoxForcedList',
  SkuScopeExclusion = 'SkuScopeExclusion',
  HfmqPairs = 'HfmqPairs',
}
export enum ComponentType {
  Php = 'Php',
  CSharp = 'CSharp',
  IntegrationFramework = 'IntegrationFramework',
}
export enum CompareType {
  Missing = 'Missing',
  Contains = 'Contains',
  Updated = 'Updated',
}
export enum CommandType {
  ComputePotential = 'ComputePotential',
  NewCalculation = 'NewCalculation',
  DeleteCalculation = 'DeleteCalculation',
  RecomputeAttributes = 'RecomputeAttributes',
  RecomputeExecutionRates = 'RecomputeExecutionRates',
  SyncSkuOverlaps = 'SyncSkuOverlaps',
  SyncPapCalculation = 'SyncPapCalculation',
  UnsyncPapCalculation = 'UnsyncPapCalculation',
  PostComputeParing = 'PostComputeParing',
  ImportAndPostComputeParing = 'ImportAndPostComputeParing',
  ImportEntityList = 'ImportEntityList',
  RunCustomExport = 'RunCustomExport',
  ImportAndRecomputeAttributesAndPostComputePairing = 'ImportAndRecomputeAttributesAndPostComputePairing',
  ComputeAso = 'ComputeAso',
  FinalizeEntityListImport = 'FinalizeEntityListImport',
  SyncEntityListVersion = 'SyncEntityListVersion',
  SkuIncrement = 'SkuIncrement',
  SkuIncrementAndPairingAndExport = 'SkuIncrementAndPairingAndExport',
  MergedCalculation = 'MergedCalculation',
}
export enum CommandQueueStatus {
  Pending = 'Pending',
  Queued = 'Queued',
  Running = 'Running',
  Done = 'Done',
  Crashed = 'Crashed',
  Deleting = 'Deleting',
  ToBeQueued = 'ToBeQueued',
}
export enum CategoryWarehouseOverviewType {
  TotalSupply = 'TotalSupply',
  AvgMonthlySale = 'AvgMonthlySale',
  AvgMonthlySaleForStockout = 'AvgMonthlySaleForStockout',
  Margin = 'Margin',
  SkuCount = 'SkuCount',
  SkuCountInStockout = 'SkuCountInStockout',
  TotalPotentialSource = 'TotalPotentialSource',
  TotalPotentialTarget = 'TotalPotentialTarget',
}
export enum CategorySummaryType {
  EligibleAvailableSupplyValue = 'EligibleAvailableSupplyValue',
  EligibleSourceSkuCount = 'EligibleSourceSkuCount',
  EligibleSourceSupplyValue = 'EligibleSourceSupplyValue',
  EligibleTargetSkuCount = 'EligibleTargetSkuCount',
  TargetSupplyForTheoreticalPotentialValue = 'TargetSupplyForTheoreticalPotentialValue',
  OpenPurchaseOrdersForTheoreticalPotentialValue = 'OpenPurchaseOrdersForTheoreticalPotentialValue',
  IncomingForTheoreticalPotentialValue = 'IncomingForTheoreticalPotentialValue',
  EligibleMonthlyRevenue = 'EligibleMonthlyRevenue',
  EligibleMargin = 'EligibleMargin',
  ForcedValue = 'ForcedValue',
  HealthyValue = 'HealthyValue',
  OutgoingValue = 'OutgoingValue',
  ExcessiveBlockedByMinLayersValue = 'ExcessiveBlockedByMinLayersValue',
  ExcessiveBlockedByFirstPurchaseDateValue = 'ExcessiveBlockedByFirstPurchaseDateValue',
  ExcessiveBlockedByLastPurchaseDateValue = 'ExcessiveBlockedByLastPurchaseDateValue',
  ExcessiveBlockedByMinValue = 'ExcessiveBlockedByMinValue',
  ExcessiveBlockedByMinProductPurchasePrice = 'ExcessiveBlockedByMinProductPurchasePrice',
  ExcessiveBlockedByForecastValue = 'ExcessiveBlockedByForecastValue',
  ExcessiveBlockedByMinimalQuantityValue = 'ExcessiveBlockedByMinimalQuantityValue',
  ExcessiveBlockedByMinimalSetValue = 'ExcessiveBlockedByMinimalSetValue',
  ExcessivePotentialTotalValue = 'ExcessivePotentialTotalValue',
  ExcessivePotentialNotAddressableValue = 'ExcessivePotentialNotAddressableValue',
  TheoreticalPotentialValue = 'TheoreticalPotentialValue',
  TheoreticalPotentialStockoutValue = 'TheoreticalPotentialStockoutValue',
  TargetPotentialOverreachingSourceValue = 'TargetPotentialOverreachingSourceValue',
  TargetPotentialUnfulfilledWithAnySourceValue = 'TargetPotentialUnfulfilledWithAnySourceValue',
  TargetPotentialEndorsedByForecastValue = 'TargetPotentialEndorsedByForecastValue',
  TargetPotentialEndorsedByMinimalLayersValue = 'TargetPotentialEndorsedByMinimalLayersValue',
  TargetPotentialEndorsedByTargetListsValue = 'TargetPotentialEndorsedByTargetListsValue',
  ExcessiveBlockedByHfmqValue = 'ExcessiveBlockedByHfmqValue',
}
export enum CategoryRedistributionType {
  SourceStandardValue = 'SourceStandardValue',
  SourceForcedValue = 'SourceForcedValue',
  TargetForecastValue = 'TargetForecastValue',
  TargetMinLayersValue = 'TargetMinLayersValue',
  TargetTargetListValue = 'TargetTargetListValue',
  TargetOthersValue = 'TargetOthersValue',
  SendToStockoutValue = 'SendToStockoutValue',
}
export enum CategoryAttributeValueType {
  TotalSkuCount = 'TotalSkuCount',
  EnabledSkuCount = 'EnabledSkuCount',
  AvailableSupplyValue = 'AvailableSupplyValue',
  MonthlyRevenueSalePriceValue = 'MonthlyRevenueSalePriceValue',
  AnnualRevenueSalePriceValue = 'AnnualRevenueSalePriceValue',
  Margin = 'Margin',
}
export enum CalculationType {
  Template = 'Template',
  Private = 'Private',
  Simulation = 'Simulation',
  Production = 'Production',
  Submerged = 'Submerged',
}
export enum CalculationStatus {
  Pending = 'Pending',
  Queued = 'Queued',
  Running = 'Running',
  Completed = 'Completed',
  Crashed = 'Crashed',
  SoftDeleted = 'SoftDeleted',
  ToBeQueued = 'ToBeQueued',
  Outdated = 'Outdated',
  Editing = 'Editing',
}
export enum CalculationStatisticClusterType {
  Store = 'Store',
  StoreDepartment = 'StoreDepartment',
}
export enum CalculationMode {
  Computed = 'Computed',
  Manual = 'Manual',
  Merged = 'Merged',
}
export enum CalculationFlag {
  Initial = 'Initial',
  PreComputePotentialFinished = 'PreComputePotentialFinished',
  PreComputePotentialCrashed = 'PreComputePotentialCrashed',
  ImportSkuPotentialFinished = 'ImportSkuPotentialFinished',
  ImportSkuPotentialCrashed = 'ImportSkuPotentialCrashed',
  PreComputePotentialRequested = 'PreComputePotentialRequested',
  ImportSkuPotentialDebugFinished = 'ImportSkuPotentialDebugFinished',
  ImportSkuPotentialDebugCrashed = 'ImportSkuPotentialDebugCrashed',
}
export enum CalculationFileType {
  PairingXlsx = 'PairingXlsx',
  PairingSpecific = 'PairingSpecific',
}
export enum CalculationConfigurationExperimentalType {
  ExperimentalConfigurationVersion = 'ExperimentalConfigurationVersion',
  HfmqIsEnabled = 'Hfmq_IsEnabled',
  HfmqMaximal = 'Hfmq_Maximal',
  HfmqMinPercentageOfTotalSupply = 'Hfmq_MinPercentageOfTotalSupply',
  HfmqPriceUpTo = 'Hfmq_PriceUpTo',
  SourceBufferIsEnabled = 'SourceBuffer_IsEnabled',
  SourceBufferSkuTypeDeadStockIsEnabled = 'SourceBuffer_SkuTypeDeadStockIsEnabled',
  SourceBufferSkuTypeSlowMoverIsEnabled = 'SourceBuffer_SkuTypeSlowMoverIsEnabled',
  SourceBufferSkuTypeFastMoverIsEnabled = 'SourceBuffer_SkuTypeFastMoverIsEnabled',
  SourceBufferOutlook = 'SourceBuffer_Outlook',
  SourceBufferSeasonalProtection = 'SourceBuffer_SeasonalProtection',
  TargetUrgentIsEnabled = 'TargetUrgent_IsEnabled',
  TargetUrgentOutlook = 'TargetUrgent_Outlook',
  SourceUrgentIsEnabled = 'SourceUrgent_IsEnabled',
  SourceUrgentSkuTypeDeadStockIsEnabled = 'SourceUrgent_SkuTypeDeadStockIsEnabled',
  SourceUrgentSkuTypeSlowMoverIsEnabled = 'SourceUrgent_SkuTypeSlowMoverIsEnabled',
  SourceUrgentSkuTypeFastMoverIsEnabled = 'SourceUrgent_SkuTypeFastMoverIsEnabled',
  SourceUrgentOutlook = 'SourceUrgent_Outlook',
  TargetBufferIsEnabled = 'TargetBuffer_IsEnabled',
  TargetBufferOutlook = 'TargetBuffer_Outlook',
  IsBalancingEnabled = 'IsBalancingEnabled',
  HfmqCeiling = 'HfmqCeiling',
  HfmqIntervalPriceUpTo = 'HfmqInterval_PriceUpTo',
  HfmqIntervalMinPercentageOfTotalSupply = 'HfmqInterval_MinPercentageOfTotalSupply',
  UseSourceBufferForFastMovers = 'UseSourceBufferForFastMovers',
  AverageSourceNonBufferForecastBoostPercentage = 'AverageSourceNonBufferForecastBoostPercentage',
  SourceBufferForecastConfigurationMonthsOfSupply = 'SourceBufferForecastConfiguration_MonthsOfSupply',
  SourceBufferForecastConfigurationMaxMonthsUseAsBuffer = 'SourceBufferForecastConfiguration_MaxMonthsUseAsBuffer',
  TargetBufferForecastConfigurationMonthsToSellout = 'TargetBufferForecastConfiguration_MonthsToSellout',
  TargetBufferForecastConfigurationMonthUseAsBuffer = 'TargetBufferForecastConfiguration_MonthUseAsBuffer',
}
export enum AuthenticationMethod {
  Password = 'password',
  Microsoft = 'microsoft',
}
export enum AttributeDefinitionType {
  DateOfFirstSale = 'DateOfFirstSale',
  DateOfLastSale = 'DateOfLastSale',
  DateOfFirstPurchase = 'DateOfFirstPurchase',
  DateOfLastPurchase = 'DateOfLastPurchase',
  AvailableSupply = 'AvailableSupply',
  StockPrice = 'StockPrice',
  SalePrice = 'SalePrice',
  OpenPurchaseOrdersQuantity = 'OpenPurchaseOrdersQuantity',
  Frequency6Month = 'Frequency6Month',
  Frequency12Month = 'Frequency12Month',
  Vat = 'Vat',
  SaleQuantityTotal = 'SaleQuantityTotal',
  SaleValueTotal = 'SaleValueTotal',
  MonthlyRevenueQuantity = 'MonthlyRevenueQuantity',
  MonthlyRevenueSalePriceValue = 'MonthlyRevenueSalePriceValue',
  MonthlyRevenueStockPriceValue = 'MonthlyRevenueStockPriceValue',
  AnnualRevenueQuantity = 'AnnualRevenueQuantity',
  AnnualRevenueStockPriceValue = 'AnnualRevenueStockPriceValue',
  AnnualRevenueSalePriceValue = 'AnnualRevenueSalePriceValue',
  AttributeValueId = 'AttributeValueId',
  CategoryId = 'CategoryId',
  ProductId = 'ProductId',
  RegionId = 'RegionId',
  WarehouseId = 'WarehouseId',
  SkuClassId = 'SkuClassId',
  MinimalQuantityForRedistribution = 'MinimalQuantityForRedistribution',
  MinimalSetForRedistribution = 'MinimalSetForRedistribution',
  IsEnabled = 'IsEnabled',
  IsDefaultTarget = 'IsDefaultTarget',
  SkuDescriptionId = 'SkuDescriptionId',
  StoreDecile = 'StoreDecile',
  BrandQuintile = 'BrandQuintile',
}
export enum AsoScenarioUseSets {
  DontUse = 'DontUse',
  MinSetsFromData = 'MinSetsFromData',
  HumanFeasibleMinSets = 'HumanFeasibleMinSets',
  Both = 'Both',
}
export enum AsoScenarioStoreTierType {
  Default = 'Default',
  Tier1 = 'Tier1',
  Tier2 = 'Tier2',
  Tier3 = 'Tier3',
}
export enum AsoScenarioStatus {
  Pending = 'Pending',
  Queued = 'Queued',
  Running = 'Running',
  Completed = 'Completed',
  Crashed = 'Crashed',
  Outdated = 'Outdated',
}
export enum AsoScenarioSpecialPeriodMode {
  None = 'None',
  Months = 'Months',
  Range = 'Range',
}
export enum AsoScenarioMinLayerType {
  Source = 'Source',
  Target = 'Target',
}
export enum AsoScenarioComputeMode {
  Routes = 'Routes',
  Layers = 'Layers',
}
export enum AsoScenarioAdditionalOneStepAdjustment {
  None = 'None',
  MaxPickingPositionsForOneSku = 'MaxPickingPositionsForOneSku',
  UseSetAsMaxQuantityForOneStep = 'UseSetAsMaxQuantityForOneStep',
}
export enum ApplicationStatus {
  Closed = 'Closed',
  Opened = 'Opened',
}
export enum ApplicationSettingsType {
  FrontendVersion = 'FrontendVersion',
  FrontendStatus = 'FrontendStatus',
}
export enum ApplicationHintType {
  CategoryConfigurationDefinitionDescription = 'CategoryConfigurationDefinition.Description',
  CategoryConfigurationDefinitionTitle = 'CategoryConfigurationDefinition.Title',
}
export enum AppMcpStatus {
  Unavailable = 'Unavailable',
  Available = 'Available',
}
export enum ApiOperationType {
  Create = 'Create',
  Replace = 'Replace',
  Patch = 'Patch',
  Delete = 'Delete',
  Read = 'Read',
}
export enum ApiAction {
  DeleteSingleCategoryDeviations = 'DeleteSingleCategoryDeviations',
  DeleteSubordinateCategoryDeviations = 'DeleteSubordinateCategoryDeviations',
  LoadConfigurationsFromCalculation = 'LoadConfigurationsFromCalculation',
}
export interface AiPromptCreateRequest {
  title?: string | null;
  content?: string | null;
  isSuperUserOnly?: boolean | null;
}
export interface AiPromptResponse {
  /** @format int32 */
  aiPromptId: number;
  /** @format int32 */
  currentVersionNumber: number;
  isSuperUserOnly?: boolean | null;
  versions: AiPromptVersionResponse[];
}
export interface AiPromptResponseDataResponse {
  messages?: string[] | null;
  data: AiPromptResponse;
}
export interface AiPromptSaveRequest {
  title?: string | null;
  content?: string | null;
  isSuperUserOnly?: boolean | null;
}
export interface AiPromptSummaryResponse {
  /** @format int32 */
  aiPromptId: number;
  /** @format int32 */
  versionNumber: number;
  title: string;
  /** @format date-time */
  createdAt: string;
  createdByIdentityUserId: string;
  createdBy?: UserResponse | null;
  isSuperUserOnly?: boolean | null;
}
export interface AiPromptSummaryResponseCollectionResponse {
  messages?: string[] | null;
  data: AiPromptSummaryResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface AiPromptVersionResponse {
  /** @format int32 */
  versionNumber: number;
  title: string;
  content: string;
  /** @format date-time */
  createdAt: string;
  createdByIdentityUserId: string;
  createdBy?: UserResponse | null;
}
export interface AiPromptWriteResult {
  /** @format int32 */
  aiPromptId: number;
  /** @format int32 */
  versionNumber: number;
}
export interface AiPromptWriteResultDataResponse {
  messages?: string[] | null;
  data: AiPromptWriteResult;
}
export interface AppMcpStatusResponse {
  status: AppMcpStatus;
}
export interface AppMcpStatusResponseDataResponse {
  messages?: string[] | null;
  data: AppMcpStatusResponse;
}
export interface ApplicationConfigurationResponse {
  /** @format date */
  applicationDate: string | null;
  /** @format date */
  lastTransactionDate: string | null;
  /** @format int32 */
  finishExecutionWithinDays: number;
  mdbProductIdAutoIncrement: string;
  mdbWarehouseIdAutoIncrement: string;
  isPickAndPackEnabled: boolean;
  isCustomExportEnabled: boolean;
  displayProductId: DisplayEntityIdType;
  displayStoreId: DisplayEntityIdType;
  isSkuAvailableSupplyEnabled: boolean;
  isProductGroupsEnabled: boolean;
  isAutoGenerated1MUMinLayerEnabled: boolean;
  isEvaluationDeliveryEnabled: boolean;
}
export interface ApplicationConfigurationResponseDataResponse {
  messages?: string[] | null;
  data: ApplicationConfigurationResponse;
}
export interface ApplicationDataResponse {
  applicationDataType: string;
  isAvailable: boolean;
}
export interface ApplicationDataResponseCollectionResponse {
  messages?: string[] | null;
  data: ApplicationDataResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface ApplicationSettings {
  type: ApplicationSettingsType;
  value: string;
}
export interface ApplicationSettingsCollectionResponse {
  messages?: string[] | null;
  data: ApplicationSettings[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface AsoRequest {
  /** @format int32 */
  asoRequestId: number;
  name: string;
  asos: AsoScenario[];
}
export interface AsoRequestCreateRequest {
  name: string;
}
export interface AsoRequestResponse {
  /** @format int32 */
  id: number;
  name: string;
}
export interface AsoRequestResponseCollectionResponse {
  messages?: string[] | null;
  data: AsoRequestResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface AsoRequestResponseDataResponse {
  messages?: string[] | null;
  data: AsoRequestResponse;
}
export interface AsoRequestUpdateRequest {
  name: string;
}
export interface AsoRequestUpdateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: AsoRequestUpdateRequest | null;
}
export interface AsoRequestUsageSummaryResponse {
  /** @format int32 */
  id: number;
  name: string;
}
export interface AsoScenario {
  /** @format int32 */
  asoScenarioId: number;
  /** @format int32 */
  asoRequestId: number;
  name: string;
  status: AsoScenarioStatus;
  asoRequest: AsoRequest;
  asoScenarioConfiguration: AsoScenarioConfiguration;
  asoScenarioStoreTierSetting: AsoScenarioStoreTierSetting;
  asoScopes: AsoScenarioScope[];
  asoMinLayers: AsoScenarioMinLayer[];
  asoStoreTiers: AsoScenarioStoreTier[];
  asoScenarioStoreTierConfigurations: AsoScenarioStoreTierConfiguration[];
  asoComputes: AsoScenarioCompute[];
}
export interface AsoScenarioCompute {
  /** @format int32 */
  asoScenarioComputeId: number;
  /** @format int32 */
  asoScenarioId: number;
  asoScenarioComputeModeId: AsoScenarioComputeMode;
  status: AsoScenarioStatus;
  /** @format int32 */
  calculationId?: number | null;
  /** @format int32 */
  entityListId?: number | null;
  isNew: boolean;
  /** @format date-time */
  createdAt: string;
  asoScenario: AsoScenario;
  calculation?: Calculation | null;
  entityList?: EntityList | null;
}
export interface AsoScenarioConfiguration {
  /** @format int32 */
  asoScenarioId: number;
  useMinRedistributionQuantity: boolean;
  useSets: AsoScenarioUseSets;
  additionalOneStepAdjustment: AsoScenarioAdditionalOneStepAdjustment;
  /** @format int32 */
  supplyPreferenceModifier1Supply?: number | null;
  /** @format double */
  supplyPreferenceModifier1Modifier?: number | null;
  /** @format int32 */
  supplyPreferenceModifier2Supply?: number | null;
  /** @format double */
  supplyPreferenceModifier2Modifier?: number | null;
  /** @format int32 */
  supplyPreferenceModifier3Supply?: number | null;
  /** @format double */
  supplyPreferenceModifier3Modifier?: number | null;
  ignoreMinRedistributionQtyAndSetWhenDepletingToZero: boolean;
  specialPeriodMode: AsoScenarioSpecialPeriodMode;
  /** @format int32 */
  specialPeriodMonths?: number | null;
  /** @format date */
  specialPeriodFrom?: string | null;
  /** @format date */
  specialPeriodTo?: string | null;
  /** @format double */
  specialPeriodWeight: number;
  /** @format double */
  routeValueToMerge?: number | null;
  /** @format double */
  routeValueToRemove?: number | null;
  /** @format double */
  preferExistingRoute: number;
  /** @format double */
  preferExistingPickingPosition: number;
  /** @format int32 */
  maxRouteCount?: number | null;
  /** @format int32 */
  maxPickingPositionsForOneSku?: number | null;
  asoScenario: AsoScenario;
}
export interface AsoScenarioConfigurationDataResponse {
  messages?: string[] | null;
  data: AsoScenarioConfiguration;
}
export interface AsoScenarioConfigurationPatchRequest {
  useMinRedistributionQuantity?: boolean | null;
  useSets?: AsoScenarioUseSets | null;
  additionalOneStepAdjustment?: AsoScenarioAdditionalOneStepAdjustment | null;
  breakSets?: boolean | null;
  /** @format int32 */
  supplyPreferenceModifier1Supply?: number | null;
  /** @format double */
  supplyPreferenceModifier1Modifier?: number | null;
  /** @format int32 */
  supplyPreferenceModifier2Supply?: number | null;
  /** @format double */
  supplyPreferenceModifier2Modifier?: number | null;
  /** @format int32 */
  supplyPreferenceModifier3Supply?: number | null;
  /** @format double */
  supplyPreferenceModifier3Modifier?: number | null;
  ignoreMinRedistributionQtyAndSetWhenDepletingToZero?: boolean | null;
  specialPeriodMode?: AsoScenarioSpecialPeriodMode | null;
  /** @format int32 */
  specialPeriodMonths?: number | null;
  /** @format date */
  specialPeriodFrom?: string | null;
  /** @format date */
  specialPeriodTo?: string | null;
  /** @format double */
  specialPeriodWeight?: number | null;
  /** @format double */
  routeValueToMerge?: number | null;
  /** @format double */
  routeValueToRemove?: number | null;
  /** @format double */
  preferExistingRoute?: number | null;
  /** @format double */
  preferExistingPickingPosition?: number | null;
  /** @format int32 */
  maxRouteCount?: number | null;
  /** @format int32 */
  maxPickingPositionsForOneSku?: number | null;
}
export interface AsoScenarioConfigurationPatchRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: AsoScenarioConfigurationPatchRequest | null;
}
export interface AsoScenarioCreateRequest {
  name: string;
  /** @format int32 */
  asoRequestId: number;
}
export interface AsoScenarioMinLayer {
  /** @format int32 */
  asoMinLayerId: number;
  /** @format int32 */
  asoScenarioId: number;
  asoScenarioMinLayerTypeId: AsoScenarioMinLayerType;
  /** @format int32 */
  scopeId?: number | null;
  listIdsJson?: string | null;
  asoScenario: AsoScenario;
}
export interface AsoScenarioMinLayerCreateRequest {
  asoScenarioMinLayerTypeId: AsoScenarioMinLayerType;
}
export interface AsoScenarioMinLayerResponse {
  /** @format int32 */
  id: number;
  asoScenarioMinLayerTypeId: AsoScenarioMinLayerType;
  /** @format int32 */
  scopeId?: number | null;
  listIds: number[];
}
export interface AsoScenarioMinLayerResponseCollectionResponse {
  messages?: string[] | null;
  data: AsoScenarioMinLayerResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface AsoScenarioMinLayerResponseDataResponse {
  messages?: string[] | null;
  data: AsoScenarioMinLayerResponse;
}
export interface AsoScenarioMinLayerUpdateRequest {
  /** @format int32 */
  scopeId?: number | null;
  listIds?: number[] | null;
}
export interface AsoScenarioMinLayerUpdateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: AsoScenarioMinLayerUpdateRequest | null;
}
export interface AsoScenarioResponse {
  /** @format int32 */
  id: number;
  name: string;
  /** @format int32 */
  asoRequestId: number;
  status: AsoScenarioStatus;
}
export interface AsoScenarioResponseCollectionResponse {
  messages?: string[] | null;
  data: AsoScenarioResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface AsoScenarioResponseDataResponse {
  messages?: string[] | null;
  data: AsoScenarioResponse;
}
export interface AsoScenarioScope {
  /** @format int32 */
  asoScopeId: number;
  /** @format int32 */
  asoScenarioId: number;
  /** @format int32 */
  priority: number;
  asoScenario: AsoScenario;
  asoScopeSources: AsoScenarioScopeSource[];
  asoScopeTargets: AsoScenarioScopeTarget[];
}
export interface AsoScenarioScopeResponse {
  /** @format int32 */
  id: number;
  /** @format int32 */
  priority: number;
  source: AsoScenarioScopeSourceResponse;
  targets: AsoScenarioScopeTargetResponse[];
}
export interface AsoScenarioScopeResponseCollectionResponse {
  messages?: string[] | null;
  data: AsoScenarioScopeResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface AsoScenarioScopeResponseDataResponse {
  messages?: string[] | null;
  data: AsoScenarioScopeResponse;
}
export interface AsoScenarioScopeSource {
  /** @format int32 */
  asoScopeSourceId: number;
  /** @format int32 */
  asoScopeId?: number | null;
  /** @format int32 */
  scopeId?: number | null;
  isForced: boolean;
  isForcedToZero: boolean;
  asoScope?: AsoScenarioScope | null;
}
export interface AsoScenarioScopeSourceResponse {
  /** @format int32 */
  id: number;
  /** @format int32 */
  scopeId?: number | null;
  isForced: boolean;
  isForcedToZero: boolean;
}
export interface AsoScenarioScopeSourceResponseDataResponse {
  messages?: string[] | null;
  data: AsoScenarioScopeSourceResponse;
}
export interface AsoScenarioScopeSourceUpdateRequest {
  /** @format int32 */
  scopeId?: number | null;
  isForced?: boolean | null;
  isForcedToZero?: boolean | null;
}
export interface AsoScenarioScopeSourceUpdateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: AsoScenarioScopeSourceUpdateRequest | null;
}
export interface AsoScenarioScopeTarget {
  /** @format int32 */
  asoScopeTargetId: number;
  /** @format int32 */
  asoScopeId?: number | null;
  /** @format int32 */
  scopeId?: number | null;
  /** @format int32 */
  priority: number;
  asoScope?: AsoScenarioScope | null;
}
export interface AsoScenarioScopeTargetResponse {
  /** @format int32 */
  id: number;
  /** @format int32 */
  scopeId?: number | null;
  /** @format int32 */
  priority: number;
}
export interface AsoScenarioScopeTargetResponseDataResponse {
  messages?: string[] | null;
  data: AsoScenarioScopeTargetResponse;
}
export interface AsoScenarioScopeTargetUpdateRequest {
  /** @format int32 */
  scopeId?: number | null;
  /** @format int32 */
  priority?: number | null;
}
export interface AsoScenarioScopeTargetUpdateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: AsoScenarioScopeTargetUpdateRequest | null;
}
export interface AsoScenarioScopeUpdateRequest {
  /** @format int32 */
  priority?: number | null;
}
export interface AsoScenarioScopeUpdateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: AsoScenarioScopeUpdateRequest | null;
}
export interface AsoScenarioStoreTier {
  /** @format int32 */
  asoScenarioId: number;
  /** @format int64 */
  storeId: number;
  /** @format int32 */
  computedTier: number;
  /** @format int32 */
  forcedTier?: number | null;
  /** @format double */
  saleValue?: number | null;
  asoScenario: AsoScenario;
  store: Warehouse;
}
export interface AsoScenarioStoreTierConfiguration {
  /** @format int32 */
  asoScenarioId: number;
  storeTier: AsoScenarioStoreTierType;
  /** @format double */
  tierMultiplier?: number | null;
  /** @format int32 */
  balancingMinimumInventoryMonths?: number | null;
  /** @format int32 */
  balancingMedianInventoryMonths?: number | null;
  /** @format int32 */
  balancingMaximumInventoryMonths?: number | null;
  asoScenario: AsoScenario;
}
export interface AsoScenarioStoreTierConfigurationPatchRequest {
  /** @format double */
  tierMultiplier?: number | null;
  /** @format int32 */
  balancingMinimumInventoryMonths?: number | null;
  /** @format int32 */
  balancingMedianInventoryMonths?: number | null;
  /** @format int32 */
  balancingMaximumInventoryMonths?: number | null;
}
export interface AsoScenarioStoreTierConfigurationPatchRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: AsoScenarioStoreTierConfigurationPatchRequest | null;
}
export interface AsoScenarioStoreTierConfigurationResponse {
  /** @format int32 */
  asoScenarioId: number;
  storeTier?: AsoScenarioStoreTierType | null;
  /** @format double */
  tierMultiplier?: number | null;
  /** @format int32 */
  balancingMinimumInventoryMonths?: number | null;
  /** @format int32 */
  balancingMedianInventoryMonths?: number | null;
  /** @format int32 */
  balancingMaximumInventoryMonths?: number | null;
}
export interface AsoScenarioStoreTierConfigurationResponseCollectionResponse {
  messages?: string[] | null;
  data: AsoScenarioStoreTierConfigurationResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface AsoScenarioStoreTierForceRequest {
  /** @format int32 */
  forcedTier?: number | null;
}
export interface AsoScenarioStoreTierForceRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: AsoScenarioStoreTierForceRequest | null;
}
export interface AsoScenarioStoreTierResponse {
  /** @format int64 */
  storeId: number;
  /** @format int32 */
  computedTier: number;
  /** @format int32 */
  forcedTier?: number | null;
  /** @format double */
  saleValue?: number | null;
}
export interface AsoScenarioStoreTierResponseCollectionResponse {
  messages?: string[] | null;
  data: AsoScenarioStoreTierResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface AsoScenarioStoreTierSetting {
  /** @format int32 */
  asoScenarioId: number;
  /** @format double */
  tier1Percent: number;
  /** @format double */
  tier2Percent: number;
  asoScenario: AsoScenario;
}
export interface AsoScenarioStoreTierSettingsResponse {
  /** @format double */
  tier1Percent: number;
  /** @format double */
  tier2Percent: number;
}
export interface AsoScenarioStoreTierSettingsResponseDataResponse {
  messages?: string[] | null;
  data: AsoScenarioStoreTierSettingsResponse;
}
export interface AsoScenarioStoreTierSettingsUpdateRequest {
  /** @format double */
  tier1Percent?: number | null;
  /** @format double */
  tier2Percent?: number | null;
}
export interface AsoScenarioStoreTierSettingsUpdateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: AsoScenarioStoreTierSettingsUpdateRequest | null;
}
export interface AsoScenarioStoreTierUpdateRequest {
  /** @format int32 */
  forcedTier?: number | null;
}
export interface AsoScenarioStoreTierUpdateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: AsoScenarioStoreTierUpdateRequest | null;
}
export interface AsoScenarioUpdateRequest {
  name: string;
}
export interface AsoScenarioUpdateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: AsoScenarioUpdateRequest | null;
}
export interface AsoScenarioUsageSummaryResponse {
  /** @format int32 */
  id: number;
  name: string;
  status: AsoScenarioStatus;
}
export interface AsoScopeUsageContextResponse {
  scenario: AsoScenarioUsageSummaryResponse;
  request: AsoRequestUsageSummaryResponse;
}
export interface AttributeValue {
  /** @format int32 */
  attributeValueId: number;
  dataRetrievalStatusId: DataRetrievalStatus;
  /** @format int32 */
  computationSplitId?: number | null;
  /** @format date */
  applicationDate: string;
  /** @format date-time */
  createdAt: string;
  isLast: boolean;
  isUsedInCalculation: boolean;
  isCron: boolean;
  isUsedForSkuAvailableSupply: boolean;
  isValid: boolean;
  computationSplit?: ComputationSplit | null;
  calculations: Calculation[];
  categoryAttributeValues: CategoryAttributeValue[];
  papSyncEvents: PapSyncEvent[];
  productAttributeValues: ProductAttributeValue[];
  sourceSkuExecutionHeuristics: SkuExecutionHeuristic[];
}
export interface Brand {
  /** @format int32 */
  brandId: number;
  name: string;
  brandAttributeValues: BrandAttributeValue[];
  brandConfigurations: BrandConfiguration[];
  products: Product[];
  productAttributeValues: ProductAttributeValue[];
  storeCategoryBrandPerformances: StoreCategoryBrandPerformance[];
  storePerformanceProductKeys: StorePerformanceProductKey[];
}
export interface BrandAttributeValue {
  /** @format int32 */
  attributeValueId: number;
  /** @format int32 */
  brandId: number;
  isUiVisible: boolean;
  /** @format int32 */
  productCount: number;
  attributeValue: AttributeValue;
  brand: Brand;
}
export interface BrandConfiguration {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  brandId: number;
  calculation: Calculation;
  brand: Brand;
}
export interface BrandConfigurationResponse {
  /** @format int32 */
  id: number;
  name: string;
  /** @format int32 */
  productCount: number;
  isConfigured: boolean;
}
export interface BrandConfigurationResponseCollectionResponse {
  messages?: string[] | null;
  data: BrandConfigurationResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface BrandConfigurationUpdateRequest {
  /** @format int32 */
  brandId: number;
}
export interface BrandDetailResponse {
  /** @format int32 */
  id: number;
  name: string;
  /** @format int32 */
  productCount: number;
}
export interface BrandDetailResponseCollectionResponse {
  messages?: string[] | null;
  data: BrandDetailResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface BrandResponse {
  /** @format int32 */
  id: number;
  name: string;
}
export interface Calculation {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  sourceTemplateId?: number | null;
  /** @format int32 */
  superiorCalculationId?: number | null;
  /** @format int32 */
  originalCalculationId?: number | null;
  calculationTypeId: CalculationType;
  calculationModeId: CalculationMode;
  calculationStatusId: CalculationStatus;
  /** @format int32 */
  forecastId: number;
  /** @format int32 */
  attributeValueId: number;
  identityUserId?: string | null;
  /** @format uuid */
  runKey?: string | null;
  name: string;
  description?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  softDeletedAt?: string | null;
  /** @format int32 */
  progress?: number | null;
  isMeasured: boolean;
  isPap: boolean;
  isSkuRedistributionEdited: boolean;
  isBackedUp: boolean;
  shouldImportDebugRows: boolean;
  calculationFlagIds: CalculationFlag;
  /** @format int32 */
  importedSkuPotentialGroupCount: number;
  /** @format date */
  applicationDate: string;
  /** @format date */
  executionRateLastEstimatedOn?: string | null;
  /** @format date */
  finishExecutionUntil?: string | null;
  attributeValue: AttributeValue;
  forecast: Forecast;
  papInputCalculation?: PapInputCalculation | null;
  papResultCalculation?: PapResultCalculation | null;
  sourceTemplate?: Calculation | null;
  superiorCalculation?: Calculation | null;
  originalCalculation?: Calculation | null;
  calculationConfiguration?: CalculationConfiguration | null;
  asoScenarioComputes: AsoScenarioCompute[];
  brandConfigurations: BrandConfiguration[];
  calculationConfigurationsExperimental: CalculationConfigurationExperimental[];
  customExportRuns: CustomExportRun[];
  calculationFiles: CalculationFile[];
  categoryFieldConfigurations: CategoryFieldConfiguration[];
  categoryRedistributions: CategoryRedistribution[];
  categorySummaries: CategorySummary[];
  commandQueues: CommandQueue[];
  configurationRules: ConfigurationRule[];
  calculationOverlaps: CalculationOverlap[];
  overlappingCalculations: CalculationOverlap[];
  entityListVersionConfigurations: EntityListVersionConfiguration[];
  entityListConfigurations: EntityListConfiguration[];
  papAuditLogs: PapAuditLog[];
  papPerformances: PapPerformance[];
  papPackingPictures: PapPackingPicture[];
  papSyncEvents: PapSyncEvent[];
  papResultRoutes: PapResultRoute[];
  papResultSkuRedistributions: PapResultSkuRedistribution[];
  papResultSkuRedistributionIssues: PapResultSkuRedistributionIssue[];
  regionFlowGroups: RegionFlowGroup[];
  skuClassConfigurations: SkuClassConfiguration[];
  skuExecutionHeuristics: SkuExecutionHeuristic[];
  skuPotentials: SkuPotential[];
  skuRedistributions: SkuRedistribution[];
  skuRedistributionBackups: SkuRedistributionBackup[];
  skuRedistributionChangelogs: SkuRedistributionChangelog[];
  skuRedistributionsExpanded: SkuRedistributionExpanded[];
  subordinateCalculations: Calculation[];
  targetCalculations: Calculation[];
  followingCalculations: Calculation[];
  productListConfigurations: ProductListConfiguration[];
  targetListConfigurations: TargetListConfiguration[];
}
export interface CalculationConfiguration {
  /** @format int32 */
  calculationId: number;
  productListsAllEnabled: boolean;
  brandsAllEnabled: boolean;
  regionFlowTypeId: RegionFlowType;
  /** @deprecated */
  superTargetRedistributionTypeId: SuperTargetRedistributionType;
  /** @deprecated */
  useClosingStores: boolean;
  skuListConfigurationFlagIds?: SkuListConfigurationFlag | null;
  isExperimentConfigurationsEnabled: boolean;
  retiredConfigurationsJson?: string | null;
  /** @format int32 */
  ptRequestListEntityListId?: number | null;
  isLocked: boolean;
  calculation: Calculation;
  ptRequestListEntityList?: EntityList | null;
}
export interface CalculationConfigurationDeleteRequest {
  skuListConfigurationFlagIds?: SkuListConfigurationFlag | null;
}
export interface CalculationConfigurationExperimental {
  /** @format int32 */
  calculationId: number;
  key: CalculationConfigurationExperimentalType;
  /** @format int32 */
  itemSequence: number;
  value: string;
  calculation: Calculation;
}
export interface CalculationConfigurationRequest {
  productListsAllEnabled?: boolean | null;
  brandsAllEnabled?: boolean | null;
  regionFlowTypeId?: RegionFlowType | null;
  superTargetRedistributionTypeId?: SuperTargetRedistributionType | null;
  useClosingStores?: boolean | null;
  skuListConfigurationFlagIds?: SkuListConfigurationFlag | null;
  isExperimentConfigurationsEnabled?: boolean | null;
  isLocked?: boolean | null;
  /** @format int32 */
  ptRequestListEntityListId?: number | null;
}
export interface CalculationConfigurationRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: CalculationConfigurationRequest | null;
}
export interface CalculationConfigurationResponse {
  productListsAllEnabled: boolean;
  brandsAllEnabled: boolean;
  regionFlowTypeId: RegionFlowType;
  /** @deprecated */
  superTargetRedistributionTypeId: SuperTargetRedistributionType;
  /** @deprecated */
  useClosingStores: boolean;
  skuListConfigurationFlagIds?: SkuListConfigurationFlag | null;
  isExperimentConfigurationsEnabled: boolean;
  isLocked: boolean;
  ptRequestListEntityList?: EntityListResponse | null;
  retiredConfigurations?: RetiredConfigurations | null;
}
export interface CalculationConfigurationResponseDataResponse {
  messages?: string[] | null;
  data: CalculationConfigurationResponse;
}
export interface CalculationDeletePickingPositionsRequest {
  /** Human-readable description of the change. */
  description?: string | null;
  /** Stringified payload object. */
  entityDetail?: string | null;
  /** @format int32 */
  sourceSkuId: number;
  /** @format int32 */
  targetSkuId: number;
}
export interface CalculationDepartmentResponse {
  /** @format int32 */
  id: number;
  name: string;
  customerDepartmentId?: string | null;
  /** @format double */
  totalValue: number;
}
export interface CalculationDepartmentResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationDepartmentResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CalculationDetailResponse {
  /** @format int32 */
  id: number;
  isDeletable: boolean;
  status: CalculationStatus;
  type: CalculationType;
  mode: CalculationMode;
  calculationFlags: CalculationFlags;
  sourceTemplate?: TemplateResponse | null;
  title: string;
  description?: string | null;
  /** @format date-time */
  created: string;
  /** @format date */
  applicationDate: string;
  identityUserId?: string | null;
  /** @format int64 */
  rootCategoryId: number;
  /** @format date */
  finishExecutionUntil?: string | null;
  /** @format date */
  executionRateLastEstimatedOn?: string | null;
  isPap: boolean;
  isSkuRedistributionEdited: boolean;
  isBackedUp: boolean;
  /**
   * Whether the SkuPotential debug rows are imported after computed pairing completes.
   * May be true even when the creating user did not ask for it, if the calculation uses a
   * Request List.
   */
  shouldImportDebugRows: boolean;
  /**
   * Configuration fields indicating how a specific entity list is used in this calculation.
   * Only populated by the GetConfiguredCalculations endpoint.
   */
  configurationFieldUsages?: ConfigurationFieldUsageResponse[] | null;
  rootCategoryRedistributions: CategoryRedistributionResponse[];
  papDbSyncStatus: PapSyncStatus;
  papResultCalculationProgressStatus: PapProgressStatus;
  owner?: UserResponse | null;
  overlappingCalculations?: CalculationWithOverviewResponse[] | null;
  subordinateCalculations?: CalculationWithOverviewResponse[] | null;
  latestCustomExportRun?: CustomExportRunResponse | null;
  /** @format date */
  forecastDate: string;
  hasSkuAttributes: boolean;
  hasSkuForecasts: boolean;
  /** @format date-time */
  lastSyncedIntoPapAppAt?: string | null;
  configuration?: CalculationConfigurationResponse | null;
  /** @deprecated */
  productListsAllEnabled: boolean;
  files: CalculationFileResponse[];
  superiorCalculation?: CalculationResponse | null;
  originalCalculation?: CalculationResponse | null;
}
export interface CalculationDetailResponseDataResponse {
  messages?: string[] | null;
  data: CalculationDetailResponse;
}
export interface CalculationEvaluationRatesSummaryResponse {
  /** @format date */
  executionRateLastEstimatedOn?: string | null;
  /** @format date */
  finishExecutionUntil?: string | null;
  /** @format date-time */
  calculationCreatedAt: string;
  executionType?: ExecutionType | null;
  isPap: boolean;
  pickingProgress: PickingProgressResponse;
  /** Information about the execution status of a redistribution */
  executionStatus: ExecutionStatusResponse;
}
export interface CalculationEvaluationRatesSummaryResponseDataResponse {
  messages?: string[] | null;
  data: CalculationEvaluationRatesSummaryResponse;
}
export interface CalculationExperimentalConfigurationRequest {
  key: CalculationConfigurationExperimentalType;
  /** @format int32 */
  itemSequence: number;
  value: string;
}
export interface CalculationExperimentalConfigurationResponse {
  key: CalculationConfigurationExperimentalType;
  /** @format int32 */
  itemSequence: number;
  value: string;
}
export interface CalculationExperimentalConfigurationResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationExperimentalConfigurationResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CalculationFile {
  /** @format int32 */
  calculationFileId: number;
  /** @format int32 */
  calculationId: number;
  calculationFileTypeId: CalculationFileType;
  dataRetrievalStatusId: DataRetrievalStatus;
  url: string;
  fileName: string;
  /** @format date-time */
  createdAt: string;
  calculation: Calculation;
}
export interface CalculationFileResponse {
  /** @format int32 */
  id: number;
  calculationFileType: CalculationFileType;
  dataRetrievalStatus: DataRetrievalStatus;
  url: string;
  fileName: string;
}
export interface CalculationFileResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationFileResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CalculationFlags {
  preComputePotentialFinished: boolean;
  preComputePotentialCrashed: boolean;
  importSkuPotentialFinished: boolean;
  importSkuPotentialCrashed: boolean;
  importSkuPotentialDebugFinished: boolean;
  importSkuPotentialDebugCrashed: boolean;
}
export interface CalculationImportRequest {
  /** @format date-time */
  verificationTimeStamp: string;
  apiOperationType: ApiOperationType;
  productIdentificationTypeId?: EntityIdentificationType | null;
  storeIdentificationTypeId?: EntityIdentificationType | null;
}
export interface CalculationImportResponse {
  /** @format int32 */
  recordImportId: number;
  apiAction: ApiOperationType;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  verificationTimeStamp: string;
  user: UserResponse;
  productIdentificationTypeId?: EntityIdentificationType | null;
  storeIdentificationTypeId?: EntityIdentificationType | null;
}
export interface CalculationImportResponseDataResponse {
  messages?: string[] | null;
  data: CalculationImportResponse;
}
export interface CalculationOverlap {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  overlappingCalculationId: number;
  calculation: Calculation;
  overlappingCalculation: Calculation;
}
export interface CalculationPickingExecutionDetailsResponse {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  sourceSkuId: number;
  /** @format int32 */
  targetSkuId: number;
  executionType: ExecutionType;
  /** @format int32 */
  shippedQuantity?: number | null;
  /** @format date */
  shippedDate?: string | null;
  /** @format int32 */
  deliveredQuantity?: number | null;
  /** @format date */
  deliveredDate?: string | null;
}
export interface CalculationPickingExecutionDetailsResponseDataResponse {
  messages?: string[] | null;
  data: CalculationPickingExecutionDetailsResponse;
}
export interface CalculationPickingInsightsSummaryResponse {
  /** @format int32 */
  processedPickingPositionsCount: number;
  /** @format int32 */
  pickingTime: number;
  /** @format double */
  trimmedMeanPickingTime: number;
  /** @format double */
  trimmedMedianPickingTime: number;
  /** @format int32 */
  trimmedPickingTime: number;
  /** @format int32 */
  executedQuantity: number;
  /** @format double */
  executedValue: number;
}
export interface CalculationPickingInsightsSummaryResponseDataResponse {
  messages?: string[] | null;
  data: CalculationPickingInsightsSummaryResponse;
}
/** Picking issues for a store. */
export interface CalculationPickingIssuesResponse {
  store: StoreResponse;
  issues: PickingIssueInsightsResponse[];
  /** @format int32 */
  count: number;
}
export interface CalculationPickingIssuesResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationPickingIssuesResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CalculationPickingPerformance {
  /** @format int32 */
  pickingTime: number;
  /** @format int32 */
  trimmedPickingTime?: number | null;
  isOutlier: boolean;
  calculation: CalculationResponse;
  sourceSku: SkuBaseResponse;
  targetSku: SkuBaseResponse;
}
export interface CalculationPickingPerformanceCollectionResponse {
  messages?: string[] | null;
  data: CalculationPickingPerformance[];
  /** @format int32 */
  totalCount?: number | null;
}
/** Summary picking results for a calculation. */
export interface CalculationPickingResponse {
  /** @format date */
  finishExecutionUntil?: string | null;
  /** @format date-time */
  calculationCreatedAt: string;
  pickingStatus: PapProgressStatus;
  pickingResults: RoutesExecutionSummaryResponse;
}
export interface CalculationPickingResponseDataResponse {
  messages?: string[] | null;
  /** Summary picking results for a calculation. */
  data: CalculationPickingResponse;
}
export interface CalculationRecordImportItemResponse {
  /** @format int32 */
  recordImportId: number;
  /** @format int32 */
  sequence: number;
  recordImportActionCode: RecordImportAction;
  productIdentification?: string | null;
  product?: ProductResponse | null;
  sourceStoreIdentification?: string | null;
  sourceStore?: StoreResponse | null;
  targetStoreIdentification?: string | null;
  targetStore?: StoreResponse | null;
  sourceSku?: SkuBaseResponse | null;
  targetSku?: SkuBaseResponse | null;
  /** @format int32 */
  quantity?: number | null;
  description?: string | null;
}
export interface CalculationRecordImportItemResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationRecordImportItemResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
/** Contains number of import items of given action in import */
export interface CalculationRecordImportSummaryResponse {
  recordImportAction: RecordImportAction;
  /** @format int32 */
  itemCount: number;
}
export interface CalculationRecordImportSummaryResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationRecordImportSummaryResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CalculationRequest {
  title?: string | null;
  description?: string | null;
  calculationType: CalculationType;
  calculationMode: CalculationMode;
  /** @format int32 */
  templateId?: number | null;
  /** @format int32 */
  originalCalculationId?: number | null;
  overlappingCalculations?: number[] | null;
  subordinateCalculations?: CalculationRequest[] | null;
  /**
   * Requests the deferred import of the SkuPotential debug rows after computed pairing
   * completes. On a merged root it reaches every computed subordinate. Left false, the
   * calculation may still end up importing debug rows if it turns out to use a Request List.
   */
  shouldImportDebugRows: boolean;
}
export interface CalculationResponse {
  /** @format int32 */
  id: number;
  isDeletable: boolean;
  status: CalculationStatus;
  type: CalculationType;
  mode: CalculationMode;
  calculationFlags: CalculationFlags;
  sourceTemplate?: TemplateResponse | null;
  title: string;
  description?: string | null;
  /** @format date-time */
  created: string;
  /** @format date */
  applicationDate: string;
  identityUserId?: string | null;
  /** @format int64 */
  rootCategoryId: number;
  /** @format date */
  finishExecutionUntil?: string | null;
  /** @format date */
  executionRateLastEstimatedOn?: string | null;
  isPap: boolean;
  isSkuRedistributionEdited: boolean;
  isBackedUp: boolean;
  /**
   * Whether the SkuPotential debug rows are imported after computed pairing completes.
   * May be true even when the creating user did not ask for it, if the calculation uses a
   * Request List.
   */
  shouldImportDebugRows: boolean;
  /**
   * Configuration fields indicating how a specific entity list is used in this calculation.
   * Only populated by the GetConfiguredCalculations endpoint.
   */
  configurationFieldUsages?: ConfigurationFieldUsageResponse[] | null;
}
export interface CalculationResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CalculationRoutesDeleteRequest {
  /** Human-readable description of the change. */
  description?: string | null;
  /** Stringified payload object. */
  entityDetail?: string | null;
  /** @format int32 */
  sourceStoreId: number;
  /** @format int32 */
  targetStoreId: number;
  /** @format int32 */
  departmentId?: number | null;
}
export interface CalculationSourceStoresDeleteRequest {
  /** Human-readable description of the change. */
  description?: string | null;
  /** Stringified payload object. */
  entityDetail?: string | null;
  /** @format int32 */
  sourceStoreId: number;
  /** @format int32 */
  departmentId?: number | null;
}
export interface CalculationStatisticRegionResponse {
  region: RegionResponse;
  /** @format double */
  valueSource: number;
  /** @format int32 */
  quantitySource: number;
  /** @format double */
  valueTarget: number;
  /** @format int32 */
  quantityTarget: number;
}
export interface CalculationStatisticRegionResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationStatisticRegionResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CalculationStatisticRequestListItemResponse {
  /** @format int32 */
  skuId: number;
  product: ProductResponse;
  store: StoreResponse;
  department: DepartmentResponse;
  /** @format int32 */
  originalRequestedQuantity: number;
  /** @format int32 */
  receivedQuantity: number;
  /** @format int32 */
  requestedQuantity: number;
  /** @format int32 */
  quantityNotReceived: number;
  /** @format int32 */
  availableSupply: number;
  /** @format int32 */
  openPurchaseOrdersQuantity: number;
  /** @format double */
  stockPrice: number;
  isEligible: boolean;
}
export interface CalculationStatisticRequestListItemResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationStatisticRequestListItemResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CalculationStatisticRequestListItemSourceResponse {
  /** @format int32 */
  skuId: number;
  store: StoreResponse;
  department: DepartmentResponse;
  /** @format double */
  stockPrice: number;
  /** @format int32 */
  availableSupply: number;
  isForced: boolean;
  useAsSource: boolean;
  /** @format int32 */
  totalSupply: number;
  /** @format int32 */
  incomingQuantity: number;
  /** @format int32 */
  outgoingQuantity: number;
  /** @format int32 */
  availableToSend: number;
  /** @format int32 */
  sentQuantity: number;
  /** @format int32 */
  blockedByAllSettings: number;
  /** @format int32 */
  blockedByCategory: number;
  /** @format int32 */
  blockedByFirstPurchaseDate: number;
  /** @format int32 */
  blockedByLastPurchaseDate: number;
  /** @format int32 */
  blockedByMinLayers: number;
  /** @format int32 */
  blockedByMinValue: number;
  /** @format int32 */
  blockedByPromo: number;
  /** @format int32 */
  blockedByForecast: number;
}
export interface CalculationStatisticRequestListItemSourceResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationStatisticRequestListItemSourceResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CalculationStatisticRequestListSummaryResponse {
  /** @format int32 */
  receivedQuantity: number;
  /** @format int32 */
  requestedQuantity: number;
  /** @format int32 */
  quantityNotReceived: number;
}
export interface CalculationStatisticRequestListSummaryResponseDataResponse {
  messages?: string[] | null;
  data: CalculationStatisticRequestListSummaryResponse;
}
export interface CalculationStatisticRouteResponse {
  department?: DepartmentResponse | null;
  sourceStore: StoreResponse;
  targetStore: StoreResponse;
  /** @format double */
  value: number;
  /** @format int32 */
  quantity: number;
  /** @format int32 */
  pickingPositionCount: number;
  /** @format double */
  filledStockoutValue: number;
}
export interface CalculationStatisticRouteResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationStatisticRouteResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CalculationStatisticRouteSummaryResponse {
  type: StatisticType;
  /** @format int32 */
  quantity: number;
  /** @format double */
  value: number;
  /** @format int32 */
  pickingPositionCount: number;
}
export interface CalculationStatisticRouteSummaryResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationStatisticRouteSummaryResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CalculationStatisticSkuClassResponse {
  skuClass: SkuClassResponse;
  /** @format double */
  valueSource: number;
  /** @format int32 */
  quantitySource: number;
  /** @format double */
  valueTarget: number;
  /** @format int32 */
  quantityTarget: number;
}
export interface CalculationStatisticSkuClassResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationStatisticSkuClassResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CalculationStatisticStoreSourceResponse {
  sourceStore: StoreResponse;
  department?: DepartmentResponse | null;
  /** @format double */
  value: number;
  /** @format int32 */
  quantity: number;
  /** @format int32 */
  productCount: number;
  /** @format int32 */
  targetStoreCount: number;
  /** @format int32 */
  pickingPositionCount: number;
}
export interface CalculationStatisticStoreSourceResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationStatisticStoreSourceResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CalculationStatisticStoreSourceSummaryResponse {
  type: StatisticType;
  /** @format int32 */
  quantity: number;
  /** @format double */
  value: number;
  /** @format int32 */
  productCount: number;
  /** @format int32 */
  targetStoreCount: number;
  /** @format int32 */
  pickingPositionCount: number;
}
export interface CalculationStatisticStoreSummaryResponse {
  sourceSummaries: CalculationStatisticStoreSourceSummaryResponse[];
  targetSummaries: CalculationStatisticStoreTargetSummaryResponse[];
}
export interface CalculationStatisticStoreSummaryResponseDataResponse {
  messages?: string[] | null;
  data: CalculationStatisticStoreSummaryResponse;
}
export interface CalculationStatisticStoreTargetResponse {
  targetStore: StoreResponse;
  department?: DepartmentResponse | null;
  /** @format double */
  value: number;
  /** @format int32 */
  quantity: number;
  /** @format int32 */
  productCount: number;
  /** @format int32 */
  sourceStoreCount: number;
  /** @format int32 */
  pickingPositionCount: number;
  /** @format double */
  filledStockoutValue: number;
}
export interface CalculationStatisticStoreTargetResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationStatisticStoreTargetResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CalculationStatisticStoreTargetSummaryResponse {
  type: StatisticType;
  /** @format int32 */
  quantity: number;
  /** @format double */
  value: number;
  /** @format int32 */
  productCount: number;
  /** @format int32 */
  sourceStoreCount: number;
  /** @format int32 */
  pickingPositionCount: number;
}
export interface CalculationStatisticStoreTypeResponse {
  storeType: StoreTypeResponse;
  /** @format double */
  valueSource: number;
  /** @format int32 */
  quantitySource: number;
  /** @format double */
  valueTarget: number;
  /** @format int32 */
  quantityTarget: number;
}
export interface CalculationStatisticStoreTypeResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationStatisticStoreTypeResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CalculationStatisticSummaryResponse {
  /** @format double */
  value: number;
  /** @format int32 */
  quantity: number;
  /** @format int32 */
  productCount: number;
  /** @format int32 */
  pickingPositionCount: number;
  /** @format int32 */
  storesSourceAvailableCount: number;
  /** @format int32 */
  storesSourceUsedCount: number;
  /** @format int32 */
  storesTargetAvailableCount: number;
  /** @format int32 */
  storesTargetUsedCount: number;
  /** @format double */
  filledStockoutValue: number;
  /** @format double */
  targetMinimalLayerValue: number;
  /** @format double */
  sourceForcedProductValue: number;
  /** @format int32 */
  routesCount: number;
  /** @format int32 */
  avgOutgoingRoutes: number;
  /** @format int32 */
  avgIncomingRoutes: number;
}
export interface CalculationStatisticSummaryResponseDataResponse {
  messages?: string[] | null;
  data: CalculationStatisticSummaryResponse;
}
export interface CalculationStatusRequest {
  status: ConfigurationStatus;
}
export interface CalculationStatusResponse {
  templateStatus: CalculationStatus;
  applicationStatus: ApplicationStatus;
  statusInfo?: string | null;
  /** @format int64 */
  rootCategoryId: number;
}
export interface CalculationStatusResponseDataResponse {
  messages?: string[] | null;
  data: CalculationStatusResponse;
}
export interface CalculationTargetStoresDeleteRequest {
  /** Human-readable description of the change. */
  description?: string | null;
  /** Stringified payload object. */
  entityDetail?: string | null;
  /** @format int32 */
  targetStoreId: number;
  /** @format int32 */
  departmentId?: number | null;
}
export interface CalculationUpdateRequest {
  title?: string | null;
  description?: string | null;
  calculationType?: CalculationType | null;
  /** @format date */
  finishExecutionUntil?: string | null;
  isPap?: boolean | null;
}
export interface CalculationUpdateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: CalculationUpdateRequest | null;
}
export interface CalculationWithOverviewResponse {
  /** @format int32 */
  id: number;
  isDeletable: boolean;
  status: CalculationStatus;
  type: CalculationType;
  mode: CalculationMode;
  calculationFlags: CalculationFlags;
  sourceTemplate?: TemplateResponse | null;
  title: string;
  description?: string | null;
  /** @format date-time */
  created: string;
  /** @format date */
  applicationDate: string;
  identityUserId?: string | null;
  /** @format int64 */
  rootCategoryId: number;
  /** @format date */
  finishExecutionUntil?: string | null;
  /** @format date */
  executionRateLastEstimatedOn?: string | null;
  isPap: boolean;
  isSkuRedistributionEdited: boolean;
  isBackedUp: boolean;
  /**
   * Whether the SkuPotential debug rows are imported after computed pairing completes.
   * May be true even when the creating user did not ask for it, if the calculation uses a
   * Request List.
   */
  shouldImportDebugRows: boolean;
  /**
   * Configuration fields indicating how a specific entity list is used in this calculation.
   * Only populated by the GetConfiguredCalculations endpoint.
   */
  configurationFieldUsages?: ConfigurationFieldUsageResponse[] | null;
  rootCategoryRedistributions: CategoryRedistributionResponse[];
  papDbSyncStatus: PapSyncStatus;
  papResultCalculationProgressStatus: PapProgressStatus;
}
export interface CalculationWithOverviewResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationWithOverviewResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CalculationWithRelatedEntitiesResponse {
  /** @format int32 */
  id: number;
  isDeletable: boolean;
  status: CalculationStatus;
  type: CalculationType;
  mode: CalculationMode;
  calculationFlags: CalculationFlags;
  sourceTemplate?: TemplateResponse | null;
  title: string;
  description?: string | null;
  /** @format date-time */
  created: string;
  /** @format date */
  applicationDate: string;
  identityUserId?: string | null;
  /** @format int64 */
  rootCategoryId: number;
  /** @format date */
  finishExecutionUntil?: string | null;
  /** @format date */
  executionRateLastEstimatedOn?: string | null;
  isPap: boolean;
  isSkuRedistributionEdited: boolean;
  isBackedUp: boolean;
  /**
   * Whether the SkuPotential debug rows are imported after computed pairing completes.
   * May be true even when the creating user did not ask for it, if the calculation uses a
   * Request List.
   */
  shouldImportDebugRows: boolean;
  /**
   * Configuration fields indicating how a specific entity list is used in this calculation.
   * Only populated by the GetConfiguredCalculations endpoint.
   */
  configurationFieldUsages?: ConfigurationFieldUsageResponse[] | null;
  rootCategoryRedistributions: CategoryRedistributionResponse[];
  papDbSyncStatus: PapSyncStatus;
  papResultCalculationProgressStatus: PapProgressStatus;
  owner?: UserResponse | null;
  overlappingCalculations?: CalculationWithOverviewResponse[] | null;
  subordinateCalculations?: CalculationWithOverviewResponse[] | null;
  latestCustomExportRun?: CustomExportRunResponse | null;
}
export interface CalculationWithRelatedEntitiesResponseCollectionResponse {
  messages?: string[] | null;
  data: CalculationWithRelatedEntitiesResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface Category {
  /** @format int64 */
  categoryId: number;
  /** @format int64 */
  parentCategoryId?: number | null;
  customerCategoryId?: string | null;
  /** @format int32 */
  level: number;
  name?: string | null;
  code?: string | null;
  parentCategory: Category;
  childCategories: Category[];
  superiorCategoryHierarchies: CategoryHierarchy[];
  subordinateCategoryHierarchies: CategoryHierarchy[];
  categoryAttributeValues: CategoryAttributeValue[];
  categoryFieldConfigurations: CategoryFieldConfiguration[];
  categorySummaries: CategorySummary[];
  forecastJobs: ForecastJob[];
  products: Product[];
  productCategories: ProductCategory[];
  definitionForecastCleanups: DefinitionForecastCleanup[];
  storeCategoryBrandPerformances: StoreCategoryBrandPerformance[];
  storePerformanceProductKeys: StorePerformanceProductKey[];
}
export interface CategoryAttributeValue {
  /** @format int32 */
  attributeValueId: number;
  /** @format int64 */
  categoryId: number;
  /** @format int32 */
  totalSkuCount: number;
  /** @format int32 */
  enabledSkuCount: number;
  /** @format double */
  availableSupplyValue: number;
  /** @format double */
  monthlyRevenueSalePriceValue: number;
  /** @format double */
  annualRevenueSalePriceValue: number;
  /** @format double */
  margin: number;
  attributeValue: AttributeValue;
  category: Category;
}
export interface CategoryAttributeValueResponse {
  categoryAttributeValueTypeId: CategoryAttributeValueType;
  /** @format double */
  value: number;
}
export interface CategoryConfigurationDefinition {
  /** @format int32 */
  categoryConfigurationDefinitionId: number;
  fieldTypeCode: ConfigurationFieldType;
  dataTypeId: ConfigurationDataType;
  sectionTypeId: ConfigurationSectionType;
  title: string;
  description?: string | null;
  /** @format int32 */
  position: number;
  computePotential: boolean;
  categoryFieldConfigurations: CategoryFieldConfiguration[];
  categoryHfmqPairConfigurations: CategoryHfmqPairConfiguration[];
}
export interface CategoryConfigurationDefinitionResponse {
  /** @format int32 */
  id: number;
  sectionType: ConfigurationSectionType;
  fieldType: ConfigurationFieldType;
  dataType: ConfigurationDataType;
  title: string;
  description?: string | null;
  /** @format int32 */
  position: number;
}
export interface CategoryConfigurationDefinitionResponseCollectionResponse {
  messages?: string[] | null;
  data: CategoryConfigurationDefinitionResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CategoryFieldConfiguration {
  /** @format int32 */
  categoryFieldConfigurationId: number;
  /** @format int32 */
  calculationId: number;
  /** @format int64 */
  categoryId: number;
  /** @format int32 */
  categoryConfigurationDefinitionId: number;
  skuTypeId?: SkuType | null;
  value: string;
  calculation: Calculation;
  category: Category;
  categoryConfigurationDefinition: CategoryConfigurationDefinition;
}
export interface CategoryFieldConfigurationResponse {
  skuType?: SkuType | null;
  fieldType: ConfigurationFieldType;
  value: string;
  /** @format int64 */
  categoryId: number;
}
export interface CategoryFieldConfigurationResponseCollectionResponse {
  messages?: string[] | null;
  data: CategoryFieldConfigurationResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CategoryHfmqPairConfiguration {
  /** @format int32 */
  categoryHfmqPairConfigurationId: number;
  /** @format int32 */
  calculationId: number;
  /** @format int64 */
  categoryId: number;
  /** @format int32 */
  categoryConfigurationDefinitionId: number;
  /** @format int32 */
  pairSequence: number;
  /** @format double */
  priceUpTo: number;
  /** @format int32 */
  minPercentageOfTotalSupply: number;
  calculation: Calculation;
  category: Category;
  categoryConfigurationDefinition: CategoryConfigurationDefinition;
}
export interface CategoryHierarchy {
  /** @format int32 */
  categoryHierarchyId: number;
  /** @format int64 */
  superiorCategoryId: number;
  /** @format int64 */
  subordinateCategoryId: number;
  /** @format int32 */
  superiorCategoryLevel: number;
  /** @format int32 */
  subordinateCategoryLevel: number;
  superiorCategory: Category;
  subordinateCategory: Category;
}
export interface CategoryInsightsResponse {
  summaries: CategorySummaryResponse[];
  categoryRedistributions?: CategoryRedistributionResponse[] | null;
  attributeValues: CategoryAttributeValueResponse[];
}
export interface CategoryInsightsResponseDataResponse {
  messages?: string[] | null;
  data: CategoryInsightsResponse;
}
export interface CategoryRedistribution {
  /** @format int32 */
  calculationId: number;
  /** @format int64 */
  categoryId: number;
  skuTypeId: SkuType;
  /** @format double */
  sourceStandardValue: number;
  /** @format double */
  sourceForcedValue: number;
  /** @format double */
  targetForecastValue: number;
  /** @format double */
  targetMinLayersValue: number;
  /** @format double */
  targetTargetListValue: number;
  /** @format double */
  targetEnhancedForecastValue: number;
  /** @format double */
  targetOthersValue: number;
  /** @format double */
  sendToStockoutValue: number;
  calculation: Calculation;
  category: Category;
}
export interface CategoryRedistributionResponse {
  skuTypeId: SkuType;
  categoryRedistributionTypeId: CategoryRedistributionType;
  /** @format double */
  value: number;
}
export interface CategoryResponse {
  /** @format int64 */
  id: number;
  /** @format int64 */
  parentCategoryId?: number | null;
  /** @format int32 */
  level: number;
  title: string;
  code?: string | null;
  customerCategoryId?: string | null;
}
export interface CategoryResponseCollectionResponse {
  messages?: string[] | null;
  data: CategoryResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CategorySkuCountResponse {
  /** @format int64 */
  id: number;
  /** @format int64 */
  parentCategoryId?: number | null;
  /** @format int32 */
  level: number;
  title: string;
  code?: string | null;
  customerCategoryId?: string | null;
  /** @format int32 */
  skuCount: number;
  /** @format int32 */
  enabledSkuCount: number;
}
export interface CategorySkuCountResponseCollectionResponse {
  messages?: string[] | null;
  data: CategorySkuCountResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CategorySummary {
  /** @format int32 */
  calculationId: number;
  /** @format int64 */
  categoryId: number;
  skuTypeId: SkuType;
  /** @format double */
  eligibleAvailableSupplyValue: number;
  /** @format double */
  eligibleMonthlyRevenueSalePriceValue: number;
  /** @format double */
  eligableMonthlyRevenueStockPriceValue: number;
  /** @format double */
  eligibleSourceSkuCount: number;
  /** @format double */
  eligibleSourceSupplyValue: number;
  /** @format double */
  eligibleTargetSkuCount: number;
  /** @format double */
  targetSupplyForTheoreticalPotentialValue: number;
  /** @format double */
  openPurchaseOrdersForTheoreticalPotentialValue: number;
  /** @format double */
  incomingForTheoreticalPotentialValue: number;
  /** @format double */
  forcedValue: number;
  /** @format double */
  healthyValue: number;
  /** @format double */
  outgoingValue: number;
  /** @format double */
  excessiveBlockedByMinLayersValue: number;
  /** @format double */
  excessiveBlockedByFirstPurchaseDateValue: number;
  /** @format double */
  excessiveBlockedByLastPurchaseDateValue: number;
  /** @format double */
  excessiveBlockedByMinValue: number;
  /** @format double */
  excessiveBlockedByMinProductPurchasePrice: number;
  /** @format double */
  excessiveBlockedByForecastValue: number;
  /** @format double */
  excessiveBlockedByMinimalQuantityValue: number;
  /** @format double */
  excessiveBlockedByMinimalSetValue: number;
  /** @format double */
  excessiveBlockedByHfmqValue: number;
  /** @format double */
  excessiveBlockedByTargetValue: number;
  /** @format double */
  excessivePotentialTotalValue: number;
  /** @format double */
  excessivePotentialNotAddressableValue: number;
  /** @format double */
  theoreticalPotentialValue: number;
  /** @format double */
  theoreticalPotentialStockoutValue: number;
  /** @format double */
  targetPotentialOverreachingSourceValue: number;
  /** @format double */
  targetPotentialUnfulfilledWithAnySourceValue: number;
  /** @format double */
  targetPotentialEndorsedByForecastValue: number;
  /** @format double */
  targetPotentialEndorsedByMinimalLayersValue: number;
  /** @format double */
  targetPotentialEndorsedByTargetListsValue: number;
  calculation: Calculation;
  category: Category;
}
export interface CategorySummaryResponse {
  skuTypeId: SkuType;
  categorySummaryTypeId: CategorySummaryType;
  /** @format double */
  value: number;
}
export interface CategoryWarehouseOverviewItemResponse {
  overviewValueTypeId: OverviewValueType;
  categoryWarehouseOverviewTypeId: CategoryWarehouseOverviewType;
  /** @format double */
  value?: number | null;
}
export interface CategoryWarehouseOverviewResponse {
  warehouse: WarehouseResponse;
  overviews: CategoryWarehouseOverviewItemResponse[];
}
export interface CategoryWarehouseOverviewResponseCollectionResponse {
  messages?: string[] | null;
  data: CategoryWarehouseOverviewResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CommandQueue {
  /** @format int32 */
  commandQueueId: number;
  /** @format int32 */
  calculationId?: number | null;
  commandTypeId: CommandType;
  createdByComponentTypeId: ComponentType;
  commandQueueStatusId: CommandQueueStatus;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  startedAt?: string | null;
  /** @format date-time */
  finishedAt?: string | null;
  identityUser?: IdentityUserInfo | null;
  additionalInfoJson?: string | null;
  failureReason?: string | null;
  calculation?: Calculation | null;
  incrementImports: IncrementImport[];
}
export interface ComputationSplit {
  /** @format int32 */
  computationSplitId: number;
  /** @format date-time */
  createdAt: string;
  isLast: boolean;
  isUsedInCalculation: boolean;
  attributeValues: AttributeValue[];
  entityListVersions: EntityListVersion[];
  forecasts: Forecast[];
  productComputationSplits: ProductComputationSplit[];
}
export interface Condition {
  fieldName?: string;
  operation?: Operation | null;
  value?: any;
  rawQuery?: string | null;
  logicalOperator?: LogicalOperator | null;
}
/**
 * One row of the specification the validators read, for the screens to read the same numbers:
 * the kind, the bounds, or the closed set of values. A field with no row is not checked.
 */
export interface ConfigurationFieldSpecificationResponse {
  /** Which table a specification row belongs to; the key is that table's enum member name. */
  owner: ConfigurationFieldOwner;
  /** @minLength 1 */
  key: string;
  kind: ConfigurationValueKind;
  /** @format double */
  minimum?: number | null;
  /** @format double */
  maximum?: number | null;
  allowedValues?: number[] | null;
  /**
   * How many decimal places a Decimal field keeps; null when it is not limited.
   * @format int32
   */
  decimalPlaces?: number | null;
}
export interface ConfigurationFieldSpecificationResponseCollectionResponse {
  messages?: string[] | null;
  data: ConfigurationFieldSpecificationResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface ConfigurationFieldUsageResponse {
  fieldType: ConfigurationFieldType;
  title: string;
  sectionType: ConfigurationSectionType;
}
export interface ConfigurationRule {
  /** @format int32 */
  configurationRuleId: number;
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  priority: number;
  description?: string | null;
  storeTypeScopeModeId: ConfigurationRuleScopeMode;
  storeScopeModeId: ConfigurationRuleScopeMode;
  departmentScopeModeId: ConfigurationRuleScopeMode;
  regionScopeModeId: ConfigurationRuleScopeMode;
  calculation: Calculation;
  configurationRuleSetups: ConfigurationRuleSetup[];
  configurationRuleScopeDepartments: ConfigurationRuleScopeDepartment[];
  configurationRuleScopeRegions: ConfigurationRuleScopeRegion[];
  configurationRuleScopeStores: ConfigurationRuleScopeStore[];
  configurationRuleScopeStoreTypes: ConfigurationRuleScopeStoreType[];
}
export interface ConfigurationRuleCreateRequest {
  name?: string | null;
  scopes: ConfigurationRuleScopeRequest[];
  setupSet: ConfigurationRuleSetupRequest[];
}
export interface ConfigurationRuleReplaceRequest {
  name?: string | null;
  scopes: ConfigurationRuleScopeRequest[];
  setupSet: ConfigurationRuleSetupRequest[];
}
export interface ConfigurationRuleReplaceRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: ConfigurationRuleReplaceRequest | null;
}
export interface ConfigurationRuleResponse {
  /** @format int32 */
  id: number;
  /** @format int32 */
  priority: number;
  name?: string | null;
  scopes: ConfigurationRuleScopeResponse[];
  setupSet: ConfigurationRuleSetupResponse[];
}
export interface ConfigurationRuleResponseCollectionResponse {
  messages?: string[] | null;
  data: ConfigurationRuleResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface ConfigurationRuleResponseDataResponse {
  messages?: string[] | null;
  data: ConfigurationRuleResponse;
}
export interface ConfigurationRuleScopeDepartment {
  /** @format int32 */
  configurationRuleId: number;
  /** @format int32 */
  departmentId: number;
  configurationRule: ConfigurationRule;
  department: Department;
}
export interface ConfigurationRuleScopeRegion {
  /** @format int32 */
  configurationRuleId: number;
  /** @format int32 */
  regionId: number;
  configurationRule: ConfigurationRule;
  region: Region;
}
export interface ConfigurationRuleScopeRequest {
  entityType: ConfigurationRuleScopeEntityType;
  scopeMode: ConfigurationRuleScopeMode;
  /** The entity ids, from get_catalog; empty for All. */
  entityIds: number[];
}
export interface ConfigurationRuleScopeResponse {
  entityType: ConfigurationRuleScopeEntityType;
  scopeMode: ConfigurationRuleScopeMode;
  entityIds: number[];
}
export interface ConfigurationRuleScopeStore {
  /** @format int32 */
  configurationRuleId: number;
  /** @format int64 */
  storeId: number;
  configurationRule: ConfigurationRule;
  store: Warehouse;
}
export interface ConfigurationRuleScopeStoreType {
  /** @format int32 */
  configurationRuleId: number;
  /** @format int32 */
  storeTypeId: number;
  configurationRule: ConfigurationRule;
  storeType: WarehouseType;
}
export interface ConfigurationRuleSetup {
  /** @format int32 */
  configurationRuleId: number;
  setupTypeId: ConfigurationRuleSetupType;
  value: string;
  configurationRule: ConfigurationRule;
}
export interface ConfigurationRuleSetupCreateRequest {
  setupType: ConfigurationRuleSetupType;
  /** '0' or '1' for the three switches; a non-negative integer as text for the rest. */
  value: string;
}
export interface ConfigurationRuleSetupCreateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: ConfigurationRuleSetupCreateRequest | null;
}
export interface ConfigurationRuleSetupDeleteRequest {
  setupType: ConfigurationRuleSetupType;
  /** '0' or '1' for the three switches; a non-negative integer as text for the rest. */
  value: string;
}
export interface ConfigurationRuleSetupDeleteRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: ConfigurationRuleSetupDeleteRequest | null;
}
export interface ConfigurationRuleSetupRequest {
  setupType: ConfigurationRuleSetupType;
  /** '0' or '1' for the three switches; a non-negative integer as text for the rest. */
  value: string;
}
export interface ConfigurationRuleSetupResponse {
  setupType: ConfigurationRuleSetupType;
  value: string;
}
export interface ConfigurationRuleSetupUpdateRequest {
  setupType: ConfigurationRuleSetupType;
  /** '0' or '1' for the three switches; a non-negative integer as text for the rest. */
  value: string;
}
export interface ConfigurationRuleSetupUpdateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: ConfigurationRuleSetupUpdateRequest | null;
}
export interface ConfigurationRuleUpdateRequest {
  name?: string | null;
  /** @format int32 */
  priority?: number | null;
}
export interface ConfigurationRuleUpdateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: ConfigurationRuleUpdateRequest | null;
}
export interface ConversationCreateRequest {
  /**
   * @format uuid
   * @minLength 1
   */
  conversationId: string;
  /**
   * A list filter, not an authorization boundary - ownership is the creator.
   * @minLength 1
   */
  projectShortName: string;
  /** @maxLength 200 */
  title?: string | null;
}
export interface ConversationMessageCreateRequest {
  /**
   * @minLength 1
   * @maxLength 100000
   */
  prompt: string;
  /** @format uuid */
  turnId: string;
  screen?: ScreenContext | null;
}
export interface ConversationMessageResponse {
  /** @format int64 */
  id: number;
  conversationMessageRoleId: ConversationMessageRole;
  content: string;
  metadataJson?: string | null;
  contextJson?: string | null;
  /** @format date-time */
  createdAt: string;
}
export interface ConversationMessageResponseCollectionResponse {
  messages?: string[] | null;
  data: ConversationMessageResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface ConversationRenameRequest {
  /**
   * @minLength 1
   * @maxLength 200
   */
  title: string;
}
export interface ConversationResponse {
  /** @format uuid */
  id: string;
  title?: string | null;
  connector: string;
  conversationStatusId: ConversationStatus;
  /** @format uuid */
  turnId?: string | null;
  /** @format date-time */
  turnStartedAt?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  lastActivityAt: string;
}
export interface ConversationResponseCollectionResponse {
  messages?: string[] | null;
  data: ConversationResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface ConversationResponseDataResponse {
  messages?: string[] | null;
  data: ConversationResponse;
}
export interface CustomExportRun {
  /** @format int32 */
  customExportRunId: number;
  /** @format int32 */
  calculationId: number;
  status: CustomExportRunStatus;
  type: CustomExportRunType;
  /** @format date-time */
  createdAt: string;
  fileForDownloadUrl?: string | null;
  isLast: boolean;
  errorMessage?: string | null;
  /** @format int32 */
  originalCustomExportRunId?: number | null;
  calculation: Calculation;
  originalCustomExportRun?: CustomExportRun | null;
  customExportRunItems: CustomExportRunItem[];
  copiedCustomExportRuns: CustomExportRun[];
}
export interface CustomExportRunItem {
  /** @format int32 */
  customExportRunItemId: number;
  /** @format int32 */
  customExportRunId: number;
  requestData?: string | null;
  responseData?: string | null;
  status: CustomExportRunItemStatus;
  /** @format date-time */
  createdAt: string;
  fileForDownloadUrl?: string | null;
  /** @format int32 */
  originalCustomExportRunItemId?: number | null;
  customExportRun: CustomExportRun;
  originalCustomExportRunItem?: CustomExportRunItem | null;
}
export interface CustomExportRunItemResponse {
  /** @format int32 */
  id: number;
  /** @format int32 */
  customExportRunId: number;
  requestData?: string | null;
  responseData?: string | null;
  status: CustomExportRunItemStatus;
  /** @format date-time */
  createdAt: string;
  fileForDownloadUrl?: string | null;
  /** @format int32 */
  originalCustomExportRunItemId?: number | null;
}
export interface CustomExportRunItemResponseCollectionResponse {
  messages?: string[] | null;
  data: CustomExportRunItemResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CustomExportRunItemResponseDataResponse {
  messages?: string[] | null;
  data: CustomExportRunItemResponse;
}
export interface CustomExportRunPatchRequest {
  status?: CustomExportRunStatus | null;
}
export interface CustomExportRunPatchRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: CustomExportRunPatchRequest | null;
}
export interface CustomExportRunResponse {
  /** @format int32 */
  id: number;
  /** @format int32 */
  calculationId: number;
  status: CustomExportRunStatus;
  type: CustomExportRunType;
  /** @format date-time */
  createdAt: string;
  fileForDownloadUrl?: string | null;
  isLast: boolean;
  errorMessage?: string | null;
  /** @format int32 */
  originalCustomExportRunId?: number | null;
}
export interface CustomExportRunResponseCollectionResponse {
  messages?: string[] | null;
  data: CustomExportRunResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface CustomExportRunResponseDataResponse {
  messages?: string[] | null;
  data: CustomExportRunResponse;
}
export interface DefinitionForecastCleanup {
  /** @format int32 */
  definitionForecastCleanupId: number;
  /** @format int32 */
  forecastCleanupId: number;
  /** @format int64 */
  categoryId?: number | null;
  /** @format int64 */
  productId?: number | null;
  /** @format int32 */
  skuId?: number | null;
  /** @format int64 */
  warehouseId?: number | null;
  forecastCleanup: ForecastCleanup;
  category: Category;
  product: Product;
  sku: Sku;
  warehouse: Warehouse;
}
export interface DeleteRegionFlowGroupConfigurationRequest {
  regionIds: number[];
}
export interface DeleteRegionFlowGroupRequest {
  regionFlowGroupIds: number[];
}
export interface Department {
  /** @format int32 */
  departmentId: number;
  customerDepartmentId?: string | null;
  name?: string | null;
  papInputDepartment?: PapInputDepartment | null;
  configurationRuleScopeDepartments: ConfigurationRuleScopeDepartment[];
  storeDepartmentAttributeValues: StoreDepartmentAttributeValue[];
  papResultRoutes: PapResultRoute[];
  productAttributeValues: ProductAttributeValue[];
  products: Product[];
  routeExecutions: RouteExecution[];
}
export interface DepartmentResponse {
  /** @format int32 */
  id: number;
  name: string;
  customerDepartmentId?: string | null;
}
export interface DepartmentResponseCollectionResponse {
  messages?: string[] | null;
  data: DepartmentResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface EntityList {
  /** @format int32 */
  entityListId: number;
  entityListSourceTypeId: EntityListSourceType;
  customerEntityListId?: string | null;
  name?: string | null;
  description?: string | null;
  /** @format int32 */
  latestEntityListVersionId?: number | null;
  isArchived: boolean;
  /** @format date */
  scheduledArchiveOn?: string | null;
  /** @format date-time */
  archivedAt?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  lastContentUpdatedAt?: string | null;
  isSoftDeleted: boolean;
  /** @format date-time */
  softDeletedAt?: string | null;
  isDataDeleted: boolean;
  /** @format date-time */
  dataDeletedAt?: string | null;
  isDefault: boolean;
  latestEntityListVersion: EntityListVersion;
  entityListImport?: EntityListImport | null;
  entityListTypeAssignments: EntityListTypeAssignment[];
  entityListImportItems: EntityListImportItem[];
  entityListVersions: EntityListVersion[];
  entityListConfigurations: EntityListConfiguration[];
  asoScenarioComputes: AsoScenarioCompute[];
  requestListCalculationConfigurations: CalculationConfiguration[];
  shortTermForecastEntityListInputs: ShortTermForecastEntityListInput[];
}
export interface EntityListConfiguration {
  /** @format int32 */
  entityListConfigurationId: number;
  /** @format int32 */
  calculationId: number;
  /** @format int64 */
  categoryId: number;
  /** @format int32 */
  entityListId: number;
  skuTypeId?: SkuType | null;
  /** @format int32 */
  categoryConfigurationDefinitionId: number;
  isEnabled: boolean;
  calculation: Calculation;
  category: Category;
  categoryConfigurationDefinition: CategoryConfigurationDefinition;
  entityList: EntityList;
}
export interface EntityListCreateRequest {
  /** @minLength 1 */
  name: string;
  description?: string | null;
  /** @format date */
  scheduledArchiveOn?: string | null;
  /** @minItems 1 */
  entityListTypeNames: EntityListTypeName[];
  customerEntityListId?: string | null;
}
export interface EntityListCreateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: EntityListCreateRequest | null;
}
export interface EntityListHoldersResponse {
  scopes: EntityListScopeHolderResponse[];
  asoScenarios: AsoScopeUsageContextResponse[];
  shortTermForecasts: EntityListShortTermForecastHolderResponse[];
  isHeldByDeletedCalculation: boolean;
}
export interface EntityListHoldersResponseDataResponse {
  messages?: string[] | null;
  data: EntityListHoldersResponse;
}
export interface EntityListImport {
  /** @format int32 */
  entityListId: number;
  storeIdentificationTypeId?: EntityIdentificationType | null;
  productIdentificationTypeId?: EntityIdentificationType | null;
  apiAction: ApiOperationType;
  identityUserId: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  verificationTimeStamp: string;
  entityList: EntityList;
}
export interface EntityListImportItem {
  /** @format int32 */
  entityListId: number;
  /** @format int32 */
  sequence: number;
  productIdentification?: string | null;
  /** @format int64 */
  productId?: number | null;
  storeIdentification?: string | null;
  /** @format int64 */
  storeId?: number | null;
  /** @format int32 */
  skuId?: number | null;
  /** @format int32 */
  quantity?: number | null;
  entityListImportActionCode: EntityListImportAction;
  entityList: EntityList;
}
export interface EntityListImportItemResponse {
  /** @format int32 */
  sequence: number;
  productIdentification?: string | null;
  product?: ProductResponse | null;
  storeIdentification?: string | null;
  store?: StoreResponse | null;
  sku?: SkuBaseResponse | null;
  /** @format int32 */
  quantity?: number | null;
  entityListImportActionCode: EntityListImportAction;
}
export interface EntityListImportItemResponseCollectionResponse {
  messages?: string[] | null;
  data: EntityListImportItemResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface EntityListImportItemsRequest {
  /** @format date-time */
  verificationTimeStamp: string;
  missingSkuHandling?: MissingSkuHandling | null;
  /** When supplied, confirmation refuses changes to the validation represented by this preview identity. */
  ignoreValidationToken?: string | null;
  importItemsEncodedBase64: string;
}
export interface EntityListImportRequest {
  /** @format date-time */
  verificationTimeStamp: string;
  missingSkuHandling?: MissingSkuHandling | null;
  /** When supplied, confirmation refuses changes to the validation represented by this preview identity. */
  ignoreValidationToken?: string | null;
  storeIdentificationTypeId?: EntityIdentificationType | null;
  productIdentificationTypeId?: EntityIdentificationType | null;
  apiOperationType: ApiOperationType;
}
export interface EntityListImportResponse {
  storeIdentificationTypeId?: EntityIdentificationType | null;
  productIdentificationTypeId?: EntityIdentificationType | null;
  apiAction: ApiOperationType;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  verificationTimeStamp: string;
  user: UserResponse;
}
export interface EntityListImportResponseDataResponse {
  messages?: string[] | null;
  data: EntityListImportResponse;
}
export interface EntityListImportSummariesResponse {
  summaries: EntityListImportSummaryResponse[];
  /** @format int32 */
  totalSkusToBeEnabled: number;
  /** @format int32 */
  totalSkusToBeCreated: number;
  /**
   * Items Ignore removes; Product lists count products without any enabled current SKU attributes.
   * @format int32
   */
  totalNotActiveItems: number;
  /** @format int32 */
  totalItemsAfterIgnore: number;
  ignoreValidationToken: string;
}
export interface EntityListImportSummariesResponseDataResponse {
  messages?: string[] | null;
  data: EntityListImportSummariesResponse;
}
export interface EntityListImportSummaryResponse {
  entityListImportAction: EntityListImportAction;
  /** @format int32 */
  itemCount: number;
}
export interface EntityListImportVerificationRequest {
  /** @format date-time */
  verificationTimeStamp: string;
  missingSkuHandling?: MissingSkuHandling | null;
  /** When supplied, confirmation refuses changes to the validation represented by this preview identity. */
  ignoreValidationToken?: string | null;
}
export interface EntityListItemResponse {
  category?: CategoryResponse | null;
  product?: ProductResponse | null;
  store?: StoreResponse | null;
  department?: DepartmentResponse | null;
  sku?: SkuBaseResponse | null;
  /** @format int32 */
  quantity?: number | null;
}
export interface EntityListItemResponseCollectionResponse {
  messages?: string[] | null;
  data: EntityListItemResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
/** The items of one list version; a version whose data were deleted returns its pair and no items. */
export interface EntityListItemResponseEntityListVersionItemsResponse {
  messages?: string[] | null;
  data: EntityListItemResponse[];
  /** @format int32 */
  totalCount?: number | null;
  isDataDeleted: boolean;
  /** @format date-time */
  dataDeletedAt?: string | null;
}
export interface EntityListRequestItem {
  /** @format int32 */
  entityListVersionId: number;
  /** @format int32 */
  skuId: number;
  /** @format int32 */
  quantity: number;
  entityListVersion: EntityListVersion;
  sku: Sku;
}
export interface EntityListResponse {
  /** @format int32 */
  entityListId: number;
  /** @format int32 */
  lastEntityListVersionNumber: number;
  /** @format int32 */
  lastEntityListVersionId: number;
  entityListSourceTypeId: EntityListSourceType;
  customerEntityListId?: string | null;
  name?: string | null;
  description?: string | null;
  /** @format int32 */
  productCount: number;
  /** @format int32 */
  storeCount: number;
  /** @format int32 */
  departmentCount: number;
  /** @format int32 */
  storeDepartmentCount: number;
  /** @format int32 */
  skuCount: number;
  isArchived: boolean;
  /** @format date */
  scheduledArchiveOn?: string | null;
  /** @format date-time */
  archivedAt?: string | null;
  isDataDeleted: boolean;
  /** @format date-time */
  dataDeletedAt?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  lastUpdatedAt: string;
  isDeletable: boolean;
  isArchivable: boolean;
  isEditable: boolean;
  isDefault: boolean;
  entityListImport?: EntityListImportResponse | null;
  entityListTypes: EntityListTypeResponse[];
}
export interface EntityListResponseCollectionResponse {
  messages?: string[] | null;
  data: EntityListResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface EntityListResponseDataResponse {
  messages?: string[] | null;
  data: EntityListResponse;
}
export interface EntityListScopeHolderResponse {
  /** @format int32 */
  scopeId: number;
  name: string;
}
export interface EntityListShortTermForecastHolderResponse {
  /** @format int32 */
  shortTermForecastId: number;
  name: string;
}
export interface EntityListSkuResponse {
  /** @format int32 */
  entityListId: number;
  /** @format int32 */
  entityListVersionId: number;
  customerEntityListId?: string | null;
  /** @format int32 */
  version: number;
  name?: string | null;
  /** @format int32 */
  quantity?: number | null;
  isArchived: boolean;
  isDataDeleted: boolean;
  /** @format date-time */
  dataDeletedAt?: string | null;
  entityListTypes: EntityListTypeResponse[];
  entityListSourceType: EntityListSourceType;
}
export interface EntityListSkuResponseCollectionResponse {
  messages?: string[] | null;
  data: EntityListSkuResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface EntityListType {
  /** @format int32 */
  entityListTypeId: number;
  entityListTypeName: EntityListTypeName;
  entityListItemTypeKey: EntityListItemType;
  mustHaveDefaultList: boolean;
}
export interface EntityListTypeAssignment {
  /** @format int32 */
  entityListId: number;
  /** @format int32 */
  entityListTypeId: number;
  entityList: EntityList;
  entityListType: EntityListType;
}
export interface EntityListTypeResponse {
  /** @format int32 */
  entityListTypeId: number;
  entityListTypeName: EntityListTypeName;
  entityListItemType: EntityListItemType;
  mustHaveDefaultList: boolean;
}
export interface EntityListTypeResponseCollectionResponse {
  messages?: string[] | null;
  data: EntityListTypeResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface EntityListUnarchivePreviewResponse {
  isComputationRequired: boolean;
}
export interface EntityListUnarchivePreviewResponseDataResponse {
  messages?: string[] | null;
  data: EntityListUnarchivePreviewResponse;
}
export interface EntityListUpdateRequest {
  name?: string | null;
  description?: string | null;
  /** @format date */
  scheduledArchiveOn?: string | null;
  isArchived?: boolean | null;
  isComputationConfirmed?: boolean | null;
  entityListTypeNames?: EntityListTypeName[] | null;
}
export interface EntityListUpdateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: EntityListUpdateRequest | null;
}
export interface EntityListVersion {
  /** @format int32 */
  entityListVersionId: number;
  /** @format int32 */
  computationSplitId?: number | null;
  /** @format int32 */
  entityListId: number;
  /** @format date-time */
  createdAt: string;
  /** @format int32 */
  versionNumber: number;
  isUsedInCalculation: boolean;
  isLast: boolean;
  isDataDeleted: boolean;
  /** @format date-time */
  dataDeletedAt?: string | null;
  /** @format int32 */
  productCountOverview: number;
  /** @format int32 */
  storeCountOverview: number;
  /** @format int32 */
  departmentCountOverview: number;
  /** @format int32 */
  storeDepartmentCountOverview: number;
  /** @format int32 */
  skuCountOverview: number;
  computationSplit: ComputationSplit;
  entityList: EntityList;
  entityListVersionConfigurations: EntityListVersionConfiguration[];
}
export interface EntityListVersionConfiguration {
  /** @format int32 */
  entityListVersionConfigurationId: number;
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  entityListVersionId: number;
  /** @format int32 */
  discriminator: number;
  isEnabled: boolean;
  calculation: Calculation;
  entityListVersion: EntityListVersion;
}
export interface ErrorResponse {
  Messages: string[];
  Problems: ValidationProblemResponse[];
}
/** Information about the execution status of a redistribution */
export interface ExecutionStatusResponse {
  /**
   * Total value of the redistribution
   * @format double
   */
  totalProposedValue: number;
  /**
   * Value of the picking positions that have been shipped from source stores
   * @format double
   */
  shippedValue: number;
  /**
   * Value of the picking positions that have been delivered to destination stores
   * @format double
   */
  deliveredValue: number;
  /**
   * Proposed value of the finished routes
   * @format double
   */
  finishedRoutesProposedValue: number;
  /**
   * Value of the picking positions that have yet to be shipped from source stores
   * @format double
   */
  remainingToShipValue: number;
  /**
   * The maximum potential value achievable upon completion of execution
   * @format double
   */
  maxExecutionPotentialValue: number;
  /** @format double */
  shippedValueToTotalProposedValueRate: number;
  /** @format double */
  shippedValueToFinishedRoutesProposedValueRate: number;
  /** @format double */
  deliveredValueToTotalProposedValueRate: number;
  /** @format double */
  deliveredValueToFinishedRoutesProposedValueRate: number;
  /** @format double */
  remainingToShipValueToTotalProposedValueRate: number;
  /** @format double */
  maxExecutionPotentialValueToTotalProposedValueRate: number;
}
export interface FieldConfigurationDeleteRequest {
  configurationFieldType: ConfigurationFieldType;
  skuType: SkuType | null;
}
export interface FieldConfigurationRequest {
  configurationFieldType: ConfigurationFieldType;
  skuType?: SkuType | null;
  value: string;
}
export interface Forecast {
  /** @format int32 */
  forecastId: number;
  /** @format int32 */
  computationSplitId?: number | null;
  /** @format int32 */
  forecastJobId?: number | null;
  /** @format date */
  applicationDate: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  code?: string | null;
  dataRetrievalStatusId: DataRetrievalStatus;
  isLast: boolean;
  isUsedInCalculation: boolean;
  hasMiddleForecast: boolean;
  computationSplit?: ComputationSplit | null;
  calculations: Calculation[];
  skuForecasts: SkuForecast[];
}
export interface ForecastCleanup {
  /** @format int32 */
  forecastCleanupId: number;
  customerForecastCleanupId: string;
  dataJson: string;
  description: string;
  definitionForecastCleanups: DefinitionForecastCleanup[];
}
export interface ForecastJob {
  /** @format int32 */
  jobId: number;
  /** @format int32 */
  skuId: number;
  sku: Sku;
}
export interface ForecastMonthlyOverviewResponse {
  monthInterval: MonthIntervalResponse;
  overviews: ForecastValueResponse[];
}
export interface ForecastMonthlyOverviewResponseCollectionResponse {
  messages?: string[] | null;
  data: ForecastMonthlyOverviewResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface ForecastValueResponse {
  overviewValueType: OverviewValueType;
  transactionOverviewType: TransactionOverviewType;
  /** @format double */
  value: number;
  /** @format int32 */
  outlookMonth: number;
  /** @format int32 */
  confidence: number;
}
export interface HintResponse {
  applicationHintType: ApplicationHintType;
  key: string;
  value: string;
}
export interface HintResponseCollectionResponse {
  messages?: string[] | null;
  data: HintResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface IdentityUserInfo {
  id?: string | null;
  email?: string | null;
  fullName?: string | null;
}
/**
 * Triggers the deferred import of the SkuPotential debug rows (data-debug.csv) for a calculation.
 * Called by the wrapper once the calculation is already Completed and announced, and only when it
 * asked for debug rows. ProjectCode is resolved from the Project-Code header / identity provider,
 * not from the body.
 */
export interface ImportSkuPotentialDebugTriggerRequest {
  /** @format int32 */
  calculationId: number;
}
export interface IncrementImport {
  /** @format int32 */
  incrementImportId: number;
  /** @format int32 */
  commandQueueId?: number | null;
  /** @format int32 */
  attributeValueId: number;
  /** @format int32 */
  skuCount: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  finishedAt?: string | null;
  commandQueue?: CommandQueue | null;
  incrementImportSkus: IncrementImportSku[];
}
export interface IncrementImportSku {
  /** @format int32 */
  incrementImportId: number;
  /** @format int32 */
  skuId: number;
  isCreated: boolean;
  incrementImport: IncrementImport;
  sku: Sku;
}
export interface MonthIntervalResponse {
  /** @format int32 */
  month: number;
  /** @format int32 */
  year: number;
  /** @format date */
  dateFrom: string;
  /** @format date */
  dateTo: string;
}
export interface NonSaleDailyOverviewResponse {
  /** @format date */
  day: string;
  nonSaleOverviews: NonSaleOverviewResponse[];
}
export interface NonSaleDailyOverviewResponseCollectionResponse {
  messages?: string[] | null;
  data: NonSaleDailyOverviewResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface NonSaleOverviewResponse {
  /** @format int32 */
  quantity: number;
  customerTypeId: string;
}
export interface OpenPurchaseOrder {
  /** @format int32 */
  skuId: number;
  /** @format date */
  orderDate: string;
  /** @format date */
  deliveryDate: string;
  /** @format int32 */
  quantity: number;
  sku: Sku;
}
export interface PackingPictureResponse {
  /** @format int32 */
  boxNumber: number;
  packingPictureTypeIds: PapPackingPictureType[];
}
export interface PapAuditLog {
  /** @format int32 */
  papAuditLogId: number;
  entryId: string;
  /** @format date-time */
  entryStartedAt: string;
  /** @format date-time */
  entryEndedAt: string;
  /** @format uuid */
  sessionId: string;
  currentScreenKey?: string | null;
  transitionKey?: string | null;
  nextScreenKey: string;
  browseModeKey?: string | null;
  /** @format int32 */
  calculationId?: number | null;
  /** @format int64 */
  sourceStoreId: number;
  /** @format int64 */
  targetStoreId?: number | null;
  /** @format int32 */
  sourceSkuId?: number | null;
  /** @format int32 */
  targetSkuId?: number | null;
  /** @format int32 */
  pickedQuantity?: number | null;
  isBarcodeScannerUsed?: boolean | null;
  /** @format int32 */
  pickingIssueId?: number | null;
  isMeasured: boolean;
  calculation?: Calculation | null;
  pickingIssue?: PapRedistributionIssue | null;
  sourceSku?: Sku | null;
  targetSku?: Sku | null;
  sourceStore: Warehouse;
  targetStore?: Warehouse | null;
}
export interface PapInputCalculation {
  /** @format int32 */
  papInputCalculationId: number;
  displayId: string;
  name: string;
  description?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date */
  finishExecutionUntil: string;
  calculation: Calculation;
  papInputRoutes: PapInputRoute[];
  papInputSkuRedistributions: PapInputSkuRedistribution[];
}
export interface PapInputDepartment {
  /** @format int32 */
  papInputDepartmentId: number;
  displayId: string;
  name?: string | null;
  department: Department;
  sourcePapInputRoutes: PapInputRoute[];
}
export interface PapInputProduct {
  /** @format int64 */
  papInputProductId: number;
  displayId: string;
  name?: string | null;
  brandName: string;
  /** @format int32 */
  papInputDepartmentId: number;
  categoryPath: string;
  picturePath: string;
  /** @format float */
  widthMillimeters: number;
  /** @format float */
  lengthMillimeters: number;
  /** @format float */
  heightMillimeters: number;
  /** @format float */
  weightGrams: number;
  pictureUrl?: string | null;
  /** @format date-time */
  pictureValidityTimestamp?: string | null;
  product: Product;
  papInputDepartment: PapInputDepartment;
  papInputSkus: PapInputSku[];
  papInputProductEans: PapInputProductEan[];
}
export interface PapInputProductEan {
  /** @format int64 */
  papInputProductId: number;
  ean: string;
  /** @format int32 */
  quantity: number;
  papInputProduct: PapInputProduct;
}
export interface PapInputRoute {
  /** @format int32 */
  papInputCalculationId: number;
  /** @format int32 */
  sourcePapInputDepartmentId: number;
  /** @format int64 */
  sourcePapInputStoreId: number;
  /** @format int64 */
  targetPapInputStoreId: number;
  /** @format double */
  minimalRouteValue: number;
  papInputCalculation: PapInputCalculation;
  sourcePapInputDepartment: PapInputDepartment;
  sourcePapInputStore: PapInputStore;
  targetPapInputStore: PapInputStore;
}
export interface PapInputSku {
  /** @format int32 */
  papInputSkuId: number;
  /** @format int64 */
  papInputProductId: number;
  /** @format int64 */
  papInputStoreId: number;
  /** @format int32 */
  availableSupply: number;
  /** @format double */
  salePriceWithVat: number;
  /** @format int32 */
  pickingSequence: number;
  planogramName: string;
  planogramPositions: string;
  sku: Sku;
  papInputProduct: PapInputProduct;
  papInputStore: PapInputStore;
  sourcePapInputSkuRedistributions: PapInputSkuRedistribution[];
  targetPapInputSkuRedistributions: PapInputSkuRedistribution[];
}
export interface PapInputSkuRedistribution {
  /** @format int32 */
  papInputCalculationId: number;
  /** @format int32 */
  sourcePapInputSkuId: number;
  /** @format int32 */
  targetPapInputSkuId: number;
  /** @format int32 */
  quantity: number;
  /** @format int32 */
  availableSupply: number;
  /** @format int32 */
  minimumSupply: number;
  /** @format double */
  sourceStockPrice: number;
  redistributionReason: string;
  descriptionTitle?: string | null;
  descriptionNote?: string | null;
  /** @format int32 */
  minimalSet: number;
  /** @format int32 */
  papRedistributionIssueSetId: number;
  papInputCalculation: PapInputCalculation;
  sourcePapInputSku: PapInputSku;
  targetPapInputSku: PapInputSku;
  papRedistributionIssueSet: PapRedistributionIssueSet;
}
export interface PapInputStore {
  /** @format int64 */
  papInputStoreId: number;
  displayId: string;
  name?: string | null;
  /** @format int32 */
  pickingTimePerPositionSeconds: number;
  /** @format int32 */
  pickingTimeToFinalizeSeconds: number;
  locale: string;
  isDistributionCenter: boolean;
  store: Warehouse;
  papInputSkus: PapInputSku[];
  sourcePapInputRoutes: PapInputRoute[];
  targetPapInputRoutes: PapInputRoute[];
}
export interface PapPackingPicture {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  departmentId: number;
  /** @format int64 */
  sourceStoreId: number;
  /** @format int64 */
  targetStoreId: number;
  /** @format int32 */
  boxNumber: number;
  papPackingPictureTypeId: PapPackingPictureType;
  url: string;
  calculation: Calculation;
  department: Department;
  sourceStore: Warehouse;
  targetStore: Warehouse;
}
export interface PapPerformance {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  sourceSkuId: number;
  /** @format int32 */
  targetSkuId: number;
  /** @format int32 */
  duration: number;
  /** @format int32 */
  durationTrimmed?: number | null;
  isOutlier: boolean;
  calculation: Calculation;
  sourceSku: Sku;
  targetSku: Sku;
}
export interface PapRedistributionIssue {
  /** @format int32 */
  papRedistributionIssueId: number;
  name: string;
  displayName: string;
  papRedistributionIssueTypeKey?: PapRedistributionIssueType | null;
  papAuditLogs: PapAuditLog[];
  papRedistributionIssueItemSets: PapRedistributionIssueItemSet[];
}
export interface PapRedistributionIssueItemSet {
  /** @format int32 */
  papRedistributionIssueSetId: number;
  /** @format int32 */
  papRedistributionIssueId: number;
  papRedistributionIssueSet: PapRedistributionIssueSet;
  papRedistributionIssue: PapRedistributionIssue;
}
export interface PapRedistributionIssueResponse {
  /** @format int32 */
  papRedistributionIssueId: number;
  name: string;
  displayName: string;
  papRedistributionIssueTypeKey?: PapRedistributionIssueType | null;
}
export interface PapRedistributionIssueSet {
  /** @format int32 */
  papRedistributionIssueSetId: number;
  name: string;
  papRedistributionIssueSets: PapRedistributionIssueItemSet[];
}
export interface PapResultCalculation {
  /** @format int32 */
  calculationId: number;
  papProgressStatusId: PapProgressStatus;
  calculation: Calculation;
}
export interface PapResultRoute {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  departmentId: number;
  /** @format int64 */
  sourceStoreId: number;
  /** @format int64 */
  targetStoreId: number;
  papProgressStatusId: PapProgressStatus;
  calculation: Calculation;
  department: Department;
  sourceStore: Warehouse;
  targetStore: Warehouse;
}
export interface PapResultRouteParameter {
  /** @format int32 */
  departmentId: number;
  /** @format int64 */
  sourceStoreId: number;
  /** @format int64 */
  targetStoreId: number;
  papProgressStatusId: PapProgressStatus;
}
export interface PapResultSkuRedistribution {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  sourceSkuId: number;
  /** @format int32 */
  targetSkuId: number;
  /** @format int32 */
  quantityRequested: number;
  /** @format int32 */
  quantityPicked: number;
  calculation: Calculation;
  sourceSku: Sku;
  targetSku: Sku;
}
export interface PapResultSkuRedistributionIssue {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  sourceSkuId: number;
  /** @format int32 */
  targetSkuId: number;
  /** @format int32 */
  papRedistributionIssueId: number;
  calculation: Calculation;
  papRedistributionIssue: PapRedistributionIssue;
  sourceSku: Sku;
  targetSku: Sku;
}
export interface PapSyncEvent {
  /** @format int32 */
  papSyncEventId: number;
  /** @format int32 */
  calculationId?: number | null;
  /** @format int32 */
  attributeValueId?: number | null;
  papSyncTypeId: PapSyncType;
  papSyncStatusId: PapSyncStatus;
  /** @format date-time */
  loggedAt: string;
  /** @format date-time */
  dataValidityTimestamp?: string | null;
  parameters?: PapSyncEventParameters | null;
  attributeValue: AttributeValue;
  calculation?: Calculation | null;
}
export interface PapSyncEventParameters {
  papResultRoute?: PapResultRouteParameter | null;
}
export interface Parameter {
  /** @format int32 */
  parameterId: number;
  parameterTypeId: ParameterType;
  customerParameterId: string;
  name: string;
  isPopular?: boolean | null;
  productParameters: ProductParameter[];
}
export interface PickingIssueInsightsResponse {
  /** @format int32 */
  count: number;
  papRedistributionIssue: PapRedistributionIssueResponse;
}
export interface PickingIssueResponse {
  /** @format int32 */
  sourceSkuId: number;
  /** @format int32 */
  targetSkuId: number;
  targetStore: StoreResponse;
  papRedistributionIssue: PapRedistributionIssueResponse;
  product: ProductResponse;
  /** @format int32 */
  quantityExecuted: number;
  /** @format int32 */
  quantityRequested: number;
  sourceStore?: StoreResponse | null;
}
export interface PickingIssueResponseCollectionResponse {
  messages?: string[] | null;
  data: PickingIssueResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface PickingPositionResponse {
  product: ProductResponse;
  /** @format int32 */
  sourceSkuId?: number | null;
  /** @format int32 */
  targetSkuId?: number | null;
  /** @format int32 */
  quantity: number;
  /** @format int32 */
  totalQuantityFromSourceSku: number;
  /** @format int32 */
  totalQuantityToTargetSku: number;
  /** @format int32 */
  targetAvailableSupply: number;
  /** @format int32 */
  sourceAvailableSupply: number;
  /** @format int32 */
  sourceOpenPurchaseOrdersQuantity: number;
  /** @format int32 */
  targetOpenPurchaseOrdersQuantity: number;
  /** @format int32 */
  sourceIncomingQuantity: number;
  /** @format int32 */
  targetIncomingQuantity: number;
  /** @format int32 */
  sourceOutgoingQuantity: number;
  /** @format int32 */
  targetOutgoingQuantity: number;
  /** @format int32 */
  sourceMinLayerQuantity: number;
  /** @format int32 */
  targetMinLayerQuantity: number;
  sourceIsInPotential: boolean;
  targetIsInPotential: boolean;
  parameters: ProductParameterResponse[];
}
export interface PickingPositionResponseCollectionResponse {
  messages?: string[] | null;
  data: PickingPositionResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface PickingProgressResponse {
  /** Base response for picking progress information */
  sourceStores: PickingProgressStatisticsResponse;
  /** Base response for picking progress information */
  routes: PickingProgressStatisticsResponse;
  /** @format double */
  rate: number;
  status: PickingProgressStatus;
}
/** Base response for picking progress information */
export interface PickingProgressStatisticsResponse {
  /** @format int32 */
  notStartedCount: number;
  /** @format int32 */
  inProgressCount: number;
  /** @format int32 */
  finishedCount: number;
  /** @format int32 */
  totalCount: number;
}
export interface PlannedOrder {
  /** @format int32 */
  plannedOrderId: number;
  /** @format int32 */
  skuId: number;
  /** @format date */
  orderDate: string;
  /** @format date */
  deliveryDate: string;
  /** @format int32 */
  quantity: number;
  sku: Sku;
}
export interface PreComputePotentialTriggerRequest {
  projectCode: string;
  /** @format int32 */
  calculationId?: number | null;
  /** @format int32 */
  templateId?: number | null;
}
export interface ProblemRelatedEntity {
  entityType: string;
  entityId?: string | null;
  role: string;
}
export interface ProblemTarget {
  entityType: string;
  entityId?: string | null;
}
export interface Product {
  /** @format int64 */
  productId: number;
  /** @format int64 */
  categoryId: number;
  /** @format int32 */
  brandId: number;
  /** @format int32 */
  departmentId: number;
  customerProductId?: string | null;
  name?: string | null;
  code?: string | null;
  /** @format double */
  weight?: number | null;
  /** @format double */
  volume?: number | null;
  pictureUrl?: string | null;
  /** @format date-time */
  pictureValidityTimestamp?: string | null;
  brand: Brand;
  category: Category;
  department: Department;
  papInputProduct?: PapInputProduct | null;
  storePerformanceProductKey?: StorePerformanceProductKey | null;
  definitionForecastCleanups: DefinitionForecastCleanup[];
  productComputationSplits: ProductComputationSplit[];
  productListItems: ProductListItem[];
  productCategories: ProductCategory[];
  productGroupItems: ProductGroupItem[];
  productParameters: ProductParameter[];
  skus: Sku[];
  skuRedistributions: SkuRedistribution[];
}
/** Snapshot details are absent when the status is Unknown. */
export interface ProductActivityResponse {
  status: ProductActivityStatus;
  /** @format date */
  applicationDate?: string | null;
  /** @format int32 */
  attributeValueId?: number | null;
}
export interface ProductActivityResponseDataResponse {
  messages?: string[] | null;
  /** Snapshot details are absent when the status is Unknown. */
  data: ProductActivityResponse;
}
export interface ProductAttributeValue {
  /** @format int32 */
  attributeValueId: number;
  /** @format int64 */
  productId: number;
  /** @format int32 */
  regionId: number;
  /** @format int32 */
  brandId: number;
  /** @format int32 */
  departmentId: number;
  /** @format date */
  dateOfFirstSale: string;
  /** @format date */
  dateOfLastSale: string;
  /** @format date */
  dateOfFirstPurchase: string;
  /** @format date */
  dateOfLastPurchase: string;
  /** @format int32 */
  availableSupply: number;
  /** @format int32 */
  saleQuantityTotal: number;
  /** @format double */
  saleValueTotal: number;
  /** @format double */
  availableStockPriceValue: number;
  /** @format double */
  availableSalePriceValue: number;
  /** @format int32 */
  openPurchaseOrdersQuantity: number;
  /** @format int32 */
  frequency6Month: number;
  /** @format int32 */
  frequency12Month: number;
  /** @format double */
  monthlyRevenueQuantity: number;
  /** @format double */
  monthlyRevenueSalePriceValue: number;
  /** @format int32 */
  skuCount: number;
  /** @format int32 */
  enabledSkuCount: number;
  attributeValue: AttributeValue;
  brand: Brand;
  department: Department;
  product: Product;
  region: Region;
}
export interface ProductCategory {
  /** @format int64 */
  categoryId: number;
  /** @format int64 */
  productId: number;
  /** @format int32 */
  level: number;
  category: Category;
  product: Product;
}
export interface ProductComputationSplit {
  /** @format int32 */
  computationSplitId: number;
  /** @format int64 */
  productId: number;
  /** @format int32 */
  potentialGroupCode: number;
  /** @format int32 */
  saleTransactionGroupCode: number;
  /** @format int32 */
  forecastGroupCode: number;
  computationSplit: ComputationSplit;
  product: Product;
}
export interface ProductGroup {
  /** @format int64 */
  productGroupId: number;
  /** @format int32 */
  productGroupTypeId: number;
  customerProductGroupId: string;
  productGroupType: ProductGroupType;
  productGroupItems: ProductGroupItem[];
}
export interface ProductGroupItem {
  /** @format int64 */
  productGroupId: number;
  /** @format int64 */
  productId: number;
  productGroup: ProductGroup;
  product: Product;
}
export interface ProductGroupResponse {
  /** @format int64 */
  id: number;
  customerId: string;
  productGroupTypeId: ProductGroupTypeKey;
  parameterTypes: ParameterType[];
}
export interface ProductGroupType {
  /** @format int32 */
  productGroupTypeId: number;
  key: ProductGroupTypeKey;
  parameterTypeIds: number[];
  productGroups: ProductGroup[];
}
export interface ProductList {
  /** @format int32 */
  productListId: number;
  customerProductListId?: string | null;
  name?: string | null;
  productListSourceTypeId: ProductListSourceType;
  /** @format int32 */
  currentProductListVersionId?: number | null;
  isArchived: boolean;
  currentProductListVersion: ProductListVersion;
  productListVersions: ProductListVersion[];
}
export interface ProductListConfiguration {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  productListVersionId: number;
  isEnabled: boolean;
  calculation: Calculation;
  productListVersion: ProductListVersion;
}
export interface ProductListConfigurationRequest {
  isEnabled: boolean;
}
export interface ProductListConfigurationResponse {
  /** @format int32 */
  productListId: number;
  /** @format int32 */
  lastProductListVersion: number;
  customerProductListId?: string | null;
  name?: string | null;
  productListSourceTypeId: EntityListSourceType;
  isArchived: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  lastUpdatedAt: string;
  /** @format int32 */
  productCount: number;
  isDeletable: boolean;
  isEnabled?: boolean | null;
  isConfigured: boolean;
  /** @format int32 */
  productListVersionId: number;
  isDataDeleted: boolean;
  /** @format date-time */
  dataDeletedAt?: string | null;
}
export interface ProductListConfigurationResponseCollectionResponse {
  messages?: string[] | null;
  data: ProductListConfigurationResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface ProductListConfigurationResponseDataResponse {
  messages?: string[] | null;
  data: ProductListConfigurationResponse;
}
export interface ProductListConfigurationUpdateRequest {
  isEnabled: boolean;
}
export interface ProductListConfigurationUpdateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: ProductListConfigurationUpdateRequest | null;
}
export interface ProductListItem {
  /** @format int32 */
  productListVersionId: number;
  /** @format int64 */
  productId: number;
  product: Product;
  productListVersion: ProductListVersion;
}
export interface ProductListResponse {
  /** @format int32 */
  productListId: number;
  /** @format int32 */
  lastProductListVersion: number;
  customerProductListId?: string | null;
  name?: string | null;
  productListSourceTypeId: EntityListSourceType;
  isArchived: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  lastUpdatedAt: string;
  /** @format int32 */
  productCount: number;
  isDeletable: boolean;
}
export interface ProductListResponseCollectionResponse {
  messages?: string[] | null;
  data: ProductListResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface ProductListVersion {
  /** @format int32 */
  productListVersionId: number;
  /** @format int32 */
  productListId: number;
  /** @format int32 */
  versionNumber: number;
  /** @format date-time */
  createdAt: string;
  isLast: boolean;
  productList: ProductList;
  productListConfigurations: ProductListConfiguration[];
  productListItems: ProductListItem[];
}
export interface ProductLookupRequest {
  identifiers?: string[] | null;
  productIds?: number[] | null;
}
export interface ProductLookupResponse {
  products: ProductResponse[];
  unrecognizedIdentifiers: string[];
}
export interface ProductLookupResponseDataResponse {
  messages?: string[] | null;
  data: ProductLookupResponse;
}
export interface ProductOverviewResponse {
  productAttributeValueTypeId: ProductAttributeValueType;
  value: string;
}
export interface ProductOverviewResponseCollectionResponse {
  messages?: string[] | null;
  data: ProductOverviewResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface ProductParameter {
  /** @format int64 */
  productId: number;
  /** @format int32 */
  parameterId: number;
  parameterTypeId: ParameterType;
  parameter: Parameter;
  product: Product;
}
export interface ProductParameterResponse {
  parameterTypeId: ParameterType;
  parameterName: string;
  customerParameterId: string;
  isPopular?: boolean | null;
}
export interface ProductResponse {
  /** @format int64 */
  id: number;
  customerId?: string | null;
  name: string;
  code: string;
  /** @format int64 */
  categoryId: number;
  allCategoryIds?: number[] | null;
  brand?: BrandResponse | null;
  compareType?: CompareType | null;
  department?: DepartmentResponse | null;
}
export interface ProductResponseCollectionResponse {
  messages?: string[] | null;
  data: ProductResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
/** The items of one list version; a version whose data were deleted returns its pair and no items. */
export interface ProductResponseEntityListVersionItemsResponse {
  messages?: string[] | null;
  data: ProductResponse[];
  /** @format int32 */
  totalCount?: number | null;
  isDataDeleted: boolean;
  /** @format date-time */
  dataDeletedAt?: string | null;
}
export interface PromoType {
  /** @format int32 */
  promoTypeId: number;
  customerPromoTypeId: string;
  name?: string | null;
  skuPromos: SkuPromo[];
}
export interface RecordImportItemsRequest {
  /** @format date-time */
  verificationTimeStamp: string;
  importItemsEncodedBase64: string;
}
export interface RecordImportVerificationRequest {
  /** @format date-time */
  verificationTimeStamp: string;
}
export interface Region {
  /** @format int32 */
  regionId: number;
  customerRegionId?: string | null;
  name?: string | null;
  configurationRuleScopeRegions: ConfigurationRuleScopeRegion[];
  storeDepartmentAttributeValues: StoreDepartmentAttributeValue[];
  regionFlowGroupConfigurations: RegionFlowGroupConfiguration[];
  sourceSkuRedistributionsExpanded: SkuRedistributionExpanded[];
  targetSkuRedistributionsExpanded: SkuRedistributionExpanded[];
  warehouses: Warehouse[];
}
export interface RegionFlowGroup {
  /** @format int32 */
  regionFlowGroupId: number;
  /** @format int32 */
  calculationId: number;
  calculation: Calculation;
  regionFlowGroupConfigurations: RegionFlowGroupConfiguration[];
}
export interface RegionFlowGroupConfiguration {
  /** @format int32 */
  regionFlowGroupId: number;
  /** @format int32 */
  regionId: number;
  regionFlowGroup: RegionFlowGroup;
  region: Region;
}
export interface RegionFlowGroupRequest {
  /** @minItems 1 */
  regionIds: number[];
}
export interface RegionFlowGroupRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: RegionFlowGroupRequest | null;
}
export interface RegionFlowGroupResponse {
  /** @format int32 */
  id: number;
  regions: RegionResponse[];
}
export interface RegionFlowGroupResponseCollectionResponse {
  messages?: string[] | null;
  data: RegionFlowGroupResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface RegionFlowGroupResponseDataResponse {
  messages?: string[] | null;
  data: RegionFlowGroupResponse;
}
export interface RegionResponse {
  /** @format int32 */
  id: number;
  name: string;
  customerRegionId?: string | null;
}
export interface RegionResponseCollectionResponse {
  messages?: string[] | null;
  data: RegionResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface RetiredCategoryFieldConfiguration {
  /** @format int32 */
  categoryId: number;
  skuType: SkuType;
  configurationFieldTypeCode: string;
  value: string;
}
export interface RetiredConfigurations {
  retiredCategoryFieldConfigurations?: RetiredCategoryFieldConfiguration[] | null;
}
export interface RouteExecution {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  departmentId: number;
  /** @format int64 */
  sourceStoreId: number;
  /** @format int64 */
  targetStoreId: number;
  isShipped: boolean;
  isDelivered: boolean;
  executionTypeId: ExecutionType;
  calculation: Calculation;
  department: Department;
  sourceStore: Warehouse;
  targetStore: Warehouse;
}
export interface RoutesByTargetStoreEvaluationRatesResponse {
  /** @format double */
  totalValue: number;
  /** @format double */
  shippedValue: number;
  /** @format double */
  shippedValueRate: number;
  /** @format double */
  deliveredValue: number;
  /** @format double */
  deliveredValueRate: number;
  /** @format int32 */
  totalPickingPositions: number;
  /** @format int32 */
  shippedPickingPositions: number;
  /** @format double */
  shippedPickingPositionsRate: number;
  status: RouteExecutionStatus;
}
export interface RoutesEvaluationRatesResponse {
  /** @format double */
  totalValue: number;
  /** @format double */
  shippedValue: number;
  /** @format double */
  shippedValueRate: number;
  /** @format double */
  deliveredValue: number;
  /** @format double */
  deliveredValueRate: number;
  /** @format int32 */
  totalRouteCount: number;
  /** @format int32 */
  finishedRouteCount: number;
  /** @format int32 */
  startedRouteCount: number;
  status: RouteExecutionStatus;
}
export interface RoutesExecutionSummaryResponse {
  /** @format int32 */
  totalQuantity: number;
  /** @format int32 */
  executedQuantity: number;
  /** @format double */
  totalValue: number;
  /** @format double */
  executedValue: number;
  /** @format int32 */
  totalSkuCount: number;
  /** @format int32 */
  executedSkuCount: number;
  /** @format int32 */
  totalRouteCount: number;
  /** @format int32 */
  executedRouteCount: number;
}
export interface SaleDailyOverviewResponse {
  /** @format date */
  day: string;
  quantities?: SaleQuantityResponse | null;
  prices?: SalePriceResponse | null;
}
export interface SaleDailyOverviewResponseCollectionResponse {
  messages?: string[] | null;
  data: SaleDailyOverviewResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface SaleMonthlyOverviewResponse {
  monthInterval: MonthIntervalResponse;
  overviews: TransactionValueResponse[];
}
export interface SaleMonthlyOverviewResponseCollectionResponse {
  messages?: string[] | null;
  data: SaleMonthlyOverviewResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface SalePriceResponse {
  /** @format double */
  regular: number;
  /** @format double */
  promo: number;
  /** @format double */
  sellout: number;
}
export interface SaleQuantityResponse {
  /** @format int32 */
  regular: number;
  /** @format int32 */
  promo: number;
  /** @format int32 */
  sellout: number;
}
export interface ScopeCreateRequest {
  /** @minLength 1 */
  name: string;
  isShared?: boolean | null;
  sections: ScopeSectionRequest[];
}
export interface ScopeCreateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: ScopeCreateRequest | null;
}
export interface ScopeEntityConfigurationResponse {
  /** @format int64 */
  warehouseId: number;
  /** @format int32 */
  departmentId: number;
  isEnabled: boolean;
  useAsSource: boolean;
  useAsTarget: boolean;
  /** @format int32 */
  maxNumberOfSourceStores: number;
  /** @format int32 */
  maxNumberOfTargetStores: number;
  /** @format int32 */
  maxNumberOfSourcePickingPositions: number;
  /** @format int32 */
  minimumRouteValue: number;
}
export interface ScopeEntityConfigurationResponseCollectionResponse {
  messages?: string[] | null;
  data: ScopeEntityConfigurationResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface ScopeOverviewResponse {
  /** @format int32 */
  scopeId: number;
  scopeSourceTypeId: ScopeSourceType;
  name: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  archivedAt?: string | null;
  isArchived: boolean;
  isShared: boolean;
  /** @format int32 */
  sectionCount: number;
}
export interface ScopeOverviewResponseCollectionResponse {
  messages?: string[] | null;
  data: ScopeOverviewResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface ScopeResolvedSkuCountResponse {
  /** @format int32 */
  count: number;
}
export interface ScopeResolvedSkuCountResponseDataResponse {
  messages?: string[] | null;
  data: ScopeResolvedSkuCountResponse;
}
export interface ScopeResolvedSkuResponse {
  /** @format int32 */
  skuId: number;
  /** @format int64 */
  productId: number;
  /** @format int64 */
  storeId: number;
  /** @format int32 */
  skuClassId: number;
}
export interface ScopeResolvedSkuResponseCollectionResponse {
  messages?: string[] | null;
  data: ScopeResolvedSkuResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface ScopeResponse {
  /** @format int32 */
  scopeId: number;
  scopeSourceTypeId: ScopeSourceType;
  name: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  archivedAt?: string | null;
  isArchived: boolean;
  isShared: boolean;
  sections: ScopeSectionResponse[];
}
export interface ScopeResponseDataResponse {
  messages?: string[] | null;
  data: ScopeResponse;
}
export interface ScopeSectionCreateRequest {
  scopeSectionRuleTypeId: ScopeSectionRuleTypeName;
  scopeSectionRuleModeId: ScopeSectionRuleModeName;
  /** @minItems 1 */
  ids: number[];
}
export interface ScopeSectionRequest {
  /** @minItems 1 */
  rules: ScopeSectionRuleRequest[];
}
export interface ScopeSectionResponse {
  /** @format int32 */
  scopeSectionId: number;
  rules: ScopeSectionRuleResponse[];
}
export interface ScopeSectionResponseDataResponse {
  messages?: string[] | null;
  data: ScopeSectionResponse;
}
export interface ScopeSectionRuleReplaceRequest {
  scopeSectionRuleModeId: ScopeSectionRuleModeName;
  /** @minItems 1 */
  ids: number[];
}
export interface ScopeSectionRuleRequest {
  scopeSectionRuleTypeId: ScopeSectionRuleTypeName;
  scopeSectionRuleModeId: ScopeSectionRuleModeName;
  /** @minItems 1 */
  ids: number[];
}
export interface ScopeSectionRuleResponse {
  /** @format int32 */
  scopeSectionRuleId: number;
  scopeSectionRuleTypeId: ScopeSectionRuleTypeName;
  scopeSectionRuleModeId: ScopeSectionRuleModeName;
  ids: number[];
}
export interface ScopeUpdateRequest {
  name?: string | null;
  isArchived?: boolean | null;
  isShared?: boolean | null;
}
export interface ScopeUpdateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: ScopeUpdateRequest | null;
}
export interface ScopeUsageResponse {
  type: ScopeUsageType;
  /** @format int32 */
  occurrenceId: number;
  aso?: AsoScopeUsageContextResponse | null;
}
export interface ScopeUsageResponseCollectionResponse {
  messages?: string[] | null;
  data: ScopeUsageResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface ScreenContext {
  url?: string | null;
  route?: string | null;
  params?: Record<string, string> | null;
}
export interface ShortTermForecast {
  /** @format int32 */
  shortTermForecastId: number;
  name: string;
  /** @format date */
  historyFrom: string;
  /** @format date */
  historyTo: string;
  /** @format date */
  forecastFrom: string;
  /** @format date */
  forecastTo: string;
  ratiosJson: string;
  shortTermForecastSkuInputs: ShortTermForecastSkuInput[];
  shortTermForecastEntityListInputs: ShortTermForecastEntityListInput[];
  skuShortTermForecasts: SkuShortTermForecast[];
}
export interface ShortTermForecastEntityListInput {
  /** @format int32 */
  shortTermForecastId: number;
  /** @format int32 */
  entityListId: number;
  shortTermForecast: ShortTermForecast;
  entityList: EntityList;
}
export interface ShortTermForecastSkuInput {
  /** @format int32 */
  shortTermForecastId: number;
  /** @format int32 */
  skuId: number;
  shortTermForecast: ShortTermForecast;
  sku: Sku;
}
export interface Sku {
  /** @format int32 */
  skuId: number;
  /** @format int64 */
  productId: number;
  /** @format int64 */
  warehouseId: number;
  /** @format int32 */
  skuClassId: number;
  /** @format int32 */
  availableSupply: number;
  /** @format double */
  stockPrice: number;
  /** @format double */
  salePrice: number;
  /** @format double */
  vat: number;
  /** @format int32 */
  minimalQuantityForRedistribution: number;
  /** @format int32 */
  minimalSetForRedistribution: number;
  /** @format date */
  firstPurchase: string;
  /** @format date */
  lastPurchase: string;
  /** @deprecated */
  isEnabled: boolean;
  isDefaultTarget: boolean;
  papInputSku?: PapInputSku | null;
  product: Product;
  skuClass: SkuClass;
  warehouse: Warehouse;
  definitionForecastCleanups: DefinitionForecastCleanup[];
  forecastJobs: ForecastJob[];
  openPurchaseOrder: OpenPurchaseOrder[];
  sourcePapResultSkuRedistributions: PapResultSkuRedistribution[];
  targetPapResultSkuRedistributions: PapResultSkuRedistribution[];
  sourcePapResultSkuRedistributionIssues: PapResultSkuRedistributionIssue[];
  targetPapResultSkuRedistributionIssues: PapResultSkuRedistributionIssue[];
  plannedOrders: PlannedOrder[];
  entityListRequestItems: EntityListRequestItem[];
  skuForecasts: SkuForecast[];
  incrementImportSkus: IncrementImportSku[];
  shortTermForecastSkuInputs: ShortTermForecastSkuInput[];
  skuShortTermForecasts: SkuShortTermForecast[];
  sourcePapAuditLogs: PapAuditLog[];
  sourcePapPerformances: PapPerformance[];
  skuPotentials: SkuPotential[];
  skuPromos: SkuPromo[];
  sourceSkuExecutions: SkuExecution[];
  sourceSkuExecutionFulfillmentHeuristics: SkuExecutionFulfillmentHeuristic[];
  sourceSkuExecutionHeuristics: SkuExecutionHeuristic[];
  sourceSkuRedistributions: SkuRedistribution[];
  sourceSkuRedistributionsExpanded: SkuRedistributionExpanded[];
  targetPapAuditLogs: PapAuditLog[];
  targetPapPerformances: PapPerformance[];
  targetSkuExecutions: SkuExecution[];
  targetSkuExecutionFulfillmentHeuristics: SkuExecutionFulfillmentHeuristic[];
  targetSkuRedistributions: SkuRedistribution[];
  targetSkuRedistributionsExpanded: SkuRedistributionExpanded[];
  targetListItems: TargetListItem[];
}
export interface SkuAttributeResponse {
  type: AttributeDefinitionType;
  value: string;
}
export interface SkuAttributeResponseCollectionResponse {
  messages?: string[] | null;
  data: SkuAttributeResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface SkuAvailableSupplyResponse {
  /** @format int32 */
  skuId: number;
  /** @format date */
  dateFrom: string;
  /** @format date */
  dateTo?: string | null;
  /** @format int32 */
  availableSupply: number;
}
export interface SkuAvailableSupplyResponseCollectionResponse {
  messages?: string[] | null;
  data: SkuAvailableSupplyResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface SkuBaseResponse {
  /** @format int32 */
  skuId: number;
  /** @format int64 */
  storeId: number;
  /** @format int64 */
  productId: number;
  isEnabled: boolean;
  /** @format int32 */
  skuClassId: number;
  store?: StoreResponse | null;
  product?: ProductResponse | null;
  skuClass?: SkuClassResponse | null;
  /** @format int32 */
  availableSupply: number;
  /** @format double */
  stockPrice: number;
  /** @format double */
  salePrice: number;
  /** @format double */
  vat: number;
  /** @format int32 */
  minimalQuantityForRedistribution: number;
  /** @format int32 */
  minimalSetForRedistribution: number;
  /** @format date-time */
  firstPurchase: string;
  /** @format date-time */
  lastPurchase: string;
  useAsSource?: boolean | null;
  isDefaultTarget?: boolean | null;
  isForced: boolean;
}
export interface SkuCalculationBaseConfigurationResponse {
  calculation: CalculationWithRelatedEntitiesResponse;
  /** @format int32 */
  skuId: number;
  skuType: SkuType;
  isForced: boolean;
  /** @format int32 */
  outgoingQuantity: number;
  /** @format int32 */
  incomingQuantity: number;
  targetList?: TargetListSkuResponse | null;
  skuClass?: SkuClassResponse | null;
  categories: CategoryResponse[];
  fieldConfigurations?: SkuFieldConfigurationResponse[] | null;
  sourceMinLayerLists?: EntityListSkuResponse[] | null;
  targetMinLayerLists?: EntityListSkuResponse[] | null;
  forecast?: SkuForecastResponse | null;
  skuDescription?: SkuDescriptionResponse | null;
}
export interface SkuCalculationConfigurationResponse {
  calculation: CalculationWithRelatedEntitiesResponse;
  /** @format int32 */
  skuId: number;
  skuType: SkuType;
  isForced: boolean;
  /** @format int32 */
  outgoingQuantity: number;
  /** @format int32 */
  incomingQuantity: number;
  targetList?: TargetListSkuResponse | null;
  skuClass?: SkuClassResponse | null;
  categories: CategoryResponse[];
  fieldConfigurations?: SkuFieldConfigurationResponse[] | null;
  sourceMinLayerLists?: EntityListSkuResponse[] | null;
  targetMinLayerLists?: EntityListSkuResponse[] | null;
  forecast?: SkuForecastResponse | null;
  skuDescription?: SkuDescriptionResponse | null;
  subordinateCalculationSkus?: SkuCalculationBaseConfigurationResponse[] | null;
  productGroups: ProductGroupResponse[];
}
export interface SkuCalculationConfigurationResponseDataResponse {
  messages?: string[] | null;
  data: SkuCalculationConfigurationResponse;
}
export interface SkuClass {
  /** @format int32 */
  skuClassId: number;
  name: string;
  customerSkuClassId?: string | null;
  skus: Sku[];
  skuClassAttributeValues: SkuClassAttributeValue[];
  skuClassConfigurations: SkuClassConfiguration[];
  sourceSkuRedistributionsExpanded: SkuRedistributionExpanded[];
  targetSkuRedistributionsExpanded: SkuRedistributionExpanded[];
}
export interface SkuClassAttributeValue {
  /** @format int32 */
  attributeValueId: number;
  /** @format int32 */
  skuClassId: number;
  isUiVisible: boolean;
  attributeValue: AttributeValue;
  skuClass: SkuClass;
}
export interface SkuClassConfiguration {
  /** @format int32 */
  skuClassConfigurationId: number;
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  skuClassId: number;
  isEnabled: boolean;
  useAsSource: boolean;
  useAsTarget: boolean;
  calculation: Calculation;
  skuClass: SkuClass;
}
export interface SkuClassConfigurationRequest {
  isEnabled?: boolean | null;
  useAsSource?: boolean | null;
  useAsTarget?: boolean | null;
}
export interface SkuClassConfigurationRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: SkuClassConfigurationRequest | null;
}
export interface SkuClassConfigurationResponse {
  skuClass?: SkuClassResponse | null;
  isEnabled: boolean;
  useAsSource: boolean;
  useAsTarget: boolean;
}
export interface SkuClassConfigurationResponseCollectionResponse {
  messages?: string[] | null;
  data: SkuClassConfigurationResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface SkuClassConfigurationResponseDataResponse {
  messages?: string[] | null;
  data: SkuClassConfigurationResponse;
}
export interface SkuClassResponse {
  /** @format int32 */
  id: number;
  name: string;
  customerSkuClassId?: string | null;
}
export interface SkuClassResponseCollectionResponse {
  messages?: string[] | null;
  data: SkuClassResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface SkuDescriptionResponse {
  /** @format int32 */
  id: number;
  value: string;
}
export interface SkuDescriptionResponseCollectionResponse {
  messages?: string[] | null;
  data: SkuDescriptionResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface SkuDescriptionResponseDataResponse {
  messages?: string[] | null;
  data: SkuDescriptionResponse;
}
export interface SkuExecution {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  sourceSkuId: number;
  /** @format int32 */
  targetSkuId: number;
  executionTypeId: ExecutionType;
  /** @format int32 */
  quantityShipped?: number | null;
  /** @format date */
  dateShipped?: string | null;
  /** @format int32 */
  quantityDelivered?: number | null;
  /** @format date */
  dateDelivered?: string | null;
  calculation: Calculation;
  sourceSku: Sku;
  targetSku: Sku;
}
export interface SkuExecutionFulfillmentHeuristic {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  sourceSkuId: number;
  /** @format int32 */
  targetSkuId: number;
  /** @format int32 */
  quantity: number;
  isEstimated: boolean;
  isDelivered: boolean;
  calculation: Calculation;
  sourceSku: Sku;
  targetSku: Sku;
}
export interface SkuExecutionHeuristic {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  executionAttributeValueId: number;
  /** @format int32 */
  sourceSkuId: number;
  /** @format int32 */
  quantity: number;
  calculation: Calculation;
  executionAttributeValue: AttributeValue;
  sourceSku: Sku;
}
export interface SkuFieldConfigurationResponse {
  fieldType: ConfigurationFieldType;
  value: string;
}
export interface SkuForecast {
  /** @format int32 */
  forecastId: number;
  /** @format int32 */
  skuId: number;
  cumulativeQuantityMinJson?: string | null;
  cumulativeQuantityMaxJson?: string | null;
  computeMethodJson?: string | null;
  additionalAttributesJson?: string | null;
  cumulativeQuantityMiddleJson?: string | null;
  forecast: Forecast;
  sku: Sku;
}
export interface SkuForecastResponse {
  computeMethodJson?: string | null;
  additionalAttributesJson?: string | null;
}
export interface SkuPotential {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  skuId: number;
  skuTypeId: SkuType;
  useAsSource: boolean;
  useAsTarget: boolean;
  isForced: boolean;
  /** @format int32 */
  availableSupply: number;
  isDebug: boolean;
  /** @format int32 */
  psScope: number;
  /** @format int32 */
  psMonthsFromFirstPurchase: number;
  /** @format int32 */
  psMonthsFromLastPurchase: number;
  /** @format int32 */
  psMinProductPurchasePrice: number;
  /** @format int32 */
  psMinRowValue: number;
  /** @format int32 */
  psForecast: number;
  /** @format int32 */
  psMinimalQuantityForRedistribution: number;
  /** @format int32 */
  psMinimalSetForRedistribution: number;
  /** @format int32 */
  psMinLayerList: number;
  /** @format int32 */
  psUrgentForecast: number;
  /** @format int32 */
  psBufferForecast: number;
  /** @format int32 */
  psForcedScope: number;
  /** @format int32 */
  psForcedMinProductPurchasePrice: number;
  /** @format int32 */
  psForcedMonthsFromLastPurchase: number;
  /** @format int32 */
  psFinal: number;
  /** @format int32 */
  psUrgentFinal: number;
  /** @format int32 */
  psBufferFinal: number;
  /** @format int32 */
  psForcedFinal: number;
  /** @format int32 */
  psMinimalQuantityForRedistributionForced: number;
  /** @format int32 */
  psMinimalSetForRedistributionForced: number;
  /** @format int32 */
  sourceBufferForecastQuantity: number;
  /** @format int32 */
  sourceForecastQuantity: number;
  /** @format int32 */
  sourceUrgentForecastQuantity: number;
  /** @format int32 */
  sourceMinLayerListQuantity: number;
  sourceMinLayerLists?: string | null;
  /** @format int32 */
  sourceMinRowValue: number;
  useStrictSets: boolean;
  useSmartSets: boolean;
  useMinRedistributionQuantity: boolean;
  allowBreakSetsMinQuantitiesWhenGoingToZero: boolean;
  useStrictSetsForced: boolean;
  useSmartSetsForced: boolean;
  useMinRedistributionQuantityForced: boolean;
  allowBreakSetsMinQuantitiesWhenGoingToZeroForced: boolean;
  /** @format int32 */
  ptForecast: number;
  /** @format int32 */
  ptUrgentForecast: number;
  /** @format int32 */
  ptBufferForecast: number;
  /** @format int32 */
  ptRequestList: number;
  /** @format int32 */
  ptMinLayerList: number;
  /** @format int32 */
  ptFinal: number;
  /** @format int32 */
  ptUrgentFinal: number;
  /** @format int32 */
  ptBufferFinal: number;
  /** @format int32 */
  targetBufferForecastQuantity: number;
  /** @format int32 */
  targetForecastQuantity: number;
  /** @format int32 */
  targetUrgentForecastQuantity: number;
  /** @format int32 */
  openPurchaseOrdersQuantity: number;
  targetMinLayerLists?: string | null;
  /** @format int32 */
  targetMinLayerListQuantity: number;
  /** @format int32 */
  requestListQuantity: number;
  targetForcingLevelTypeId?: ForcingLevelType | null;
  /** @format int32 */
  hfmq: number;
  /** @format int32 */
  hfmqForced: number;
  /** @format int32 */
  outgoingQuantity: number;
  /** @format int32 */
  incomingQuantity: number;
  /** @format int32 */
  sourceIntegrationMinLayerListQuantity: number;
  /** @format int32 */
  targetIntegrationMinLayerListQuantity: number;
  calculation: Calculation;
  sku: Sku;
}
export interface SkuPromo {
  /** @format int32 */
  skuId: number;
  /** @format int32 */
  promoTypeId: number;
  /** @format date */
  dateFrom: string;
  /** @format date */
  dateTo: string;
  useForForecast: boolean;
  useForExcludeList: boolean;
  /** @format double */
  promoPrice?: number | null;
  /** @format int32 */
  totalEstimate?: number | null;
  sku: Sku;
  promoType: PromoType;
}
export interface SkuRedistribution {
  /** @format int32 */
  calculationId: number;
  /** @format int64 */
  productId: number;
  /** @format int64 */
  sourceWarehouseId: number;
  /** @format int64 */
  targetWarehouseId: number;
  /** @format int32 */
  sourceSkuId: number;
  /** @format int32 */
  targetSkuId: number;
  /** @format int32 */
  quantityProposed: number;
  /** @format int32 */
  quantity: number;
  /** @format double */
  score: number;
  description?: string | null;
  calculation: Calculation;
  product: Product;
  sourceSku: Sku;
  targetSku: Sku;
  sourceWarehouse: Warehouse;
  targetWarehouse: Warehouse;
}
export interface SkuRedistributionBackup {
  /** @format int32 */
  calculationId: number;
  /** @format int64 */
  productId: number;
  /** @format int64 */
  sourceWarehouseId: number;
  /** @format int64 */
  targetWarehouseId: number;
  /** @format int32 */
  sourceSkuId: number;
  /** @format int32 */
  targetSkuId: number;
  /** @format int32 */
  quantityProposed: number;
  /** @format int32 */
  quantity: number;
  /** @format double */
  score: number;
  description?: string | null;
  calculation: Calculation;
}
export interface SkuRedistributionChangelog {
  /** @format int64 */
  skuRedistributionChangelogId: number;
  /** @format int32 */
  calculationId: number;
  /** @format date-time */
  createdAt: string;
  skuRedistributionChangeType: SkuRedistributionChangeType;
  description?: string | null;
  payload?: string | null;
  identityUserId?: string | null;
  calculation: Calculation;
}
export interface SkuRedistributionChangelogCollectionResponse {
  messages?: string[] | null;
  data: SkuRedistributionChangelog[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface SkuRedistributionExpanded {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  sourceSkuId: number;
  /** @format int32 */
  targetSkuId: number;
  /** @format int64 */
  productId: number;
  /** @format int64 */
  categoryId: number;
  /** @format int32 */
  brandId: number;
  /** @format int32 */
  departmentId: number;
  /** @format int32 */
  sourceRegionId: number;
  /** @format int32 */
  targetRegionId: number;
  /** @format int64 */
  sourceWarehouseId: number;
  /** @format int64 */
  targetWarehouseId: number;
  sourceSkuTypeId: SkuType;
  targetSkuTypeId: SkuType;
  /** @format int32 */
  sourceSkuClassId: number;
  /** @format int32 */
  targetSkuClassId: number;
  /** @format int32 */
  quantityProposed: number;
  /** @format int32 */
  quantity: number;
  /** @format double */
  value: number;
  description?: string | null;
  /** @format int32 */
  sourceAvailableSupply: number;
  /** @format int32 */
  targetAvailableSupply: number;
  /** @format double */
  sourceStockPrice: number;
  /** @format double */
  targetStockPrice: number;
  /** @format int32 */
  sourceOpenPurchaseOrdersQuantity: number;
  /** @format int32 */
  targetOpenPurchaseOrdersQuantity: number;
  /** @format int32 */
  totalQuantityFromSource: number;
  /** @format int32 */
  totalQuantityToTarget: number;
  /** @format int32 */
  totalRouteFromSource: number;
  /** @format int32 */
  totalRouteToTarget: number;
  isSendToStockout: boolean;
  isSourceForced: boolean;
  /** @format int32 */
  sourceBufferForecastQuantity: number;
  /** @format int32 */
  sourceForecastQuantity: number;
  /** @format int32 */
  sourceUrgentForecastQuantity: number;
  /** @format int32 */
  sourceMinLayerListQuantity: number;
  /** @format int32 */
  targetBufferForecastQuantity: number;
  /** @format int32 */
  targetForecastQuantity: number;
  /** @format int32 */
  targetUrgentForecastQuantity: number;
  /** @format int32 */
  targetMinLayerListQuantity: number;
  /** @format int32 */
  requestListQuantity: number;
  calculation: Calculation;
  brand: Brand;
  category: Category;
  department: Department;
  product: Product;
  sourceRegion: Region;
  sourceSku: Sku;
  sourceWarehouse: Warehouse;
  targetRegion: Region;
  targetSku: Sku;
  targetWarehouse: Warehouse;
  sourceSkuClass: SkuClass;
  targetSkuClass: SkuClass;
}
export interface SkuRedistributionResponse {
  product: ProductResponse;
  department: DepartmentResponse;
  brand: BrandResponse;
  sourceStore: StoreResponse;
  targetStore: StoreResponse;
  sourceRegion: RegionResponse;
  targetRegion: RegionResponse;
  sourceSku: SkuRedistributionSkuResponse;
  targetSku: SkuRedistributionSkuResponse;
  /** @format int32 */
  quantity: number;
  /** @format int32 */
  quantityProposed: number;
  /** @format double */
  value: number;
  description?: string | null;
  /** @format int32 */
  totalRouteFromSource: number;
  /** @format int32 */
  totalRouteToTarget: number;
  /** @format int32 */
  totalQuantityFromSourceSku: number;
  /** @format int32 */
  totalQuantityToTargetSku: number;
  /** @format int32 */
  totalAvailableSupplyOfTargetSku: number;
  /** @format int32 */
  totalAvailableSupplyOfSourceSku: number;
  isSourceForced: boolean;
  isSendToStockout: boolean;
}
export interface SkuRedistributionResponseCollectionResponse {
  messages?: string[] | null;
  data: SkuRedistributionResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface SkuRedistributionSkuResponse {
  /** @format int32 */
  skuId: number;
  skuTypeId: SkuType;
  /** @format int32 */
  skuClassId: number;
  /**
   * Null when the calculation has no quintile for this SKU; it sorts after every quintile.
   * @format int32
   */
  brandQuintile?: number | null;
}
export interface SkuResponse {
  /** @format int32 */
  skuId: number;
  /** @format int64 */
  storeId: number;
  /** @format int64 */
  productId: number;
  isEnabled: boolean;
  /** @format int32 */
  skuClassId: number;
  store?: StoreResponse | null;
  product?: ProductResponse | null;
  skuClass?: SkuClassResponse | null;
  /** @format int32 */
  availableSupply: number;
  /** @format double */
  stockPrice: number;
  /** @format double */
  salePrice: number;
  /** @format double */
  vat: number;
  /** @format int32 */
  minimalQuantityForRedistribution: number;
  /** @format int32 */
  minimalSetForRedistribution: number;
  /** @format date-time */
  firstPurchase: string;
  /** @format date-time */
  lastPurchase: string;
  useAsSource?: boolean | null;
  isDefaultTarget?: boolean | null;
  isForced: boolean;
  attributes?: SkuAttributeResponse[] | null;
  description?: SkuDescriptionResponse | null;
}
export interface SkuResponseCollectionResponse {
  messages?: string[] | null;
  data: SkuResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface SkuResponseDataResponse {
  messages?: string[] | null;
  data: SkuResponse;
}
export interface SkuShortTermForecast {
  /** @format int32 */
  shortTermForecastId: number;
  /** @format int32 */
  skuId: number;
  /** @format double */
  quantity: number;
  /** @format int32 */
  safetyStock?: number | null;
  additionalDataJson?: string | null;
  shortTermForecast: ShortTermForecast;
  sku: Sku;
}
export interface SkuSizeResponse {
  /** @format int32 */
  skuId: number;
  /** @format int64 */
  storeId: number;
  /** @format int64 */
  productId: number;
  isEnabled: boolean;
  productSize?: string | null;
  /** @format int32 */
  availableSupply: number;
  /** @format int32 */
  frequency6Month: number;
  /** @format int32 */
  saleQuantityTotal: number;
  /** @format double */
  saleValueTotal: number;
  /** @format date */
  firstPurchase: string;
  /** @format date */
  lastPurchase: string;
  store: StoreResponse;
  product: ProductResponse;
}
export interface SkuSizeResponseCollectionResponse {
  messages?: string[] | null;
  data: SkuSizeResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface Sorting {
  fieldName: string;
  direction?: SortDirection;
}
export interface SourceStoreEvaluationRatesResponse {
  store: StoreResponse;
  department?: DepartmentResponse | null;
  evaluationSummary: RoutesEvaluationRatesResponse;
}
export interface SourceStoreEvaluationRatesResponseCollectionResponse {
  messages?: string[] | null;
  data: SourceStoreEvaluationRatesResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface StoreCategoryBrandPerformance {
  /** @format int64 */
  storeId: number;
  /** @format int32 */
  brandId: number;
  /** @format int64 */
  categoryId: number;
  /** @format double */
  revenue: number;
  /** @format double */
  normalizedRevenue: number;
  /** @format int32 */
  brandQuintile?: number | null;
  isSignificant: boolean;
  store: Warehouse;
  brand: Brand;
  category: Category;
}
export interface StoreClosure {
  /** @format int32 */
  storeClosureId: number;
  /** @format int64 */
  storeId: number;
  /** @format date */
  dateFrom: string;
  /** @format date */
  dateTo: string;
  store: Warehouse;
}
export interface StoreDepartmentAttributeValue {
  /** @format int32 */
  attributeValueId: number;
  /** @format int64 */
  storeId: number;
  /** @format int32 */
  departmentId: number;
  /** @format int32 */
  regionId: number;
  /** @format int32 */
  storeTypeId: number;
  isUiVisible: boolean;
  /** @format date */
  firstSaleOn?: string | null;
  /** @format date */
  lastSaleOn?: string | null;
  attributeValue: AttributeValue;
  store: Warehouse;
  region: Region;
  storeType: WarehouseType;
  department: Department;
}
export interface StorePerformance {
  /** @format int64 */
  storeId: number;
  /** @format double */
  revenue: number;
  /** @format int32 */
  openDaysInWindow: number;
  /** @format double */
  normalizedRevenue: number;
  /** @format int32 */
  storeDecile?: number | null;
  storeRankingStatusId: StoreRankingStatus;
  store: Warehouse;
}
export interface StorePerformanceProductKey {
  /** @format int64 */
  productId: number;
  /** @format int64 */
  categoryId: number;
  /** @format int32 */
  brandId: number;
  product: Product;
  brand: Brand;
  category: Category;
}
export interface StorePickingInsightsResponse {
  /**
   * The number of picking positions picked
   * @format int32
   */
  pickingPositionCount: number;
  /**
   * Mean picking time per SKU based on all durations. Not Filterable.
   * @format int32
   */
  meanPickingTime: number;
  /**
   * Mean picking time per SKU excluding outliers. Not Filterable.
   * @format int32
   */
  trimmedMeanPickingTime: number;
  /**
   * Total picking time for all SKUs excluding outliers. Not Filterable.
   * @format int32
   */
  trimmedPickingTime: number;
  /**
   * Sum of all durations. Not Filterable.
   * @format int32
   */
  totalPickingTime: number;
  /**
   * Median picking time based on all durations. Not Filterable.
   * @format double
   */
  medianPickingTime: number;
  /** @format double */
  trimmedMedianPickingTime: number;
  store: StoreResponse;
  /** @format int32 */
  executedQuantity: number;
  /** @format double */
  executedValue: number;
}
export interface StorePickingInsightsResponseCollectionResponse {
  messages?: string[] | null;
  data: StorePickingInsightsResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface StoreResponse {
  /** @format int64 */
  id: number;
  name: string;
  code?: string | null;
  customerStoreId?: string | null;
  storeType?: StoreTypeResponse | null;
  region?: RegionResponse | null;
  /** @format date */
  lastSaleOn?: string | null;
  /** @format date */
  firstSaleOn?: string | null;
  /**
   * Null means the store was never ranked, which is not the same as being ranked weakest:
   * decile 1 is the weakest bucket, so an unranked store must not sort below it.
   * @format int32
   */
  storeDecile?: number | null;
}
export interface StoreResponseCollectionResponse {
  messages?: string[] | null;
  data: StoreResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface StoreScheduleCreateRequest {
  /**
   * @format int64
   * @min 0
   * @exclusiveMin true
   */
  storeId: number;
  /** @format date */
  cannotSendFrom?: string | null;
  /** @format date */
  cannotSendTo?: string | null;
  /** @format date */
  cannotReceiveFrom?: string | null;
  /** @format date */
  cannotReceiveTo?: string | null;
  /** @maxLength 1024 */
  note?: string | null;
}
export interface StoreScheduleCreateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: StoreScheduleCreateRequest | null;
}
/** One register record as a template or calculation follows it; for a calculation, read from its snapshot, ExcludedUntil and EvaluatedOn are null. */
export interface StoreScheduleExclusionResponse {
  /** @format int32 */
  storeScheduleId: number;
  store: StoreResponse;
  isExcludedFromSending: boolean;
  isExcludedFromReceiving: boolean;
  /** @format date */
  excludedUntil?: string | null;
  isEnabled: boolean;
  /** @format date */
  evaluatedOn?: string | null;
}
export interface StoreScheduleExclusionResponseCollectionResponse {
  messages?: string[] | null;
  data: StoreScheduleExclusionResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface StoreScheduleExclusionUpdateRequest {
  /** Whether the exclusion applies to this template: false stores an opt-out, true removes it. */
  isEnabled: boolean;
}
export interface StoreScheduleResponse {
  /** @format int32 */
  storeScheduleId: number;
  store: StoreResponse;
  /** @format date */
  cannotSendFrom?: string | null;
  /** @format date */
  cannotSendTo?: string | null;
  /** @format date */
  cannotReceiveFrom?: string | null;
  /** @format date */
  cannotReceiveTo?: string | null;
  note?: string | null;
  /** @format date-time */
  createdAt: string;
  isArchived: boolean;
  /** @format date-time */
  archivedAt?: string | null;
  /** From the dates on EvaluatedOn, so it is right even before the archiving job has run. */
  isActive: boolean;
  isInEffect: boolean;
  /**
   * The business date IsActive and IsInEffect were evaluated on.
   * @format date
   */
  evaluatedOn: string;
}
export interface StoreScheduleResponseCollectionResponse {
  messages?: string[] | null;
  data: StoreScheduleResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface StoreScheduleResponseDataResponse {
  messages?: string[] | null;
  data: StoreScheduleResponse;
}
export interface StoreScheduleStoreExclusionResponse {
  store: StoreResponse;
  isExcludedFromSending: boolean;
  isExcludedFromReceiving: boolean;
  isCompletelyExcluded: boolean;
  /**
   * Null for a calculation, whose frozen rows carry no periods.
   * @format date
   */
  excludedUntil?: string | null;
}
export interface StoreScheduleStoreExclusionResponseCollectionResponse {
  messages?: string[] | null;
  data: StoreScheduleStoreExclusionResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface StoreScheduleUpdateRequest {
  /**
   * @format int64
   * @min 0
   * @exclusiveMin true
   */
  storeId: number;
  /** @format date */
  cannotSendFrom?: string | null;
  /** @format date */
  cannotSendTo?: string | null;
  /** @format date */
  cannotReceiveFrom?: string | null;
  /** @format date */
  cannotReceiveTo?: string | null;
  /** @maxLength 1024 */
  note?: string | null;
}
export interface StoreScheduleUpdateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: StoreScheduleUpdateRequest | null;
}
export interface StoreTypeResponse {
  /** @format int64 */
  id: number;
  name: string;
  customerWarehouseTypeId?: string | null;
}
export interface StoreTypeResponseCollectionResponse {
  messages?: string[] | null;
  data: StoreTypeResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface TargetList {
  /** @format int32 */
  targetListId: number;
  customerTargetListId?: string | null;
  name?: string | null;
  description?: string | null;
  /** @format int32 */
  currentTargetListVersionId?: number | null;
  isArchived: boolean;
  /** @format date-time */
  softDeletedAt?: string | null;
  currentTargetListVersion: TargetListVersion;
  targetListVersions: TargetListVersion[];
}
export interface TargetListConfiguration {
  /** @format int32 */
  calculationId: number;
  /** @format int32 */
  targetListVersionId: number;
  calculation: Calculation;
  targetListVersion: TargetListVersion;
}
export interface TargetListItem {
  /** @format int32 */
  targetListVersionId: number;
  /** @format int32 */
  skuId: number;
  /** @format int32 */
  quantity: number;
  targetListVersion: TargetListVersion;
  sku: Sku;
}
export interface TargetListSkuResponse {
  /** @format int32 */
  targetListId: number;
  /** @format int32 */
  version: number;
  name?: string | null;
  /** @format int32 */
  quantity?: number | null;
  isArchived: boolean;
  isDataDeleted: boolean;
  /** @format date-time */
  dataDeletedAt?: string | null;
}
export interface TargetListVersion {
  /** @format int32 */
  targetListVersionId: number;
  /** @format int32 */
  targetListId: number;
  /** @format date-time */
  createdAt: string;
  /** @format int32 */
  versionNumber: number;
  isLast: boolean;
  targetList: TargetList;
  targetListConfigurations: TargetListConfiguration[];
  targetListItems: TargetListItem[];
}
export interface TargetStoreEvaluationRatesResponse {
  store: StoreResponse;
  department?: DepartmentResponse | null;
  evaluationSummary: RoutesByTargetStoreEvaluationRatesResponse;
  packingPictures?: PackingPictureResponse[] | null;
}
export interface TargetStoreEvaluationRatesResponseCollectionResponse {
  messages?: string[] | null;
  data: TargetStoreEvaluationRatesResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface TemplateRequest {
  /** @format int32 */
  originalTemplateId: number;
  title?: string | null;
  description?: string | null;
}
export interface TemplateResponse {
  /** @format int32 */
  id: number;
  status: CalculationStatus;
  calculationFlags: CalculationFlags;
  title: string;
  description?: string | null;
  /** @format date-time */
  created: string;
  /** @format date */
  applicationDate: string;
  owner?: UserResponse | null;
  /** @format int64 */
  rootCategoryId: number;
  isLocked: boolean;
}
export interface TemplateUpdateRequest {
  title?: string | null;
  description?: string | null;
  isLocked?: boolean | null;
}
export interface TemplateUpdateRequestJsonMerge {
  mergeOperationType: ApiOperationType;
  rawJson: string;
  data?: TemplateUpdateRequest | null;
}
export interface TemplateWithRelatedResponse {
  /** @format int32 */
  id: number;
  status: CalculationStatus;
  calculationFlags: CalculationFlags;
  title: string;
  description?: string | null;
  /** @format date-time */
  created: string;
  /** @format date */
  applicationDate: string;
  owner?: UserResponse | null;
  /** @format int64 */
  rootCategoryId: number;
  isLocked: boolean;
  overlappingCalculations?: CalculationResponse[] | null;
}
export interface TemplateWithRelatedResponseCollectionResponse {
  messages?: string[] | null;
  data: TemplateWithRelatedResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface TemplateWithRelatedResponseDataResponse {
  messages?: string[] | null;
  data: TemplateWithRelatedResponse;
}
export interface TransactionValueResponse {
  overviewValueType: OverviewValueType;
  transactionOverviewType: TransactionOverviewType;
  /** @format double */
  value: number;
}
export interface UserResponse {
  id: string;
  fullName: string;
  email: string;
  isSuperUser: boolean;
  isConfirmed: boolean;
  isActive: boolean;
  allowedAuthenticationMethodIds: AuthenticationMethod;
}
export interface ValidationProblemResponse {
  code: ValidationProblemCode;
  severity: ProblemSeverity;
  /** @minLength 1 */
  message: string;
  target?: ProblemTarget | null;
  path?: string | null;
  related?: ProblemRelatedEntity[] | null;
  data?: Record<string, string> | null;
}
export interface ValidationProblemResponseCollectionResponse {
  messages?: string[] | null;
  data: ValidationProblemResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface Warehouse {
  /** @format int64 */
  warehouseId: number;
  /** @format int32 */
  warehouseTypeId: number;
  /** @format int32 */
  regionId: number;
  customerWarehouseId?: string | null;
  name?: string | null;
  code?: string | null;
  /** @format date */
  lastSaleDate?: string | null;
  papInputStore?: PapInputStore | null;
  region: Region;
  storePerformance?: StorePerformance | null;
  warehouseType: WarehouseType;
  configurationRuleScopeStores: ConfigurationRuleScopeStore[];
  definitionForecastCleanups: DefinitionForecastCleanup[];
  sourceSkuRedistributions: SkuRedistribution[];
  sourceSkuRedistributionsExpanded: SkuRedistributionExpanded[];
  skus: Sku[];
  storeCategoryBrandPerformances: StoreCategoryBrandPerformance[];
  storeClosures: StoreClosure[];
  storeDepartmentAttributeValues: StoreDepartmentAttributeValue[];
  asoScenarioStoreTiers: AsoScenarioStoreTier[];
  sourcePapAuditLogs: PapAuditLog[];
  papInputStores: PapInputStore[];
  sourcePapResultRoutes: PapResultRoute[];
  sourcePapPackingPictures: PapPackingPicture[];
  sourceStoreRouteExecutions: RouteExecution[];
  targetPapAuditLogs: PapAuditLog[];
  targetPapResultRoutes: PapResultRoute[];
  targetPapPackingPictures: PapPackingPicture[];
  targetSkuRedistributionsExpanded: SkuRedistributionExpanded[];
  targetSkuRedistributions: SkuRedistribution[];
  targetStoreRouteExecutions: RouteExecution[];
}
export interface WarehouseResponse {
  /** @format int64 */
  id: number;
  name: string;
  code?: string | null;
  customerWarehouseId?: string | null;
  warehouseType?: WarehouseTypeResponse | null;
  region?: RegionResponse | null;
  /** @format date-time */
  lastSaleDate?: string | null;
  /**
   * Null means the store was never ranked, which is not the same as being ranked weakest:
   * decile 1 is the weakest bucket, so an unranked store must not sort below it.
   * @format int32
   */
  storeDecile?: number | null;
}
export interface WarehouseResponseCollectionResponse {
  messages?: string[] | null;
  data: WarehouseResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface WarehouseType {
  /** @format int32 */
  warehouseTypeId: number;
  customerWarehouseTypeId?: string | null;
  name: string;
  configurationRuleScopeStoreTypes: ConfigurationRuleScopeStoreType[];
  warehouses: Warehouse[];
}
export interface WarehouseTypeResponse {
  /** @format int64 */
  id: number;
  name: string;
  customerWarehouseTypeId?: string | null;
}
export interface WarehouseTypeResponseCollectionResponse {
  messages?: string[] | null;
  data: WarehouseTypeResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
/** Credentials details for YPick mobile application. */
export interface YPickStoreCredentialsResponse {
  /**
   * Store to which the QR Code is assigned
   * @format int64
   */
  storeId: number;
  /**
   * Department within store to which the QR Code is assigned
   * @format int32
   */
  departmentId: number;
  /** Name of the file with the QR Code */
  qrCodeFileName: string;
}
export interface YPickStoreCredentialsResponseCollectionResponse {
  messages?: string[] | null;
  data: YPickStoreCredentialsResponse[];
  /** @format int32 */
  totalCount?: number | null;
}
export interface YbotAvailabilityResponse {
  enabled: boolean;
  /** @format int32 */
  turnTimeoutSeconds: number;
}
export interface YbotAvailabilityResponseDataResponse {
  messages?: string[] | null;
  data: YbotAvailabilityResponse;
}
export interface YdistriDevsMcpStatusResponse {
  /** What `claude mcp get <name>` answers. */
  status: YdistriDevsMcpStatus;
}
export interface YdistriDevsMcpStatusResponseDataResponse {
  messages?: string[] | null;
  data: YdistriDevsMcpStatusResponse;
}
